(function () {
    'use strict';

    const {
      setScrollbarWidth
    } = window.PoleneLibs.Utils;
    document.addEventListener('DOMContentLoaded', () => {
      const {
        hydrateComponents
      } = window.PoleneLibs.Hydration;
      (async () => {
        const components = [Promise.resolve().then(function () { return imageLoaded$1; }), Promise.resolve().then(function () { return parallax$1; }), Promise.resolve().then(function () { return keyboardNavigation; }), Promise.resolve().then(function () { return dropdown$1; }), Promise.resolve().then(function () { return reveal$1; }), Promise.resolve().then(function () { return wishlist$1; }), Promise.resolve().then(function () { return countrySelectorModal$1; }), Promise.resolve().then(function () { return eventForm$1; }), Promise.resolve().then(function () { return componentBisForm$1; }), Promise.resolve().then(function () { return comingSoonForm$1; }), Promise.resolve().then(function () { return localizationForm$1; }), Promise.resolve().then(function () { return handleNewsletterEvent; }), Promise.resolve().then(function () { return componentCarousel$1; }), Promise.resolve().then(function () { return componentModal$1; }), Promise.resolve().then(function () { return componentProductCard$1; }), Promise.resolve().then(function () { return componentProductForm$1; }), Promise.resolve().then(function () { return componentDrawer$1; }), Promise.resolve().then(function () { return componentNewsletterSignup$1; }), Promise.resolve().then(function () { return componentAccordion$1; }), Promise.resolve().then(function () { return componentTabs$1; }), Promise.resolve().then(function () { return componentAddToWishlist$1; }), Promise.resolve().then(function () { return componentSnackbar$1; }), Promise.resolve().then(function () { return componentQuickAdd$1; }), Promise.resolve().then(function () { return componentCartNotification$1; }), Promise.resolve().then(function () { return cartBindingPing$1; }), Promise.resolve().then(function () { return klaviyoIdentityResolve$1; }), Promise.resolve().then(function () { return sessionReplay$1; }), Promise.resolve().then(function () { return themeBridge$1; }), Promise.resolve().then(function () { return componentSeeMore$1; }), Promise.resolve().then(function () { return themeSearchOverlay$1; }), Promise.resolve().then(function () { return wishlistCounter$1; }), Promise.resolve().then(function () { return wishlistGrid$1; }), Promise.resolve().then(function () { return wishlistStateBlock$1; }), Promise.resolve().then(function () { return fragmentCursor$1; }), Promise.resolve().then(function () { return eyesCursor$1; }), Promise.resolve().then(function () { return fragmentOptionSelect$1; }), Promise.resolve().then(function () { return fragmentSearchTrigger$1; }), Promise.resolve().then(function () { return fragmentSubMenu$1; }), Promise.resolve().then(function () { return fragmentVideo$1; }), Promise.resolve().then(function () { return sectionAnnouncementBar$1; }), Promise.resolve().then(function () { return sectionArticleTeaser$1; }), Promise.resolve().then(function () { return componentHeaderMenu$1; }), Promise.resolve().then(function () { return sectionCountdownTeaser$1; }), Promise.resolve().then(function () { return sectionProductRecommendations$1; }), Promise.resolve().then(function () { return sectionWishlistSlider$1; }), Promise.resolve().then(function () { return sectionFeaturedMediaFrieze$1; }), Promise.resolve().then(function () { return sectionStickyTextGallery$1; }), Promise.resolve().then(function () { return sectionVideoGallery$1; }), Promise.resolve().then(function () { return componentSapDownloadRedirection$1; }), Promise.resolve().then(function () { return componentVideoControls$1; }), Promise.resolve().then(function () { return componentVideoToggle$1; })];
        const componentsObj = hydrateComponents(components, setScrollbarWidth);
        await componentsObj.hydrate?.();
      })();
    });

    const camelCase = s => s.replace(/-./g, x => x[1].toUpperCase());
    const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);
    function groupByRef(element, result, onlyFirst = false) {
      const ref = element.getAttribute('data-ref');
      if (!ref) return;
      const refs = ref.split(' ').map(camelCase);
      refs.forEach(capitalizedRef => {
        if (onlyFirst) {
          if (!result[capitalizedRef]) {
            result[capitalizedRef] = element;
          }
        } else {
          if (result[capitalizedRef]) {
            if (Array.isArray(result[capitalizedRef])) {
              result[capitalizedRef].push(element);
            } else {
              result[capitalizedRef] = [result[capitalizedRef], element];
            }
          } else {
            result[capitalizedRef] = element;
          }
        }
      });
    }
    const getElementsByRef$g = (refs, target) => {
      const root = target instanceof HTMLElement ? target : document.body;
      const result = {};
      const selector = Array.isArray(refs) ? refs.map(ref => `[data-ref*="${ref}"]`).join(',') : `[data-ref*="${refs}"]`;
      const elements = root.querySelectorAll(selector);
      elements.forEach(element => groupByRef(element, result));
      return result;
    };
    const getRefs$9 = (target = document.body, watch) => {
      const root = typeof target === 'string' ? document.querySelector(`[data-namespace="${target}"]`) : target;
      if (!root) {
        return;
      }
      const name = root?.getAttribute('data-namespace');
      return watch ? _watched(root, name, watch) : _refs(root, name, true);
    };
    function _refs(root, name, includeRoot) {
      const attribute = name ? `data-ref-${name}` : 'data-ref';
      return [...root.querySelectorAll(`[${attribute}]`)].reduce((refs, el) => {
        const dataset = name ? `ref${capitalize(name)}` : 'ref';
        return {
          ...(includeRoot && {
            root
          }),
          ...refs,
          ...(camelCase(el.dataset[dataset]) || 'item').split(' ').reduce((acc, newRef) => ({
            ...acc,
            [newRef]: refs[newRef] ? [refs[newRef], el].flat() : el
          }), {})
        };
      }, {});
    }
    function _watched(r, n, onChange) {
      const observer = new MutationObserver(() => {
        ref.current = _refs(r, n);
        if (typeof onChange === 'function') onChange();
      });
      observer.observe(r, {
        childList: true,
        subtree: true
      });
      const ref = {
        root: r,
        current: _refs(r, n),
        unwatch: observer.disconnect.bind(observer)
      };
      return ref;
    }
    getRefs$9();

    var imageLoaded = () => {
      const {
        image,
        video
      } = getElementsByRef$g(['image', 'video']);
      const images = image ? Array.isArray(image) ? image : [image] : [];
      const videos = video ? Array.isArray(video) ? video : [video] : [];
      const handleImageLoad = ({
        target
      }) => {
        target.classList.add('loaded');
      };
      images.forEach(image => {
        if (image.complete) {
          handleImageLoad({
            target: image
          });
        } else {
          image.addEventListener('load', handleImageLoad, {
            once: true
          });
        }
      });
      videos.forEach(video => {
        video.addEventListener('canplaythrough', handleImageLoad);
        setTimeout(() => {
          handleImageLoad({
            target: video
          });
        }, 1000);
      });
    };

    var imageLoaded$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: imageLoaded
    });

    const breakpoints$3 = {
      'sm': 600,
      'md': 1024,
      'lg': 1200,
      'xl': 1440,
      'page-max': 1660
    };

    const progress = (() => {
      const multiplier = 0.1;
      let instances = [];
      window.ins = instances;
      let ticking = false;
      let raf = null;
      const start = () => {
        ticking = true;
        animate();
      };
      const pause = () => {
        ticking = false;
        if (raf) cancelAnimationFrame(raf);
      };
      const destroy = () => {
        pause();
        instances = [];
      };
      const isAnimating = () => {
        return ticking;
      };
      const add = ({
        element,
        value
      }) => {
        const valueAsFloat = value;
        const bounds = element.getBoundingClientRect();
        const startFromZero = bounds.y + bounds.height + scrollY >= 0 && bounds.y + scrollY < innerHeight ? true : false;
        const initialProgressInScreen = Math.max((innerHeight - bounds.y - scrollY) / (innerHeight + bounds.height), 0);
        let startValue = 0;
        let endValue = 0;
        if (startFromZero) {
          startValue = 0;
        } else {
          startValue = valueAsFloat * -0.5;
        }
        endValue = valueAsFloat * 0.5;
        const instance = {
          element,
          startValue,
          endValue,
          range: endValue - startValue,
          currentValue: null,
          initialProgressInScreen,
          isInitialized: false
        };
        instances.push(instance);
        if (!ticking) {
          start();
        }
      };
      const animate = () => {
        const {
          innerHeight
        } = window;
        let instancesLength = instances.length;
        let i = instancesLength;
        if (raf) {
          cancelAnimationFrame(raf);
        }
        if (ticking) {
          raf = requestAnimationFrame(animate);
        }
        while (i) {
          i--;
          const instance = instances[i];
          const {
            element,
            startValue,
            endValue,
            initialProgressInScreen,
            isInitialized
          } = instance;
          const bounds = element.getBoundingClientRect();
          let progress = (innerHeight - bounds.y) / (innerHeight + bounds.height);
          let normalizedProgress = (progress - initialProgressInScreen) / (1 - initialProgressInScreen);
          if (normalizedProgress > 1) normalizedProgress = 1;
          if (normalizedProgress < 0) normalizedProgress = 0;
          if (normalizedProgress === 0 && instance.currentValue === startValue) continue;
          if (normalizedProgress >= 1 && instance.currentValue === endValue) continue;
          const targetValue = (endValue - startValue) * normalizedProgress + startValue;
          const delta = targetValue - (instance.currentValue ?? 0);
          const velocity = Math.abs(delta) < 0.1 ? 0 : delta * multiplier;
          instance.currentValue = (instance.currentValue ?? 0) + velocity;
          instance.currentValue = parseFloat(instance.currentValue.toFixed(3));
          if (Math.abs(delta) < 0.1 || !isInitialized) {
            instance.currentValue = parseFloat(targetValue.toFixed(3));
            instance.isInitialized = true;
          }
          const transformString = `translate3d(0, ${instance.currentValue}px,0)`;
          setTransform(element, transformString);
        }
      };
      const setTransform = (element, transform) => {
        element.style.transform = transform;
      };
      return {
        start,
        pause,
        destroy,
        isAnimating,
        add
      };
    })();

    const cleanPath = path => path.replace(/\/+/g, '/');
    const cleanPaths = paths => {
      return Object.fromEntries(Object.entries(paths).map(([key, path]) => [key, cleanPath(path)]));
    };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const ROOT_PATH = window?.Shopify?.routes?.root || '/';
    const PROXY_BASE_PATH = cleanPath(`${ROOT_PATH}/apps/polene-theme-features`);
    const KLAVIYO_BASE_PATH = 'https://a.klaviyo.com/client';
    cleanPaths({
      WISHLIST: `${ROOT_PATH}/pages/wishlist`,
      ACCOUNT: `${ROOT_PATH}/account`,
      LOGIN: `${ROOT_PATH}/account/login`,
      LOGIN_MULTI_PASS: `${ROOT_PATH}/account/login/multipass`
    });
    const API_PROXY = {
      RETURNS: PROXY_BASE_PATH + '/order-returns',
      RETURN_BUTTON: PROXY_BASE_PATH + '/order-return-button',
      ORDER_HISTORY: PROXY_BASE_PATH + '/order-history',
      ORDER_INVOICE: PROXY_BASE_PATH + '/order-invoice',
      ORDER_CREDIT_NOTE: PROXY_BASE_PATH + '/order-credit-note',
      ORDER_DETAILS: PROXY_BASE_PATH + '/order-details',
      ORDER_DETAILS_SAP: PROXY_BASE_PATH + '/order-details-sap',
      DELETE_ACCOUNT: PROXY_BASE_PATH + '/delete-account',
      CREATE_CUSTOMER: PROXY_BASE_PATH + '/customer-create',
      UPDATE_CUSTOMER: PROXY_BASE_PATH + '/customer-update',
      CUSTOMER_SMS_CONSENT: PROXY_BASE_PATH + '/customer-sms-marketing',
      CUSTOMER_WISHLIST: PROXY_BASE_PATH + '/customer-wishlist',
      STOREFRONT: PROXY_BASE_PATH + '/storefront',
      MARKETING_SUBSCRIBE: PROXY_BASE_PATH + '/marketing-subscribe',
      BACK_IN_STOCK_SUBSCRIBE: PROXY_BASE_PATH + '/back-in-stock-subscribe',
      WISHLIST: PROXY_BASE_PATH + '/wishlist',
      ORDER_TRACKER: PROXY_BASE_PATH + '/order-tracker',
      BIS_SUBSCRIPTIONS: PROXY_BASE_PATH + '/back-in-stock-subscriptions',
      ALL_ARTICLES: PROXY_BASE_PATH + '/blog-articles',
      CART_IDENTITY: PROXY_BASE_PATH + '/cart-identity',
      CUSTOMER_IDENTITY: PROXY_BASE_PATH + '/customer-identity',
      KLAVIYO_RESOLVER: PROXY_BASE_PATH + '/klaviyo-resolver'
    };
    const KLAVIYO_ID = window.P1?.klaviyo?.public_key;
    window.P1?.klaviyo?.list_id;
    const API_KLAVIYO = {
      HEADERS: {
        'revision': '2025-01-15',
        'content-type': 'application/vnd.api+json'
      },
      BACK_IN_STOCK_SUB: KLAVIYO_BASE_PATH + `/back-in-stock-subscriptions/?company_id=${KLAVIYO_ID}`,
      SUBSCRIPTION: KLAVIYO_BASE_PATH + `/subscriptions?company_id=${KLAVIYO_ID}`,
      EVENT: KLAVIYO_BASE_PATH + `/profiles?company_id=${KLAVIYO_ID}`
    };
    const FOCUSABLE_SELECTORS = ['button:not([disabled])', '[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"]):not([disabled])'].join(', ');
    const TIMEOUTS = {
      DELAY_50: 50,
      DELAY_150: 150,
      COMMON_DELAY_300: 300,
      DELAY_500: 500,
      DELAY_600: 600,
      DELAY_4000: 4000
    };
    const KLAVIYO_ID_COOKIE_NAME = '__kla_id';
    const KLAVIYO_EXCHANGE_ID_PARAM = '_kx';
    const KLAVIYO_EXCHANGE_ID_SESSION_KEY = 'polene_klaviyo_exchange_id';
    const CONSENT_TRACKING_API_FEATURE = {
      name: 'consent-tracking-api',
      version: '0.1'
    };
    const TRACKING_CONSENT_TIMEOUT = 1500;
    const VISITOR_CONSENT_COLLECTED_EVENT = 'visitorConsentCollected';
    const MIXPANEL_BRIDGE_KEY = 'mixpanel:bridge';
    const MIXPANEL_BRIDGE_VERSION = 1;
    const ROLLOUT_TREATMENT_IDS_SELECTOR = 'script[data-treatment-ids]';
    const ATC_SOURCE_MAX_AGE = 60000;
    const ATC_SOURCE_FALLBACK = 'unknown';
    const MIXPANEL_SDK_URL = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
    const MIXPANEL_API_HOST = 'https://api-eu.mixpanel.com';
    const MIXPANEL_REPLAY_ID_SYNC_INTERVAL = 2000;

    const prefersReducedMotion$1 = () => {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    };

    var parallax = () => {
      if (prefersReducedMotion$1()) return;
      const ref = getElementsByRef$g(['parallax-el']);
      if (!ref?.parallaxEl) return;
      const parallaxItems = Array.isArray(ref.parallaxEl) ? ref.parallaxEl : [ref.parallaxEl];
      let items = [];
      let isMobile = window.innerWidth < breakpoints$3.md;
      const init = () => {
        window.addEventListener('load', isReady);
      };
      const isReady = () => {
        items = isMobile ? parallaxItems.filter(item => !item.hasAttribute('data-disable-mobile-parallax')) : parallaxItems;
        items.forEach(item => {
          progress.add({
            element: item,
            value: item.dataset.parallax ? parseFloat(item.dataset.parallax) : 0
          });
        });
      };
      init();
      return () => {
        window.removeEventListener('load', isReady);
        progress.destroy();
      };
    };

    var parallax$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: parallax
    });

    function initKeyboardNavigation() {
      const handleMouseDown = () => {
        document.body.classList.remove('keyboard-navigation');
      };
      const handleKeyDown = e => {
        if (e.key === 'Tab') {
          document.body.classList.add('keyboard-navigation');
        }
      };
      document.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('keydown', handleKeyDown);
      return () => {
        document.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('keydown', handleKeyDown);
      };
    }
    document.addEventListener('DOMContentLoaded', initKeyboardNavigation);

    var keyboardNavigation = /*#__PURE__*/Object.freeze({
        __proto__: null,
        initKeyboardNavigation: initKeyboardNavigation
    });

    const {
      getRefs: getRefs$8,
      getElementsByRef: getElementsByRef$f
    } = window.PoleneLibs.Refs;
    const initDropdown = dropdown => {
      const ref = getRefs$8(dropdown);
      const KEYS = {
        SPACEBAR: [0, 32],
        ENTER: 13,
        DOWN_ARROW: 40,
        UP_ARROW: 38,
        ESCAPE: 27
      };
      if (!ref.items) return;
      if (dropdown.dataset.dropdown === 'store-selector') {
        const currentStore = ref.items.find(item => {
          const link = item.querySelector('a');
          return link?.href?.includes(location.hostname);
        });
        if (currentStore) {
          ref.selected.textContent = currentStore.textContent;
        }
      }
      ref.selected.addEventListener('click', e => toggleVisibility(e));
      ref.selected.addEventListener('keydown', e => toggleVisibility(e));
      document.body.addEventListener('click', e => handleBodyClick(e));
      const handleBodyClick = e => {
        const clickOutsideDropdown = !e.target.closest('[data-ref="dropdown"]');
        if (clickOutsideDropdown) close();
      };
      const focusItem = item => (item?.matches(FOCUSABLE_SELECTORS) ? item : item?.querySelector(FOCUSABLE_SELECTORS))?.focus();
      const handleClose = e => {
        setSelected(e);
        close();
      };
      const handleKeypress = e => {
        switch (e.keyCode) {
          case KEYS.ENTER:
            handleClose(e);
            return;
          case KEYS.DOWN_ARROW:
            focusNextItem(KEYS.DOWN_ARROW);
            return;
          case KEYS.UP_ARROW:
            focusNextItem(KEYS.UP_ARROW);
            return;
          case KEYS.ESCAPE:
            close();
            return;
          default:
            return;
        }
      };
      const itemTeardowns = ref.items.map(item => {
        item.addEventListener('click', handleClose);
        item.addEventListener('keydown', handleKeypress);
        return () => {
          item.removeEventListener('click', handleClose);
          item.removeEventListener('keydown', handleKeypress);
        };
      });
      function setSelected(e) {
        ref.selected.textContent = e.target.innerText;
      }
      function close() {
        ref.list.classList.remove('open');
        ref.selected.setAttribute('aria-expanded', 'false');
        const wasFocusedInside = ref.root.contains(document.activeElement);
        ref.container.hidden = true;
        if (wasFocusedInside) ref.selected.focus();
      }
      function toggleVisibility(e) {
        if (e.keyCode === KEYS.ESCAPE) close();
        if (e.type === 'click') {
          const isOpen = ref.list.classList.toggle('open');
          ref.selected.setAttribute('aria-expanded', String(isOpen));
          ref.container.hidden = !isOpen;
          if (isOpen && e.detail === 0) focusItem(ref.items[0]);
        }
        if (e.keyCode === KEYS.DOWN_ARROW) {
          focusNextItem(KEYS.DOWN_ARROW);
        }
        if (e.keyCode === KEYS.UP_ARROW) {
          focusNextItem(KEYS.UP_ARROW);
        }
      }
      function focusNextItem(direction) {
        if (!ref.list.classList.contains('open')) {
          return;
        }
        const activeElement = document.activeElement;
        if (activeElement instanceof HTMLElement && activeElement.dataset?.id === 'selected') {
          focusItem(ref.items[0]);
          return;
        }
        const current = ref.items.indexOf(activeElement?.closest('[data-ref-dropdown="items"]'));
        if (current === -1) return;
        const next = direction === KEYS.DOWN_ARROW ? current + 1 : current - 1;
        if (next < 0 || next >= ref.items.length) return;
        focusItem(ref.items[next]);
      }
      return () => {
        itemTeardowns.forEach(teardown => teardown());
      };
    };
    var dropdown = () => {
      const {
        dropdown
      } = getElementsByRef$f(['dropdown']);
      if (!dropdown) return;
      const elements = Array.isArray(dropdown) ? dropdown : [dropdown];
      const instances = elements.map(initDropdown);
      return () => {
        instances.forEach(teardown => teardown?.());
      };
    };

    var dropdown$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: dropdown
    });

    var reveal = () => {
      const {
        getElementsByRef
      } = window.PoleneLibs.Refs;
      const {
        revealElement
      } = getElementsByRef('reveal-element');
      if (!revealElement) return;
      const items = Array.isArray(revealElement) ? Array.from(revealElement) : [revealElement];
      const init = () => {
        items.forEach(item => item.classList.add('is-revealed'));
      };
      init();
    };

    var reveal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: reveal
    });

    var WishlistEvent;
    (function (WishlistEvent) {
      WishlistEvent[WishlistEvent["UPDATE"] = 0] = "UPDATE";
      WishlistEvent[WishlistEvent["ADD"] = 1] = "ADD";
      WishlistEvent[WishlistEvent["REMOVE"] = 2] = "REMOVE";
    })(WishlistEvent || (WishlistEvent = {}));

    class Wishlist {
      static CACHE_EXPIRATION_AGE = 0;
      static productIds = [];
      static initialized = false;
      static localId = undefined;
      static eventHandlers = {
        [WishlistEvent.UPDATE]: [],
        [WishlistEvent.ADD]: [],
        [WishlistEvent.REMOVE]: []
      };
      static async init() {
        if (this.initialized) return;
        this.authenticate();
        if (this.localId) {
          this.setupEndpoint();
          if (!this.loadFromCache()) await this.get();
          this.callback(WishlistEvent.UPDATE);
        }
        this.initialized = true;
      }
      static cache = () => {
        localStorage.setItem('wishlist_products', JSON.stringify(Array.isArray(this.productIds) ? this.productIds : []));
        localStorage.setItem('wishlist_products_timestamp', Date.now().toString());
      };
      static authenticate = () => {
        const localId = localStorage.getItem('local_id');
        if (localId) this.localId = localId;else if (window.location.href.includes('wishlist')) this.registerLocally();
      };
      static registerLocally = () => {
        this.localId = self.crypto.randomUUID();
        localStorage.setItem('local_id', this.localId);
        this.setupEndpoint();
      };
      static setupEndpoint = () => {
        this.endpoint = `${API_PROXY.WISHLIST}?local_id=${this.localId}`;
      };
      static loadFromCache() {
        const cached = localStorage.getItem('wishlist_products');
        const timestamp = localStorage.getItem('wishlist_products_timestamp');
        if (cached && timestamp) {
          const age = Date.now() - parseInt(timestamp);
          this.productIds = JSON.parse(cached);
          if (age < this.CACHE_EXPIRATION_AGE) return true;
        }
        return false;
      }
      static callback = event => {
        const ids = [...this.productIds];
        if (Array.isArray(event)) {
          event.forEach(e => this.eventHandlers[e].forEach(func => func(ids)));
        } else this.eventHandlers[event].forEach(func => func(ids));
      };
      static async request(endpoint, options = {}) {
        try {
          const response = await fetch(endpoint, options);
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          const data = await response.json();
          return {
            data
          };
        } catch (error) {
          const message = error instanceof Error ? error.message : 'Unknown error';
          return {
            error: message
          };
        }
      }
      static getHTML = async (type = 'grid') => {
        try {
          const response = await fetch(`${this.endpoint}&type=${type}`, {
            headers: {
              Accept: 'text/html'
            }
          });
          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }
          const data = await response.text();
          return data;
        } catch (error) {
          error instanceof Error ? error.message : 'Unknown error';
          return '';
        }
      };
      static get = async () => {
        if (!this.localId) this.registerLocally();
        const result = await this.request(this.endpoint);
        if (result.data) {
          this.productIds = result.data.products;
          this.cache();
        }
        return this.productIds;
      };
      static add = async productId => {
        if (!this.localId) this.registerLocally();
        if (this.productIds.includes(productId)) return true;
        const formData = new FormData();
        formData.append('product_id', productId);
        const result = await this.request(`${this.endpoint}`, {
          method: 'POST',
          body: formData
        });
        if (result.data?.success) {
          this.productIds.push(productId);
          this.cache();
          this.callback([WishlistEvent.ADD, WishlistEvent.UPDATE]);
          return true;
        }
        return false;
      };
      static remove = async productId => {
        if (!this.localId) return false;
        if (!this.productIds.includes(productId)) return true;
        const formData = new FormData();
        formData.append('product_id', productId);
        const result = await this.request(this.endpoint, {
          method: 'DELETE',
          body: formData
        });
        if (result.data?.success) {
          this.productIds = this.productIds.filter(id => id !== productId);
          this.cache();
          this.callback([WishlistEvent.REMOVE, WishlistEvent.UPDATE]);
          return true;
        }
        return false;
      };
      static count = () => this.productIds.length;
      static isInWishlist = productId => {
        return this.productIds.includes(productId);
      };
      static getProductIds = () => {
        return [...this.productIds];
      };
      static setEventListeners = (event, callback) => this.eventHandlers[event].push(callback);
      static removeEventListeners = (event, callback) => this.eventHandlers[event] = this.eventHandlers[event].filter(func => func !== callback);
    }
    var wishlist = async () => await Wishlist.init();

    var wishlist$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Wishlist: Wishlist,
        default: wishlist
    });

    class FocusTrap {
      focusableElements = [];
      previousActiveElement = null;
      constructor(container) {
        this.container = container;
        this.boundHandleKeydown = this.handleKeydown.bind(this);
      }
      activate() {
        this.previousActiveElement = document.activeElement;
        this.focusableElements = this.getFocusableElements();
        document.addEventListener('keydown', this.boundHandleKeydown);
        if (this.focusableElements.length > 0) {
          this.focusableElements[0].focus();
        } else {
          this.container.focus();
        }
      }
      deactivate() {
        document.removeEventListener('keydown', this.boundHandleKeydown);
        if (this.previousActiveElement && !this.container.contains(this.previousActiveElement)) {
          this.previousActiveElement.focus();
        }
      }
      handleKeydown(event) {
        if (!this.focusableElements.length) return;
        const firstElement = this.focusableElements[0];
        const lastElement = this.focusableElements[this.focusableElements.length - 1];
        const activeElement = document.activeElement;
        if (event.key === 'Tab') {
          if (!event.shiftKey && activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
          } else if (event.shiftKey && activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
          }
        }
      }
      getFocusableElements() {
        const elements = Array.from(this.container.querySelectorAll(FOCUSABLE_SELECTORS));
        return elements.filter(element => {
          return !element.hasAttribute('disabled') && element.offsetParent !== null && !element.hasAttribute('aria-hidden') && !element.hasAttribute('hidden');
        });
      }
    }

    const SEARCH_PARAM = 'openCountrySelector';
    const CLOSE_BUTTON_SELECTOR = '.country-selector__popup__header__close';
    class CountrySelectorModal {
      focusTrap = null;
      inertedBackground = [];
      constructor() {
        this.selectorModals = document.querySelectorAll('.selector_popup');
        this.selectorButtons = document.querySelectorAll('.selector-button');
        this.boundHandleEscapeKeydown = this.handleEscapeKeydown.bind(this);
        this.boundHandleButtonClick = this.handleButtonClick.bind(this);
        this.boundCloseModal = this.closeModal.bind(this);
      }
      handleButtonClick(event) {
        const button = event.currentTarget;
        const countrySelectorModal = document.querySelector(`#${button.dataset.puid}`);
        if (countrySelectorModal && !document.body.classList.contains('search-open')) {
          this.showModal(countrySelectorModal);
        }
      }
      setBackgroundInert(countrySelectorModal, inert) {
        if (inert) {
          this.inertedBackground = Array.from(document.body.children).filter(child => child instanceof HTMLElement && !child.contains(countrySelectorModal) && !child.hasAttribute('inert'));
          this.inertedBackground.forEach(element => element.setAttribute('inert', ''));
          return;
        }
        this.inertedBackground.forEach(element => element.removeAttribute('inert'));
        this.inertedBackground = [];
      }
      setTriggersExpanded(countrySelectorModal, expanded) {
        document.querySelectorAll(`[data-puid="${countrySelectorModal.id}"][aria-expanded]`).forEach(trigger => trigger.setAttribute('aria-expanded', String(expanded)));
      }
      showModal(countrySelectorModal) {
        if (!countrySelectorModal) return;
        const closeModalButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        if (closeModalButton) {
          closeModalButton.addEventListener('click', this.boundCloseModal);
        }
        document.addEventListener('keydown', this.boundHandleEscapeKeydown);
        countrySelectorModal.classList.add('is-open');
        document.querySelector('body')?.classList.add('country-selector-modal-is-open');
        countrySelectorModal.setAttribute('tabindex', '-1');
        this.setBackgroundInert(countrySelectorModal, true);
        this.focusTrap = new FocusTrap(countrySelectorModal);
        this.focusTrap.activate();
        this.setTriggersExpanded(countrySelectorModal, true);
        (closeModalButton ?? countrySelectorModal).focus();
      }
      closeModal() {
        const countrySelectorModal = document.querySelector('.selector_popup.is-open');
        if (countrySelectorModal) {
          countrySelectorModal.classList.remove('is-open');
          document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
          this.clearEvents(countrySelectorModal);
          const url = new URL(window.location.href);
          const urlParams = new URLSearchParams(url.search);
          urlParams.delete(SEARCH_PARAM);
          url.search = urlParams.toString();
          window.history.replaceState({}, document.title, url.toString());
        }
      }
      clearEvents(countrySelectorModal) {
        const modalCloseButton = countrySelectorModal.querySelector(CLOSE_BUTTON_SELECTOR);
        this.setBackgroundInert(countrySelectorModal, false);
        this.setTriggersExpanded(countrySelectorModal, false);
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        this.focusTrap?.deactivate();
        if (modalCloseButton) {
          modalCloseButton.removeEventListener('click', this.boundCloseModal);
        }
      }
      handleEscapeKeydown(event) {
        if (event.key === 'Escape') {
          this.closeModal();
        }
      }
      getSearchParam() {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);
        urlParams.delete('country');
        url.search = urlParams.toString();
        window.history.replaceState({}, document.title, url.toString());
        return urlParams.has(SEARCH_PARAM);
      }
      setupEventListeners() {
        if (!this.selectorModals || this.selectorButtons.length === 0) return;
        this.selectorButtons.forEach(button => {
          button.addEventListener('click', this.boundHandleButtonClick);
        });
      }
      cleanup() {
        if (this.selectorButtons) {
          this.selectorButtons.forEach(button => {
            button.removeEventListener('click', this.boundHandleButtonClick);
          });
        }
        document.removeEventListener('keydown', this.boundHandleEscapeKeydown);
        if (this.selectorModals) {
          this.selectorModals.forEach(modal => {
            if (modal.classList.contains('is-open')) {
              this.clearEvents(modal);
              modal.classList.remove('is-open');
            }
          });
        }
        document.querySelector('body')?.classList.remove('country-selector-modal-is-open');
      }
      init() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => {
            this.setupEventListeners();
          });
        } else {
          this.setupEventListeners();
        }
        if (this.getSearchParam()) {
          const defaultModal = this.selectorModals[0];
          if (defaultModal) {
            this.showModal(defaultModal);
          }
        }
        return this.cleanup.bind(this);
      }
    }
    var countrySelectorModal = () => {
      const modal = new CountrySelectorModal();
      return modal.init();
    };

    var countrySelectorModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        CountrySelectorModal: CountrySelectorModal,
        default: countrySelectorModal
    });

    var InputFields;
    (function (InputFields) {
      InputFields["FirstName"] = "firstName";
      InputFields["LastName"] = "lastName";
      InputFields["Address1"] = "address1";
      InputFields["Address2"] = "address2";
      InputFields["Zip"] = "zip";
      InputFields["City"] = "city";
      InputFields["Phone"] = "phone";
      InputFields["Birthdate"] = "birthdate";
      InputFields["email"] = "email";
      InputFields["password"] = "password";
      InputFields["confirmPassword"] = "confirmPassword";
      InputFields["civility"] = "civility";
    })(InputFields || (InputFields = {}));
    const FormSelectors = {
      Customer: {
        BIRTHDATE: 'input[name=birthdate]',
        PHONE: 'input[name="phone"]',
        PHONE_COUNTRY_SELECT: 'select[name="phone_country_select"]',
        SUBMIT_BUTTON: 'button[type="submit"]',
        FIRST_NAME: 'input[name="firstName"]',
        LAST_NAME: 'input[name="lastName"]',
        EMAIL: 'input[name="email"]',
        PASSWORD: 'input[name="password"]',
        CIVILITY: 'select[name="civility"]',
        Shopify: {
          Selectors: {
            EMAIL: 'input[name="customer[email]"]',
            PASSWORD: 'input[name="customer[password]"]',
            CONFIRM_PASSWORD: 'input[name="customer[password_confirmation]"]'
          }
        },
        RecoverPassword: {
          EMAIL: 'input[name="email"]'
        },
        Update: {
          ID: '#profile_form',
          FORM: '#update_customer_form',
          Selectors: {
            FIRST_NAME: 'input[name="firstName"]',
            LAST_NAME: 'input[name="lastName"]',
            PHONE: 'input[name="phone"]'
          },
          Fields: {
            FirstName: 'firstName',
            LastName: 'lastName',
            Phone: 'phone'
          }
        },
        Address: {
          COUNTRY_SELECT: 'select[name="address[country]"]',
          PHONE: 'input[name="address[phone]"]',
          FIRST_NAME: 'input[name="address[first_name]"]',
          LAST_NAME: 'input[name="address[last_name]"]',
          ADDRESS_1: 'input[name="address[address1]"]',
          ADDRESS_2: 'input[name="address[address2]"]',
          ZIP: 'input[name="address[zip]"]',
          CITY: 'input[name="address[city]"]'
        }
      }
    };
    const defaultNoValidationConf = {
      noSpecialChar: undefined,
      nonLatinCharacters: undefined,
      noNumber: undefined,
      maxLength: undefined,
      minLength: 0,
      required: false
    };
    const inputTextDefaultValidationConf = {
      nonLatinCharacters: true,
      noSpecialChar: true,
      noNumber: true,
      maxLength: 35,
      minLength: 0,
      required: true
    };
    const FormValidations = {
      [InputFields.FirstName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.LastName]: {
        ...inputTextDefaultValidationConf,
        minLength: 2,
        maxLength: 35
      },
      [InputFields.Address1]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: true
      },
      [InputFields.Address2]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        required: false
      },
      [InputFields.City]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: undefined,
        required: true
      },
      [InputFields.Zip]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        maxLength: 10,
        required: true
      },
      [InputFields.Phone]: {
        ...defaultNoValidationConf
      },
      [InputFields.email]: {
        ...defaultNoValidationConf,
        required: true,
        email: true
      },
      [InputFields.password]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.confirmPassword]: {
        ...inputTextDefaultValidationConf,
        noNumber: false,
        noSpecialChar: false,
        minLength: 5
      },
      [InputFields.civility]: {
        ...defaultNoValidationConf,
        required: true
      },
      [InputFields.Birthdate]: {
        ...inputTextDefaultValidationConf,
        nonLatinCharacters: false,
        noSpecialChar: false,
        maxDate: Date.now(),
        required: false,
        noNumber: false
      }
    };

    var ErrorTypes;
    (function (ErrorTypes) {
      ErrorTypes["invalidTitle"] = "invalid_title";
      ErrorTypes["invalidName"] = "invalid_name";
      ErrorTypes["invalidCivility"] = "invalid_civility";
      ErrorTypes["nonLatinCharacters"] = "contains_non_latin_characters";
      ErrorTypes["maxLengthExceeded"] = "max_length_exceeded";
      ErrorTypes["minLength"] = "min_length";
      ErrorTypes["containsNumbers"] = "contains_numbers";
      ErrorTypes["containsSpecialChars"] = "contains_special_chars";
      ErrorTypes["empty"] = "empty";
      ErrorTypes["phoneNumberInvalid"] = "phone_number_invalid";
      ErrorTypes["formSubmitError"] = "form_error";
      ErrorTypes["TAKEN"] = "email_taken";
      ErrorTypes["maxDate"] = "max_date";
      ErrorTypes["invalidDate"] = "invalid_date";
      ErrorTypes["invalidEmail"] = "invalid_email";
    })(ErrorTypes || (ErrorTypes = {}));

    const containsNonLatinCharactersFieldError = str => {
      const nonLatinRegex = /[^\u0000-\u017F]+/;
      return nonLatinRegex.test(str || '');
    };
    const validateNotContainsNonLatinCharacters = str => {
      if (containsNonLatinCharactersFieldError(str)) {
        return {
          isValid: false,
          error: ErrorTypes.nonLatinCharacters
        };
      }
      return {
        isValid: true
      };
    };
    function validateMaxLength(str, maxLength) {
      if (str.length > maxLength) {
        return {
          isValid: false,
          error: ErrorTypes.maxLengthExceeded
        };
      }
      return {
        isValid: true
      };
    }
    function validateMinLength(str, minLength) {
      if (str.length < minLength) {
        return {
          isValid: false,
          error: ErrorTypes.minLength
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoNumbers(str) {
      const numberRegex = /\d/;
      if (numberRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsNumbers
        };
      }
      return {
        isValid: true
      };
    }
    function validateNoSpecialChars(str) {
      const specialCharsRegex = /[%_;|]/;
      if (specialCharsRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.containsSpecialChars
        };
      }
      return {
        isValid: true
      };
    }
    function validateNotEmpty(str) {
      const withoutWhiteSpace = str.replace(/\s/g, '');
      if (withoutWhiteSpace.length <= 0) return {
        isValid: false,
        error: ErrorTypes.empty
      };
      return {
        isValid: true
      };
    }
    function validateMaxDate(inputTimestamp, limitTimestamp) {
      if (inputTimestamp > limitTimestamp) {
        return {
          isValid: false,
          error: ErrorTypes.maxDate
        };
      }
      return {
        isValid: true
      };
    }
    function validateDate(ts) {
      return !ts ? {
        isValid: false,
        error: ErrorTypes.invalidDate
      } : {
        isValid: true
      };
    }
    function validateEmail$1(str) {
      if (!str || str.trim().length === 0) {
        return {
          isValid: false,
          error: ErrorTypes.empty
        };
      }
      if (!emailRegex.test(str)) {
        return {
          isValid: false,
          error: ErrorTypes.invalidEmail
        };
      }
      return {
        isValid: true
      };
    }

    const DateFormat = window.PoleneLibs.DateFormat;
    class InputValidation {
      inputs = {};
      dateFormat = new DateFormat();
      hasSubmitOnce = false;
      constructor({
        formContainer,
        inputs
      }) {
        this.formContainer = formContainer;
        this.inputs = inputs;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw new Error('Form not found');
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Submit Button not found');
      }
      triggerValidationEffect(input, validation) {
        if (!validation.isValid && validation.error) {
          this.displayErrorSpan(input, validation.error, validation.message);
          if (this.submitButton) this.submitButton.disabled = true;
          return false;
        }
        this.removeErrorSpan(input);
        if (this.submitButton) this.submitButton.disabled = false;
        return true;
      }
      displayErrorSpan(input, error, message) {
        this.removeErrorSpan(input);
        const errorSpan = this.form?.querySelector(`span[data-ref=${input.id}-${error}]`);
        if (!errorSpan) return;
        if (message) errorSpan.textContent = message;
        input.ariaInvalid = 'true';
        input.setAttribute('aria-describedby', `${input.id}-${error}`);
        errorSpan.hidden = false;
        errorSpan.style.display = 'block';
      }
      removeErrorSpan(input) {
        const errorSpans = this.form?.querySelectorAll(`span[data-ref^=${input.id}]`);
        if (!errorSpans) return;
        input.ariaInvalid = 'false';
        input.removeAttribute('aria-describedby');
        errorSpans.forEach(span => {
          span.hidden = true;
          span.style.display = 'none';
        });
      }
      checkRequiredInput({
        input
      }) {
        if (!input) return true;
        let inputIsEmpty = false;
        if (!input.validationConfig.required) return;
        const emptyCheck = validateNotEmpty(input.selector.value);
        if (!this.triggerValidationEffect(input.selector, emptyCheck)) return false;
        inputIsEmpty = true;
        return inputIsEmpty;
      }
      checkRequiredInputs({
        inputs
      }) {
        if (!inputs) return false;
        let isValid = true;
        Object.values(this.inputs).forEach(input => {
          if (!input.validationConfig.required) return;
          const emptyCheck = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, emptyCheck)) {
            isValid = false;
          }
        });
        return isValid;
      }
      validateInput(input) {
        if (this.hasSubmitOnce) {
          const empty = validateNotEmpty(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, empty)) {
            return false;
          }
        }
        if (input.selector.dataset.ref == 'input-date' && input.selector.value != `${this.dateFormat.placeholder}  (${input.selector.dataset.tOptional})`) {
          const date = this.dateFormat.parse(input.selector.value);
          const invalidDateCheck = validateDate(date);
          if (!this.triggerValidationEffect(input.selector, invalidDateCheck)) return false;
          if (input.validationConfig.maxDate) {
            const maxDateCheck = validateMaxDate(date ?? NaN, input.validationConfig.maxDate);
            if (!this.triggerValidationEffect(input.selector, maxDateCheck)) return false;
          }
        }
        if (input.validationConfig.noSpecialChar) {
          const speCharCheck = validateNoSpecialChars(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, speCharCheck)) {
            return false;
          }
        }
        if (input.validationConfig.noNumber) {
          const noNumb = validateNoNumbers(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, noNumb)) {
            return false;
          }
        }
        if (input.validationConfig.maxLength) {
          const lengthCheck = validateMaxLength(input.selector.value, input.validationConfig.maxLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.minLength) {
          const lengthCheck = validateMinLength(input.selector.value, input.validationConfig.minLength);
          if (!this.triggerValidationEffect(input.selector, lengthCheck)) {
            return false;
          }
        }
        if (input.validationConfig.nonLatinCharacters) {
          const latinCharactersCheck = validateNotContainsNonLatinCharacters(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, latinCharactersCheck)) {
            return false;
          }
        }
        if (input.validationConfig.email) {
          const emailCheck = validateEmail$1(input.selector.value);
          if (!this.triggerValidationEffect(input.selector, emailCheck)) {
            return false;
          }
        }
        return true;
      }
      validateForm({
        inputs
      }) {
        let isValid = true;
        Object.values(inputs).forEach(input => {
          if (input.selector.value.trim() !== '') {
            if (!this.validateInput(input)) {
              isValid = false;
            }
          }
        });
        return isValid;
      }
    }

    const {
      getElementByRef: getElementByRef$p
    } = window.PoleneLibs.Refs;
    const handleNewsletterEventSubscription = async formData => {
      let customerIsSubscribedToEvent = true;
      const errorType = ErrorTypes.formSubmitError;
      let errorMessage;
      const {
        newsletterEventForm,
        messageContainerSuccess,
        messageContainerError,
        messageContainerAlreadySignedUp
      } = getElementByRef$p(['newsletter-event-form', 'message-container-success', 'message-container-error', 'message-container-already-signed-up']);
      if (!newsletterEventForm || !messageContainerSuccess || !messageContainerError || !messageContainerAlreadySignedUp) {
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
      const {
        eventKey
      } = newsletterEventForm.dataset;
      const customerEmail = formData.get('email');
      if (typeof customerEmail != 'string') {
        messageContainerError.classList.remove('is-hidden');
        messageContainerError.classList.add('is-visible');
        customerIsSubscribedToEvent = false;
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      } else {
        try {
          const response = await fetch(API_KLAVIYO.EVENT, {
            method: 'POST',
            headers: API_KLAVIYO.HEADERS,
            body: JSON.stringify({
              data: {
                type: 'profile',
                attributes: {
                  email: customerEmail,
                  meta: {
                    patch_properties: {
                      append: {
                        event: eventKey
                      }
                    }
                  }
                }
              }
            })
          });
          if (response.status === 202) {
            messageContainerSuccess.classList.remove('is-hidden');
            messageContainerSuccess.classList.add('is-visible');
            newsletterEventForm.querySelector('input[data-ref="event-form-email"]').value = '';
          } else {
            customerIsSubscribedToEvent = false;
            const data = await response.json();
            const emailError = data.errors?.find(err => err.source?.pointer === '/data/attributes/email');
            if (emailError) {
              errorMessage = emailError.detail;
              return {
                customerIsSubscribedToEvent,
                errorType: ErrorTypes.invalidEmail,
                errorMessage
              };
            }
            messageContainerError.style.display = 'block';
          }
        } catch (error) {
          customerIsSubscribedToEvent = false;
        }
        return {
          customerIsSubscribedToEvent,
          errorType,
          errorMessage
        };
      }
    };

    var handleNewsletterEvent = /*#__PURE__*/Object.freeze({
        __proto__: null,
        handleNewsletterEventSubscription: handleNewsletterEventSubscription
    });

    const {
      getElementsByRef: getElementsByRef$e,
      getElementByRef: getElementByRef$o
    } = window.PoleneLibs.Refs;
    class NewsletterEventForm {
      inputs = {};
      constructor({
        formContainerId
      }) {
        this.formContainer = document.getElementById(formContainerId);
        if (!this.formContainer) throw `Unable to find form container with id: ${formContainerId}`;
        this.form = this.formContainer.querySelector('form');
        if (!this.form) throw `Unable to find form in the given container: ${formContainerId}`;
        this.submitButton = this.form.querySelector(FormSelectors.Customer.SUBMIT_BUTTON);
        if (!this.submitButton) throw new Error('Required elements not found');
        this.inputs = {
          email: {
            selector: this.form.querySelector(FormSelectors.Customer.EMAIL),
            validationConfig: FormValidations.email
          }
        };
        this.init();
      }
      initInputValidation({
        inputs
      }) {
        this.inputValidation = new InputValidation({
          formContainer: this.formContainer,
          inputs: inputs
        });
      }
      handleFormValidation = () => {
        if (!this.inputs.email?.selector) return false;
        const isValid = this.inputValidation?.validateForm({
          inputs: this.inputs
        });
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      handleInputValidation = input => {
        if (!input.selector || !input.validationConfig) return false;
        this.resetFormMessage();
        const isValid = this.inputValidation?.validateInput(input);
        if (this.submitButton) this.submitButton.disabled = !isValid;
        return isValid;
      };
      async handleFormSubmit(event) {
        event.preventDefault();
        this.resetFormMessage();
        if (!this.inputValidation?.checkRequiredInputs({
          inputs: this.inputs
        }) || !this.handleFormValidation) return false;
        const form = event.currentTarget;
        const formData = new FormData(form);
        if (this.submitButton) this.submitButton.disabled = true;
        const newsletterEventSubscriptionHandler = await handleNewsletterEventSubscription(formData);
        if (this.submitButton && this.inputs.email) {
          if (!newsletterEventSubscriptionHandler.customerIsSubscribedToEvent) {
            this.inputValidation?.triggerValidationEffect(this.inputs.email.selector, {
              isValid: newsletterEventSubscriptionHandler.customerIsSubscribedToEvent,
              error: newsletterEventSubscriptionHandler.errorType
            });
          }
          this.submitButton.disabled = !newsletterEventSubscriptionHandler.customerIsSubscribedToEvent;
        }
      }
      resetFormMessage() {
        const {
          messageContainerSuccess,
          messageContainerError,
          messageContainerAlreadySignedUp
        } = getElementByRef$o(['message-container-success', 'message-container-error', 'message-container-already-signed-up'], this.formContainer);
        [messageContainerSuccess, messageContainerError, messageContainerAlreadySignedUp].forEach(container => {
          container?.classList.add('is-hidden');
          container?.classList.remove('is-visible');
        });
      }
      init() {
        this.initInputValidation({
          inputs: this.inputs
        });
        this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => {
          return input.selector.addEventListener('blur', () => this.handleInputValidation(input));
        });
      }
      destroy() {
        this.form.removeEventListener('submit', this.handleFormSubmit.bind(this));
        Object.values(this.inputs).forEach(input => input.selector.removeEventListener('blur', () => this.handleInputValidation(input)));
      }
    }
    var eventForm = async () => {
      const newsletterEventForm = getElementsByRef$e('newsletter-event-form');
      if (newsletterEventForm) {
        try {
          const form = new NewsletterEventForm({
            formContainerId: 'newsletter-event-form-container'
          });
          return () => {
            form.destroy();
          };
        } catch (error) {}
      }
    };

    var eventForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: eventForm
    });

    const {
      dispatchCartError: dispatchCartError$2,
      cartErrorMessage: cartErrorMessage$2
    } = window.PoleneLibs.CartEvents;
    const getCartToken = async () => {
      const root = ROOT_PATH;
      try {
        const response = await fetch(`${root}cart.js`);
        if (!response.ok) {
          dispatchCartError$2({
            endpoint: 'cart.js',
            method: 'GET',
            status: response.status,
            message: `HTTP ${response.status}`
          });
          return null;
        }
        const cart = await response.json();
        return typeof cart?.token === 'string' ? cart.token.split('?')[0] : null;
      } catch (error) {
        dispatchCartError$2({
          endpoint: 'cart.js',
          method: 'GET',
          status: null,
          message: cartErrorMessage$2(error)
        });
        return null;
      }
    };

    const events$c = window.PoleneLibs.Events.default;
    const {
      storeLanguage: storeLanguage$2
    } = window.PoleneLibs.ConstantsDate;
    const {
      dispatchEvent: dispatchEvent$6,
      getClientToken: getClientToken$2
    } = window.PoleneLibs.Utils;
    const STATE_MESSAGE_CLASS = {
      'submitted': 'is-success',
      'already-subscribed': 'is-already-subscribed',
      'error': 'is-error',
      'no-email': 'is-email-error'
    };
    const ANNOUNCE_DELAY = 150;
    class ComponentBISForm extends HTMLElement {
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller.abort();
        clearTimeout(this.announceTimer);
        if (this.container) this.container.dataset.state = '';
      }
      updatedCallback() {
        this.controller.abort();
        this.controller = new AbortController();
        if (this.container) this.container.dataset.state = '';
        this.initializeElements();
        this.setupEventListeners();
      }
      initializeElements = () => {
        const container = this.closest('.bis-form');
        if (container) this.container = container;
        const form = this.querySelector('form');
        if (form) this.form = form;
        this.emailInput = this.querySelector('input[type="email"]') ?? undefined;
        this.announcer = this.querySelector('[data-ref="bis-announcer"]') ?? undefined;
      };
      announce = state => {
        if (!this.announcer) return;
        clearTimeout(this.announceTimer);
        this.announcer.textContent = '';
        if (!state) return;
        const message = this.container?.querySelector(`.bis-form__message.${STATE_MESSAGE_CLASS[state]}`)?.textContent?.trim();
        if (!message) return;
        this.announceTimer = setTimeout(() => {
          if (this.announcer) this.announcer.textContent = message;
        }, ANNOUNCE_DELAY);
      };
      setState = state => {
        if (this.container) this.container.dataset.state = state;
        const invalid = state === 'no-email' || state === 'already-subscribed';
        this.emailInput?.setAttribute('aria-invalid', String(invalid));
        const focusMoves = invalid && document.activeElement !== this.emailInput;
        if (invalid) this.emailInput?.focus();
        if (!focusMoves) this.announce(state);
      };
      setupEventListeners = () => {
        document.addEventListener('modal', this.handleModalOpen, {
          signal: this.controller.signal
        });
        if (this.form) {
          this.form.addEventListener('submit', this.handleSubmit, {
            signal: this.controller.signal
          });
        }
        const submitBtn = this.querySelector('.js-submit-btn');
        if (submitBtn) {
          submitBtn.addEventListener('click', event => {
            if (this.container?.dataset.state !== 'submitted') return;
            event.preventDefault();
            this.closest('component-modal')?.querySelector('.component-modal__close')?.click();
          }, {
            signal: this.controller.signal
          });
        }
      };
      handleModalOpen = event => {
        if (!(event instanceof CustomEvent)) return;
        const {
          submitter,
          type
        } = event.detail;
        if (!submitter || type !== 'bis') return;
        this.submitter = submitter;
        this.setState('');
      };
      handleSubmit = async event => {
        event.preventDefault();
        if (!this.emailInput?.value.trim() || !this.emailInput.checkValidity()) {
          this.setState('no-email');
          return;
        }
        this.setState('');
        if (this.container && this.form && this.submitter && this.submitter.dataset.variantid) {
          try {
            const formData = new FormData(this.form);
            const variantId = this.submitter.dataset.variantid;
            const newsletterConsentInput = this.form.querySelector('input[id="newsletter-checkbox"]');
            const newsletterConsent = newsletterConsentInput?.checked ?? false;
            formData.set('locale', storeLanguage$2);
            formData.set('variant_id', variantId);
            formData.set('email_marketing_consent', JSON.stringify(newsletterConsent));
            const marketId = this.dataset.marketId;
            if (marketId) formData.set('market_id', marketId);
            const clientToken = getClientToken$2();
            if (clientToken) formData.set('client_token', clientToken);
            const cartToken = await getCartToken();
            if (cartToken) formData.set('cart_token', cartToken);
            const response = await fetch(`${API_PROXY.BACK_IN_STOCK_SUBSCRIBE}`, {
              method: 'POST',
              body: formData
            });
            if (response.status === 202) {
              this.setState('submitted');
              const handle = this.submitter.dataset.handle;
              const state = this.submitter.dataset.trackingState ?? this.submitter.dataset.state;
              dispatchEvent$6(window, events$c.BIS_SUBSCRIBED, {
                variantId,
                handle,
                newsletterConsent,
                state
              });
            } else if (response.status === 409) {
              this.setState('already-subscribed');
            } else {
              throw response.status;
            }
          } catch {
            this.setState('error');
          }
        } else if (this.container) {
          this.setState('error');
        }
      };
      static define = () => {
        if (!customElements.get('component-bis-form')) customElements.define('component-bis-form', ComponentBISForm);
      };
    }
    var componentBisForm = () => {
      ComponentBISForm.define();
    };

    var componentBisForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentBisForm
    });

    const validateEmail = email => {
      if (/^[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        return true;
      }
      return false;
    };

    const {
      BaseComponent: BaseComponent$9
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef: getElementByRef$n
    } = window.PoleneLibs.Refs;
    const {
      storeLanguage: storeLanguage$1
    } = window.PoleneLibs.ConstantsDate;
    const {
      getClientToken: getClientToken$1
    } = window.PoleneLibs.Utils;
    class ComingSoonForm extends BaseComponent$9 {
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
      }
      initializeElements = () => {
        const {
          comingSoonForm,
          comingSoonFormEmail,
          comingSoonFormConsent,
          comingSoonFormSubmit
        } = getElementByRef$n(['coming-soon-form', 'coming-soon-form-email', 'coming-soon-form-consent', 'coming-soon-form-submit'], this);
        this.form = comingSoonForm;
        this.emailInput = comingSoonFormEmail;
        this.consentInput = comingSoonFormConsent;
        this.submitButton = comingSoonFormSubmit;
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        document.addEventListener('modal', this.handleModalEvent, {
          signal
        });
        this.form?.addEventListener('submit', this.handleSubmit, {
          signal
        });
        this.submitButton?.addEventListener('click', this.handleSubmitButtonClick, {
          signal
        });
      };
      setState = state => {
        this.dataset.state = state;
      };
      handleModalEvent = event => {
        if (!(event instanceof CustomEvent)) return;
        const {
          type,
          action,
          submitter
        } = event.detail;
        if (type !== 'coming-soon' || action !== 'open') return;
        this.trigger = submitter ?? undefined;
        this.setState('');
        if (this.emailInput) this.emailInput.value = '';
        if (this.consentInput) this.consentInput.checked = true;
      };
      handleSubmitButtonClick = event => {
        if (this.dataset.state !== 'submitted') return;
        event.preventDefault();
        this.closest('component-modal')?.querySelector('.component-modal__close')?.click();
      };
      handleSubmit = async event => {
        event.preventDefault();
        const {
          eventKey,
          handle
        } = this.trigger?.dataset ?? {};
        if (!eventKey) {
          this.setState('config-error');
          return;
        }
        if (!this.form || !this.emailInput) {
          this.setState('error');
          return;
        }
        if (!validateEmail(this.emailInput.value)) {
          this.setState('email-error');
          return;
        }
        const newsletterConsent = this.consentInput?.checked ?? false;
        const formData = new FormData(this.form);
        formData.set('locale', storeLanguage$1);
        formData.set('event', eventKey);
        formData.set('email_marketing_consent', JSON.stringify(newsletterConsent));
        if (handle) formData.set('product_handle', handle);
        const clientToken = getClientToken$1();
        if (clientToken) formData.set('client_token', clientToken);
        const cartToken = await getCartToken();
        if (cartToken) formData.set('cart_token', cartToken);
        formData.set('identity_source', 'coming_soon');
        try {
          const response = await fetch(API_PROXY.MARKETING_SUBSCRIBE, {
            method: 'POST',
            body: formData,
            signal: this.controller.signal
          });
          if (response.status === 200 || response.status === 409) {
            this.setState('submitted');
          } else {
            this.setState('error');
          }
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
          this.setState('error');
        }
      };
      static define = () => {
        if (!customElements.get('coming-soon-form')) customElements.define('coming-soon-form', ComingSoonForm);
      };
    }
    var comingSoonForm = () => {
      ComingSoonForm.define();
    };

    var comingSoonForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: comingSoonForm
    });

    class LocalizationForm extends HTMLElement {
      abortController = null;
      input = null;
      items = [];
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.initialyzeElements();
        this.setEventListeners();
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      initialyzeElements = () => {
        this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');
        this.items = Array.from(this.querySelectorAll('button'));
      };
      setEventListeners = () => {
        this.items.forEach(item => {
          item.addEventListener('click', this.onItemClick, {
            signal: this.abortController?.signal
          });
          item.addEventListener('keydown', this.onItemKeydown, {
            signal: this.abortController?.signal
          });
        });
      };
      onItemClick = event => {
        event.preventDefault();
        this.submitLanguage(event.currentTarget);
      };
      onItemKeydown = event => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        this.submitLanguage(event.currentTarget);
      };
      submitLanguage = target => {
        const form = this.querySelector('form');
        if (target.dataset.value && this.input) {
          this.input.value = target.dataset.value;
          if (form) form.submit();
        }
      };
      static define() {
        if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);
      }
    }
    var localizationForm = () => {
      LocalizationForm.define();
    };

    var localizationForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        LocalizationForm: LocalizationForm,
        default: localizationForm
    });

    const {
      BaseComponent: BaseComponent$8
    } = window.PoleneLibs.BaseComponent;
    const {
      isMobile: isMobile$7,
      isRTL,
      prefersReducedMotion
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$m
    } = window.PoleneLibs.Refs;
    const {
      dispatchEvent: dispatchEvent$5
    } = window.PoleneLibs.Utils;
    const {
      ACTIVE_SLIDE_CHANGE,
      PDP_CAROUSEL_GALLERY_SWIPE,
      PDP_CAROUSEL_PACKSHOT_SWIPE
    } = window.PoleneLibs.Events.default;
    const {
      EmblaCarousel,
      EmblaPlugins
    } = window.PoleneVendors;
    const SLIDES_QTY_MARGIN = 2;
    const AUTO_SAVE_SCROLL_KEY = id => `carousel-scroll-${id}`;
    const isReloadNavigation = () => {
      const [navEntry] = performance.getEntriesByType('navigation');
      return navEntry?.type === 'reload';
    };
    class ComponentCarousel extends BaseComponent$8 {
      embla = undefined;
      autoscrollPlugin = undefined;
      wheelGesturesPlugin = undefined;
      viewport = undefined;
      container = undefined;
      slides = [];
      nextBtn = undefined;
      prevBtn = undefined;
      customNextBtns = [];
      customPrevBtns = [];
      dotsContainer = undefined;
      dots = [];
      statusRegion = undefined;
      autoplayToggle = undefined;
      autoplayPlayIcon = undefined;
      autoplayPauseIcon = undefined;
      userPaused = false;
      userInteracted = false;
      showDots = false;
      desktopOnly = false;
      slidesPerView = undefined;
      slidesPerViewMobile = undefined;
      slideFullPage = false;
      slidesToScroll = 1;
      disableScroll = false;
      loop = false;
      initialSnapIndex = 0;
      ownerEl = null;
      autoscroll = false;
      autoscrollSpeed = 20;
      autoscrollDirection = 1;
      centered = false;
      skipSnap = false;
      dragFree = false;
      disableTransform = false;
      containScroll = 'trimSnaps';
      autoSaveScroll = false;
      isDragEnabled = true;
      savedTransform = null;
      savedLocation = null;
      clickSaved = false;
      onMount() {
        this.parseDatasetParams();
        this.initializeElements();
        this.initializeCarousel();
        this.setupEventListeners();
      }
      onUnmount() {
        this.embla?.destroy();
        this.embla = undefined;
      }
      parseDatasetParams = () => {
        const {
          slideFullPage,
          loop,
          showDots,
          initialSnapIndex,
          ownerSelector,
          slidesPerView,
          slidesPerViewMobile,
          slidesToScroll,
          autoscroll,
          autoscrollSpeed,
          autoscrollDirection,
          disableScroll,
          desktopOnly,
          centered,
          centeredMobile,
          skipSnap,
          dragFree,
          disableTransform,
          customNextBtnsSelector,
          customPrevBtnsSelector,
          autoSaveScroll
        } = this.dataset;
        this.slideFullPage = slideFullPage === 'true';
        this.loop = loop === 'true';
        this.showDots = showDots === 'true';
        this.initialSnapIndex = initialSnapIndex ? +initialSnapIndex : 0;
        this.ownerEl = ownerSelector ? this.closest(ownerSelector) : null;
        this.slidesPerView = !!slidesPerView ? +slidesPerView : undefined;
        this.slidesPerViewMobile = !!slidesPerViewMobile ? +slidesPerViewMobile : undefined;
        this.slidesToScroll = slidesToScroll ? +slidesToScroll : 1;
        this.autoscroll = autoscroll === 'true';
        this.autoscrollSpeed = autoscrollSpeed ? +autoscrollSpeed : 20;
        this.autoscrollDirection = autoscrollDirection ? +autoscrollDirection : 1;
        this.disableScroll = disableScroll === 'true';
        this.desktopOnly = desktopOnly === 'true';
        this.centered = isMobile$7() ? centeredMobile === 'true' : centered === 'true';
        this.skipSnap = skipSnap === 'true';
        this.dragFree = dragFree === 'true';
        this.disableTransform = disableTransform === 'true';
        this.autoSaveScroll = autoSaveScroll === 'true';
        this.containScroll = this.loop ? false : this.centered ? isMobile$7() ? 'keepSnaps' : 'trimSnaps' : 'trimSnaps';
        if (this.ownerEl) {
          this.customNextBtns = !!customNextBtnsSelector ? Array.from(this.ownerEl.querySelectorAll(customNextBtnsSelector)) : [];
          this.customPrevBtns = !!customPrevBtnsSelector ? Array.from(this.ownerEl.querySelectorAll(customPrevBtnsSelector)) : [];
        }
      };
      initializeElements = () => {
        try {
          const {
            carouselSlidesViewport,
            carouselPrev,
            carouselNext,
            carouselDotsContainer,
            carouselSlidesContainer,
            carouselStatus,
            carouselAutoplayToggle,
            carouselAutoplayPlayIcon,
            carouselAutoplayPauseIcon
          } = getElementByRef$m(['carousel-slides-viewport', 'carousel-prev', 'carousel-next', 'carousel-dots-container', 'carousel-slides-container', 'carousel-status', 'carousel-autoplay-toggle', 'carousel-autoplay-play-icon', 'carousel-autoplay-pause-icon'], this);
          this.viewport = carouselSlidesViewport;
          this.container = carouselSlidesContainer;
          if (!this.validateRequirements()) {
            throw new Error('ComponentCarousel minimum requirements are not met.');
          }
          this.dotsContainer = carouselDotsContainer;
          this.statusRegion = carouselStatus;
          this.autoplayToggle = carouselAutoplayToggle;
          this.autoplayPlayIcon = carouselAutoplayPlayIcon;
          this.autoplayPauseIcon = carouselAutoplayPauseIcon;
          this.nextBtn = carouselNext;
          this.prevBtn = carouselPrev;
          if (this.autoSaveScroll && this.id) this.loadSavedScroll();
        } catch (error) {}
      };
      setupEventListeners = () => {
        this.nextBtn?.addEventListener('click', this.handleNext, {
          signal: this.controller?.signal
        });
        this.prevBtn?.addEventListener('click', this.handlePrev, {
          signal: this.controller?.signal
        });
        this.customNextBtns.forEach(btn => btn.addEventListener('click', this.handleNext, {
          signal: this.controller?.signal
        }));
        this.customPrevBtns.forEach(btn => btn.addEventListener('click', this.handlePrev, {
          signal: this.controller?.signal
        }));
        this.autoplayToggle?.addEventListener('click', this.handleAutoplayToggle, {
          signal: this.controller?.signal
        });
        this.viewport?.addEventListener('mouseleave', this.handleMouseleave, {
          signal: this.controller?.signal
        });
        this.viewport?.addEventListener('focusout', this.handleFocusout, {
          signal: this.controller?.signal
        });
        this.viewport?.addEventListener('blur', this.handleBlur, {
          signal: this.controller?.signal
        });
        this.viewport?.addEventListener('touchend', this.handleTouchend, {
          signal: this.controller?.signal
        });
        if (!this.disableScroll && !EmblaPlugins.WheelGestures) this.viewport?.addEventListener('wheel', this.handleWheel, {
          signal: this.controller?.signal,
          passive: false
        });
        if (this.autoSaveScroll) {
          this.container?.addEventListener('click', this.handleSaveClickScroll, {
            signal: this.controller?.signal
          });
          window.addEventListener('pagehide', this.handleSavePagehideScroll, {
            signal: this.controller?.signal
          });
        }
      };
      validateRequirements() {
        if (!this.viewport) {
          return false;
        }
        if (!this.slides) {
          return false;
        }
        return true;
      }
      initializeIndexes = () => {
        if (this.dotsContainer) {
          this.dotsContainer.innerHTML = '';
          this.dots = [];
        }
        this.slides.forEach((slide, index) => {
          if (!slide) return;
          slide.dataset.index = index;
          slide.dataset.initialTabIndex = slide.tabIndex.toString();
          if (this.dotsContainer && !slide.dataset.dupOriginIndex) this.setDot(index);
        });
      };
      initializeCarousel = () => {
        if (!this.viewport) return;
        const hasSavedScroll = this.autoSaveScroll && this.savedLocation !== null && this.savedTransform !== null;
        const options = {
          loop: this.loop,
          align: this.centered ? 'center' : 'start',
          slidesToScroll: this.slideFullPage ? 'auto' : this.slidesToScroll,
          containScroll: this.containScroll,
          skipSnaps: this.skipSnap,
          dragFree: this.dragFree,
          direction: isRTL() ? 'rtl' : 'ltr',
          watchDrag: this.disableScroll ? false : () => this.isDragEnabled,
          watchResize: true,
          watchSlides: true,
          watchFocus: () => this.autoscrollPlugin?.stop(),
          inViewThreshold: this.disableTransform ? 1 : 0.5,
          breakpoints: {
            '(max-width: 1023px)': {
              active: !this.desktopOnly
            }
          },
          ...(hasSavedScroll ? {} : {
            startIndex: this.initialSnapIndex
          }),
          ...(prefersReducedMotion() ? {
            duration: 0
          } : {})
        };
        const plugins = this.setupPlugins();
        if (this.embla) this.embla.destroy();
        this.embla = EmblaCarousel(this.viewport, options, plugins);
        this.slides = this.embla.slideNodes();
        this.setupEmblaEvents();
        this.applySavedScroll();
        this.duplicateSlides();
        this.initializeIndexes();
      };
      applySavedScroll = () => {
        if (!this.autoSaveScroll || !this.embla || !this.container || this.savedLocation === null || this.savedTransform === null) return;
        const engine = this.embla.internalEngine();
        if (!engine) return;
        this.container.style.setProperty('transform', this.savedTransform);
        engine.location.set(+this.savedLocation);
        engine.target.set(+this.savedLocation);
        engine.scrollTo.distance(0, false);
        this.savedTransform = null;
        this.savedLocation = null;
      };
      loadSavedScroll = () => {
        const key = AUTO_SAVE_SCROLL_KEY(this.id);
        const raw = sessionStorage.getItem(key);
        sessionStorage.removeItem(key);
        if (!raw) return;
        try {
          const data = JSON.parse(raw);
          if (data.source === 'pagehide' && !isReloadNavigation()) return;
          this.savedTransform = data.transform;
          this.savedLocation = data.location;
        } catch (error) {}
      };
      handleSaveClickScroll = () => {
        this.clickSaved = true;
        this.saveScroll('click');
      };
      handleSavePagehideScroll = () => {
        if (this.clickSaved) return;
        this.saveScroll('pagehide');
      };
      saveScroll = source => {
        if (!this.embla || !this.id) return;
        const emblaLocation = this.embla.internalEngine().location.get();
        const payload = {
          transform: this.container?.style.transform || '',
          location: emblaLocation.toString(),
          source
        };
        sessionStorage.setItem(AUTO_SAVE_SCROLL_KEY(this.id), JSON.stringify(payload));
      };
      setDot = index => {
        const dot = document.createElement('button');
        dot.setAttribute('data-ref', 'carousel-dot');
        dot.setAttribute('data-index', index.toString());
        dot.setAttribute('type', 'button');
        dot.setAttribute('aria-label', this.formatSlideMessage(this.dataset.tGoToSlide, {
          i: index + 1
        }));
        dot.addEventListener('click', this.handleDotClick, {
          signal: this.controller?.signal
        });
        this.dotsContainer?.appendChild(dot);
        this.dots.push(dot);
      };
      setupPlugins = () => {
        const plugins = [];
        if (this.autoscroll && this.loop && !prefersReducedMotion()) {
          this.autoscrollPlugin = EmblaPlugins.AutoScroll({
            speed: this.autoscrollSpeed / 16,
            stopOnInteraction: true,
            stopOnFocusIn: true,
            stopOnMouseEnter: true,
            direction: this.autoscrollDirection === 1 ? 'forward' : 'backward',
            playOnInit: true,
            startDelay: 0
          });
          plugins.push(this.autoscrollPlugin);
        }
        if (!this.disableScroll && EmblaPlugins.WheelGestures) {
          this.wheelGesturesPlugin = EmblaPlugins.WheelGestures({
            forceWheelAxis: 'x'
          });
          plugins.push(this.wheelGesturesPlugin);
        }
        return plugins;
      };
      setupEmblaEvents = () => {
        if (!this.embla) return;
        this.embla.on('select', this.onSelect);
        this.embla.on('pointerDown', this.handlePointerDown);
        this.embla.on('init', this.onInit);
        this.embla.on('reInit', this.onReInit);
        this.embla.on('slidesInView', this.onSlideInView);
      };
      onInit = () => {
        this.updateDots();
        this.updateButtonsState();
      };
      onReInit = () => {
        this.updateDots();
        this.updateButtonsState();
      };
      logicalIndex = (slide, domIndex) => {
        const origin = slide?.dataset.dupOriginIndex;
        return origin ? +origin : domIndex;
      };
      formatSlideMessage = (template, values) => {
        if (!template) return '';
        return Object.entries(values).reduce((acc, [token, value]) => acc.split(`%${token}%`).join(String(value)), template);
      };
      visibleSlidesInVisualOrder = () => {
        if (!this.embla) return [];
        const rtl = isRTL();
        return this.embla.slidesInView().map(dom => ({
          dom,
          left: this.slides[dom]?.getBoundingClientRect().left ?? 0
        })).sort((a, b) => rtl ? b.left - a.left : a.left - b.left).map(({
          dom
        }) => ({
          dom,
          logical: this.logicalIndex(this.slides[dom], dom)
        }));
      };
      announceSlideChange = () => {
        if (!this.embla || !this.statusRegion || !this.userInteracted) return;
        if (this.autoscrollPlugin?.isPlaying()) return;
        const total = this.slides.filter(slide => slide && !slide.dataset.dupOriginIndex).length;
        if (!total) return;
        const visible = this.visibleSlidesInVisualOrder().filter(({
          logical
        }) => logical >= 0 && logical < total);
        if (!visible.length) return;
        const positions = visible.map(({
          logical
        }) => logical + 1);
        const first = positions[0];
        const last = positions[positions.length - 1];
        const isRun = positions.every((value, i) => i === 0 || value === positions[i - 1] + 1);
        const message = positions.length > 1 && isRun ? this.formatSlideMessage(this.dataset.tSlideRange, {
          i: first,
          j: last,
          n: total
        }) : this.formatSlideMessage(this.dataset.tSlidePosition, {
          i: first,
          n: total
        });
        if (!message || this.statusRegion.textContent === message) return;
        this.statusRegion.textContent = message;
      };
      onSelect = () => {
        this.updateDots();
        this.updateButtonsState();
        requestAnimationFrame(this.announceSlideChange);
        this.dispatchActiveSlideChangeEvent();
        if (this.id && this.id.includes('gallery')) {
          dispatchEvent$5(window, PDP_CAROUSEL_GALLERY_SWIPE, {
            carousel_id: this.id,
            state: this.dataset.trackingState
          });
        } else if (this.id && this.id.includes('packshot')) {
          dispatchEvent$5(window, PDP_CAROUSEL_PACKSHOT_SWIPE, {
            carousel_id: this.id,
            state: this.dataset.trackingState
          });
        }
      };
      handlePointerDown = () => {
        this.userInteracted = true;
      };
      onSlideInView = () => {
        const slidesInView = this.embla?.slidesInView();
        const slidesNotInView = this.embla?.slidesNotInView();
        this.updateTransformDisabled();
        if (!this.embla?.canScrollPrev() && !this.embla?.canScrollNext()) {
          this.dataset.centered = 'true';
        } else {
          this.dataset.centered = 'false';
        }
        if (this.dataset.ref && this.dataset.ref === 'fs-colors-carousel' && isMobile$7() && slidesInView && slidesInView.length < 5 && slidesNotInView && slidesNotInView.length === 0) {
          this.classList.add('mobile-centered');
        } else {
          this.classList.remove('mobile-centered');
        }
        if (this.classList.contains('reveal-manual')) {
          this.classList.add('is-revealed');
        }
        slidesInView?.forEach(slideIndex => this.setSlideAccessibility(this.slides[slideIndex], true));
        slidesNotInView?.forEach(slideIndex => this.setSlideAccessibility(this.slides[slideIndex], false));
      };
      updateTransformDisabled = () => {
        if (!this.container || !this.embla || !this.disableTransform) return;
        const allSlidesVisible = this.embla.slidesNotInView().length === 0;
        this.container.classList.toggle('transform-disabled', allSlidesVisible);
      };
      setSlideAccessibility = (slide, isVisible) => {
        if (!slide) return;
        if (!slide.dataset.initialTabIndex) slide.dataset.initialTabIndex = slide.tabIndex.toString() ?? '0';
        if (isVisible) {
          slide.setAttribute('tabindex', slide.dataset.initialTabIndex ?? '0');
          slide.setAttribute('aria-hidden', 'false');
          const restorable = slide.querySelectorAll(`${FOCUSABLE_SELECTORS}, [data-carousel-demoted]`);
          Array.from(restorable).forEach(child => {
            if (!child.dataset.initialTabIndex) child.dataset.initialTabIndex = child.tabIndex.toString() ?? '0';
            delete child.dataset.carouselDemoted;
            child.setAttribute('tabindex', child.dataset.initialTabIndex ?? '0');
          });
        } else {
          slide.setAttribute('tabindex', '-1');
          slide.setAttribute('aria-hidden', 'true');
          Array.from(slide.querySelectorAll(FOCUSABLE_SELECTORS)).forEach(child => {
            if (!child.dataset.initialTabIndex) child.dataset.initialTabIndex = child.tabIndex.toString() ?? '0';
            child.dataset.carouselDemoted = '';
            child.setAttribute('tabindex', '-1');
          });
        }
      };
      duplicateSlides = () => {
        if (!this.container || !this.loop || !this.slidesPerView && !this.slidesPerViewMobile) return;
        const minRequiredSlides = Math.max(this.slidesPerView ?? 0, this.slidesPerViewMobile ?? 0) + SLIDES_QTY_MARGIN;
        if (this.slides.length === 0 || this.slides.length >= minRequiredSlides) return;
        const originalSlides = this.slides.filter(slide => slide != undefined);
        while (this.slides.length < minRequiredSlides) {
          const dupSlides = originalSlides.map(slide => slide.cloneNode(true));
          dupSlides.forEach((slide, index) => {
            slide.dataset.dupOriginIndex = index.toString();
            if (this.container) this.container.appendChild(slide);
          });
          this.slides = this.slides.concat(dupSlides);
        }
      };
      handleNext = () => {
        if (this.loop && this.autoscroll) this.autoscrollPlugin?.stop();
        this.userInteracted = true;
        this.embla?.scrollNext();
      };
      handlePrev = () => {
        if (this.loop && this.autoscroll) this.autoscrollPlugin?.stop();
        this.userInteracted = true;
        this.embla?.scrollPrev();
      };
      resumeAutoscroll = () => {
        if (this.userPaused) return;
        this.autoscrollPlugin?.play();
      };
      handleMouseleave = () => this.resumeAutoscroll();
      handleFocusout = () => this.resumeAutoscroll();
      handleBlur = () => this.resumeAutoscroll();
      handleTouchend = () => this.resumeAutoscroll();
      handleAutoplayToggle = () => {
        if (!this.autoplayToggle) return;
        this.userPaused = !this.userPaused;
        if (this.userPaused) this.autoscrollPlugin?.stop();else this.autoscrollPlugin?.play();
        const {
          tPlay,
          tPause
        } = this.autoplayToggle.dataset;
        this.autoplayToggle.setAttribute('aria-label', (this.userPaused ? tPlay : tPause) ?? '');
        this.autoplayPlayIcon?.classList.toggle('hidden', !this.userPaused);
        this.autoplayPauseIcon?.classList.toggle('hidden', this.userPaused);
      };
      handleWheel = event => {
        if (!this.embla) return;
        const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (isHorizontalScroll) {
          event.preventDefault();
          if (event.deltaX > 0) {
            this.embla.scrollNext();
          } else if (event.deltaX < 0) {
            this.embla.scrollPrev();
          }
        }
      };
      handleDotClick = event => {
        const target = event.currentTarget;
        const dotIndex = target.dataset.index;
        if (!this.embla || !dotIndex) return;
        const selectedIndex = this.embla.selectedScrollSnap();
        const selectedSlide = this.slides[selectedIndex];
        const {
          dupOriginIndex
        } = selectedSlide.dataset;
        if (dupOriginIndex && +dupOriginIndex === dotIndex) return;
        this.userInteracted = true;
        this.embla.scrollTo(dotIndex);
      };
      updateDots = () => {
        if (!this.embla || !this.showDots || this.dots.length === 0) return;
        const selectedIndex = this.embla.selectedScrollSnap();
        const selectedSlide = this.slides[selectedIndex];
        const dotIndex = selectedSlide.dataset.dupOriginIndex ? +selectedSlide.dataset.dupOriginIndex : selectedIndex;
        this.dots.forEach((dot, index) => {
          const isActive = index === dotIndex;
          dot.classList.toggle('active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      };
      updateButtonsState = () => {
        if (!this.embla) return;
        const canScrollPrev = this.embla.canScrollPrev();
        const canScrollNext = this.embla.canScrollNext();
        const hasScrollContent = this.loop || canScrollPrev || canScrollNext;
        const disableScrollPrev = !canScrollPrev && !this.loop;
        const disableScrollNext = !canScrollNext && !this.loop;
        const setArrowsVisibility = visible => {
          const ariaHidden = visible ? 'false' : 'true';
          const updateAriaHidden = btn => {
            if (!btn) return;
            if (btn.getAttribute('tabindex') === '-1') btn.setAttribute('aria-hidden', 'true');else btn.setAttribute('aria-hidden', ariaHidden);
          };
          updateAriaHidden(this.prevBtn);
          updateAriaHidden(this.nextBtn);
          this.prevBtn?.classList.toggle('is-visible', visible);
          this.nextBtn?.classList.toggle('is-visible', visible);
          this.customPrevBtns.forEach(btn => {
            updateAriaHidden(btn);
            btn.classList.toggle('is-visible', visible);
          });
          this.customNextBtns.forEach(btn => {
            updateAriaHidden(btn);
            btn.classList.toggle('is-visible', visible);
          });
        };
        setArrowsVisibility(hasScrollContent);
        this.isDragEnabled = hasScrollContent;
        if (this.prevBtn) {
          this.prevBtn.disabled = disableScrollPrev;
          this.prevBtn.setAttribute('aria-disabled', disableScrollPrev.toString());
          this.customPrevBtns.forEach(btn => {
            btn.disabled = disableScrollPrev;
            btn.setAttribute('aria-disabled', disableScrollPrev.toString());
          });
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = disableScrollNext;
          this.nextBtn.setAttribute('aria-disabled', disableScrollNext.toString());
          this.customNextBtns.forEach(btn => {
            btn.disabled = disableScrollNext;
            btn.setAttribute('aria-disabled', disableScrollNext.toString());
          });
        }
      };
      dispatchActiveSlideChangeEvent = () => {
        if (!this.embla) return;
        const selectedIndex = this.embla.selectedScrollSnap();
        const activeSlide = this.slides[selectedIndex];
        if (activeSlide) {
          const event = new CustomEvent(ACTIVE_SLIDE_CHANGE, {
            detail: {
              slideIndex: selectedIndex,
              slide: activeSlide
            },
            bubbles: true
          });
          (this.ownerEl || this).dispatchEvent(event);
        }
      };
      scrollToIndex = (index, removeTransition = false) => {
        if (index >= this.slides.length || index < 0) return;
        this.embla?.scrollTo(index, removeTransition);
      };
      reInit = () => {
        this.embla?.reInit();
      };
      static define = () => {
        if (!customElements.get('component-carousel')) {
          customElements.define('component-carousel', ComponentCarousel);
        }
      };
    }
    var componentCarousel = () => {
      ComponentCarousel.define();
    };

    var componentCarousel$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentCarousel: ComponentCarousel,
        default: componentCarousel
    });

    const events$b = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$4
    } = window.PoleneLibs.Utils;
    const {
      ModalEvent
    } = window.PoleneLibs.ModalEvents;
    const {
      isMobile: isMobile$6
    } = window.PoleneLibs.Utils;
    class ComponentModal extends HTMLElement {
      static FOCUS_DELAY = 100;
      controller = undefined;
      backdrop = null;
      closeButton = null;
      extOpenTrigger = null;
      extCloseTrigger = null;
      focusTimeout = null;
      fsModalClassInitiallyPresent = false;
      triggerScope = 'parent';
      isOpen = false;
      hideMessengerPopup = false;
      focusTrap = null;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.triggerScope = this.dataset.triggerScope || 'parent';
        this.initializeElements();
        this.applyAccessibility();
      }
      updatedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.triggerScope = this.dataset.triggerScope || 'parent';
        this.isOpen = this.classList.contains('active') || this.classList.contains('closing');
        if (this.focusTimeout) {
          clearTimeout(this.focusTimeout);
          this.focusTimeout = null;
        }
        this.initializeElements();
        this.applyAccessibility();
      }
      disconnectedCallback() {
        document.body.style.overflow = '';
        this.controller?.abort();
      }
      initializeElements = () => {
        const {
          openSelector,
          closeSelector,
          hideMessengerPopup
        } = this.dataset;
        this.hideMessengerPopup = hideMessengerPopup === 'true';
        if (this.nextElementSibling?.matches('.component-modal__backdrop')) {
          const backdrop = this.nextElementSibling;
          if (backdrop) this.backdrop = backdrop;
        }
        this.closeButton = this.querySelector('.component-modal__close');
        const root = this.triggerScope === 'parent' ? this.parentElement : document;
        if (root) {
          if (!!openSelector) this.extOpenTrigger = root.querySelectorAll(openSelector);
          if (!!closeSelector) this.extCloseTrigger = root.querySelectorAll(closeSelector);
        }
        this.setupEventListeners();
      };
      setupEventListeners = () => {
        this.extOpenTrigger?.forEach(trigger => {
          trigger.addEventListener('click', () => this.open(trigger), {
            signal: this.controller?.signal
          });
        });
        this.extCloseTrigger?.forEach(trigger => {
          trigger.addEventListener('click', this.close, {
            signal: this.controller?.signal
          });
        });
        this.closeButton?.addEventListener('click', this.close, {
          signal: this.controller?.signal
        });
        this.addEventListener('click', this.handleOverlayClick, {
          signal: this.controller?.signal
        });
        if (this.backdrop) {
          this.backdrop.addEventListener('click', this.close, {
            signal: this.controller?.signal
          });
        }
      };
      applyAccessibility = () => {
        this.inert = !this.isOpen;
        this.removeEventListener('keydown', this.handleKeyDown);
        this.addEventListener('keydown', this.handleKeyDown, {
          signal: this.controller?.signal
        });
      };
      handleOverlayClick = e => {
        if (e.target === this) this.close();
      };
      handleKeyDown = e => {
        if (e.key === 'Escape') {
          this.close();
        }
      };
      open = trigger => {
        if (this.isOpen === true) return;
        if (document.body.classList.contains('fullscreen-active')) this.fsModalClassInitiallyPresent = true;
        if (this.dataset.fullscreen === 'true') document.body.classList.add('fullscreen-active');
        this.classList.add('active');
        this.inert = false;
        this.ariaHidden = 'false';
        document.body.style.overflow = 'hidden';
        this.isOpen = true;
        this.focusTrap = new FocusTrap(this);
        setTimeout(() => {
          this.focusTrap?.activate();
        }, ComponentModal.FOCUS_DELAY);
        if (isMobile$6() || this.hideMessengerPopup) {
          window?.zE?.('messenger', 'hide');
        }
        document.dispatchEvent(new ModalEvent(this.dataset.type || 'modal', 'open', trigger || null));
        if (this.dataset.type === 'bis') {
          const variantId = trigger?.dataset.variantid;
          const handle = trigger?.dataset.handle;
          const state = trigger?.dataset.trackingState ?? trigger?.dataset.state;
          dispatchEvent$4(window, events$b.TOGGLE_BIS, {
            variantId,
            handle,
            state
          });
        }
      };
      close = () => {
        this.classList.remove('active');
        this.classList.add('closing');
        this.focusTrap?.deactivate();
        setTimeout(() => {
          if (this.isOpen === false) return;
          if (this.dataset.fullscreen === 'true' && !this.fsModalClassInitiallyPresent) document.body.classList.remove('fullscreen-active');
          this.classList.remove('closing');
          this.inert = true;
          this.ariaHidden = 'true';
          document.body.style.overflow = '';
          if (this.focusTimeout) clearTimeout(this.focusTimeout);
          this.isOpen = false;
        }, ComponentModal.FOCUS_DELAY);
        if (isMobile$6() || this.hideMessengerPopup) {
          window?.zE?.('messenger', 'show');
        }
        document.dispatchEvent(new ModalEvent(this.dataset.type || 'modal', 'close', null));
      };
      reInit = () => {
        this.initializeElements();
      };
      static define() {
        if (!customElements.get('component-modal')) {
          customElements.define('component-modal', ComponentModal);
        }
      }
    }
    var componentModal = () => {
      ComponentModal.define();
    };

    var componentModal$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentModal: ComponentModal,
        default: componentModal
    });

    const {
      getElementByRef: getElementByRef$l
    } = window.PoleneLibs.Refs;
    class ComponentProductCard extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {}
      init() {
        this.handleImgLoad();
      }
      handleImgLoad = () => {
        const {
          productCardImg
        } = getElementByRef$l('product-card-img', this);
        if (!productCardImg) return;
        const {
          imgSrc
        } = productCardImg.dataset;
        const pImg = new Image();
        if (imgSrc) {
          pImg.src = imgSrc;
          pImg.addEventListener('load', () => {
            if (productCardImg?.parentNode instanceof HTMLElement) {
              productCardImg.parentNode.classList.add('is-visible');
            }
          });
        }
      };
      static define() {
        if (!customElements.get('component-product-card')) {
          customElements.define('component-product-card', ComponentProductCard);
        }
      }
    }
    var componentProductCard = () => {
      ComponentProductCard.define();
    };

    var componentProductCard$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductCard
    });

    const isPlainObject = value => typeof value === 'object' && value !== null && !Array.isArray(value);
    const normalizeVariantId = variantId => {
      const digits = String(variantId ?? '').match(/\d+/g);
      return digits ? digits[digits.length - 1] : null;
    };
    const persist = (merged, fresh) => {
      try {
        sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
          v: MIXPANEL_BRIDGE_VERSION,
          ...merged
        }));
      } catch {
        try {
          sessionStorage.removeItem(MIXPANEL_BRIDGE_KEY);
          sessionStorage.setItem(MIXPANEL_BRIDGE_KEY, JSON.stringify({
            v: MIXPANEL_BRIDGE_VERSION,
            ...fresh
          }));
        } catch {
          return;
        }
      }
    };
    const readBridge = () => {
      try {
        const raw = sessionStorage.getItem(MIXPANEL_BRIDGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return isPlainObject(parsed) ? parsed : {};
      } catch {
        return {};
      }
    };
    const writeBridgeFields = fields => {
      persist({
        ...readBridge(),
        ...fields
      }, fields);
    };
    const recordAtcSources = (variantIds, source) => {
      const ids = variantIds.map(normalizeVariantId).filter(id => id !== null);
      if (!ids.length) return;
      const now = Date.now();
      const fresh = {};
      ids.forEach(id => {
        fresh[id] = {
          source,
          ts: now
        };
      });
      const bridge = readBridge();
      const stored = isPlainObject(bridge.atc_sources) ? bridge.atc_sources : {};
      const kept = {};
      Object.entries(stored).forEach(([id, entry]) => {
        if (!isPlainObject(entry)) return;
        const {
          source: entrySource,
          ts
        } = entry;
        if (typeof entrySource !== 'string' || typeof ts !== 'number') return;
        if (now - ts > ATC_SOURCE_MAX_AGE) return;
        kept[id] = {
          source: entrySource,
          ts
        };
      });
      persist({
        ...bridge,
        atc_sources: {
          ...kept,
          ...fresh
        }
      }, {
        atc_sources: fresh
      });
    };

    const {
      wrappedLoader
    } = window.PoleneLibs.ElementTemplates;
    const events$a = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$3,
      parseProductForm
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$7,
      getElementByRef: getElementByRef$k
    } = window.PoleneLibs.Refs;
    const {
      morphSection
    } = window.PoleneLibs.SectionRenderer;
    const {
      dispatchCartError: dispatchCartError$1,
      cartErrorMessage: cartErrorMessage$1
    } = window.PoleneLibs.CartEvents;
    const root = window.Shopify?.routes.root;
    const selectors$4 = {
      cartCounter: '.js-cart-counter',
      variantInput: '.js-variant-input'
    };
    const fetchCart = async () => {
      try {
        const response = await fetch(root + 'cart.js', {
          method: 'GET'
        });
        const cart = await response.json().catch(() => null);
        if (!response.ok) {
          dispatchCartError$1({
            endpoint: 'cart.js',
            method: 'GET',
            status: response.status,
            message: cartErrorMessage$1(cart)
          });
        }
        if (cart) fetchHandler(cart);
      } catch (error) {
        dispatchCartError$1({
          endpoint: 'cart.js',
          method: 'GET',
          status: null,
          message: cartErrorMessage$1(error)
        });
      }
    };
    const updateCartContent = async (section, json) => {
      try {
        const cartComponent = document.querySelector('component-cart-items');
        const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
        await morphSection(sectionId, section);
        dispatchEvent$3(window, events$a.CART_UPDATED, json);
        dispatchEvent$3(window, events$a.CART_DOM_UPDATED);
      } catch (error) {
        const {
          cart
        } = getRefs$7();
        if (cart) {
          cart.innerHTML = section;
          setCartCount(0);
        }
      }
    };
    const fetchHandler = cart => {
      updateCartCount(cart);
      dispatchEvent$3(window, events$a.CART_FETCHED, cart);
    };
    const updateCartCount = cart => {
      setTimeout(() => {
        setCartCount(cart.item_count);
      });
    };
    const setCartCount = amount => {
      const counters = document.querySelectorAll(selectors$4.cartCounter);
      counters.forEach(counter => {
        const currentText = counter.innerHTML;
        const newText = counter.classList.contains('visually-hidden') ? currentText.replace(/\d+/, amount.toString()) : amount.toString();
        counter.innerHTML = newText;
      });
    };
    const triggeredProductForm = {};
    const handleAddToCart = async ({
      productForm,
      submitBtn,
      submitBtns
    }) => {
      const forms = Array.isArray(productForm) ? productForm : [productForm];
      const form = forms[0];
      const formData = new FormData(form);
      const items = parseProductForm(formData);
      const inputs = form.querySelectorAll('input');
      if (!submitBtn) return false;
      const uniqueBtns = new Set([submitBtn]);
      if (submitBtns) submitBtns.forEach(btn => uniqueBtns.add(btn));
      const allBtns = Array.from(uniqueBtns);
      const defaultStates = new Map();
      allBtns.forEach(btn => defaultStates.set(btn, btn.dataset.state));
      let eContainer;
      const states = {
        success: 'success',
        loading: 'loading',
        default: 'default',
        disabled: 'disabled'
      };
      if (submitBtn.dataset.state == states.disabled) {
        let variantId = null;
        if (!items.length) {
          variantId = form.querySelectorAll(selectors$4.variantInput)[0].value;
        } else {
          variantId = items[0].id;
          const hasOptions = form.getElementsByTagName('option');
          if (hasOptions && items[0].id === '0') {
            variantId = form.getElementsByTagName('option')[1].value;
          }
        }
        const handle = form.dataset.handle || form.querySelector('input[data-handle]')?.value || form.closest('[data-handle]')?.dataset.handle;
        dispatchEvent$3(window, events$a.TOGGLE_BIS, {
          variantId,
          handle
        });
        return false;
      }
      const btnParent = submitBtn.closest('.product-size-selector__actions, .product-add-to-cart, [data-ref="product-card"]');
      const formParent = form.closest('[data-ref="product-card"]') || form.closest('component-product-form') || form.nextElementSibling;
      const nextElementSibling = btnParent || formParent;
      if (nextElementSibling) {
        const {
          errorContainer
        } = getRefs$7(nextElementSibling);
        if (errorContainer) {
          eContainer = Array.isArray(errorContainer) ? errorContainer : [errorContainer];
        }
      }
      allBtns.forEach(btn => {
        if (!btn.firstElementChild) {
          btn.innerHTML = wrappedLoader;
        }
        btn.dataset.state = states.loading;
      });
      const cartComponent = document.querySelector('component-cart-items');
      const sectionId = cartComponent?.getAttribute('data-section-id') || 'main-cart';
      const resetBtnsState = () => {
        allBtns.forEach(btn => {
          const originalState = defaultStates.get(btn);
          if (originalState !== undefined) btn.dataset.state = originalState;
        });
      };
      const source = submitBtn.closest('[data-atc-source]')?.dataset.atcSource ?? ATC_SOURCE_FALLBACK;
      recordAtcSources(items.map(item => item?.id), source);
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: `${sectionId},cart-notification-content`
          })
        });
        const json = await response.json().catch(() => null);
        if (response.ok) {
          if (cartComponent && json.sections && json.sections[sectionId]) {
            await updateCartContent(json.sections[sectionId], json);
          }
          dispatchEvent$3(window, events$a.CART_UPDATED, json);
          allBtns.forEach(btn => {
            btn.dataset.state = states.success;
          });
          if (eContainer) eContainer.forEach(el => el.innerHTML = '');
          const buttonsWithLabels = [];
          allBtns.forEach(btn => {
            const {
              defaultLabel,
              successLabel
            } = getElementByRef$k(['default-label', 'success-label'], btn);
            if (defaultLabel && successLabel) {
              buttonsWithLabels.push({
                btn,
                defaultLabel,
                successLabel
              });
              defaultLabel.classList.add('is-hidden');
              defaultLabel.setAttribute('aria-hidden', 'true');
              successLabel.classList.remove('is-hidden');
              successLabel.setAttribute('aria-hidden', 'false');
            }
          });
          setTimeout(() => {
            buttonsWithLabels.forEach(({
              defaultLabel,
              successLabel
            }) => {
              defaultLabel.classList.remove('is-hidden');
              defaultLabel.setAttribute('aria-hidden', 'false');
              successLabel.classList.add('is-hidden');
              successLabel.setAttribute('aria-hidden', 'true');
            });
            resetBtnsState();
          }, 3000);
          const handleKey = form.dataset.handle;
          if (!handleKey) return true;
          if (handleKey in triggeredProductForm) {
            clearTimeout(triggeredProductForm[handleKey]);
            delete triggeredProductForm[handleKey];
          }
          triggeredProductForm[handleKey] = setTimeout(() => {
            resetBtnsState();
            inputs.forEach(input => {
              input.checked = false;
            });
            clearTimeout(triggeredProductForm[handleKey]);
            delete triggeredProductForm[handleKey];
          }, 3000);
          return true;
        } else {
          dispatchCartError$1({
            endpoint: 'cart/add.js',
            method: 'POST',
            status: response.status,
            message: cartErrorMessage$1(json)
          });
          resetBtnsState();
          if (eContainer && json?.description) {
            eContainer.forEach(el => {
              el.innerHTML = json.description;
              el.classList.add('is-visible');
            });
            setTimeout(() => {
              eContainer.forEach(el => {
                el.innerHTML = '';
                el.classList.remove('is-visible');
              });
            }, 5000);
          }
          return false;
        }
      } catch (error) {
        dispatchCartError$1({
          endpoint: 'cart/add.js',
          method: 'POST',
          status: null,
          message: cartErrorMessage$1(error)
        });
        resetBtnsState();
        return false;
      }
    };

    const {
      getElementByRef: getElementByRef$j,
      getElementsByRef: getElementsByRef$d
    } = window.PoleneLibs.Refs;
    const events$9 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$2,
      isMobile: isMobile$5,
      updateGlobalModals: updateGlobalModals$1
    } = window.PoleneLibs.Utils;
    const selectors$3 = {
      sizeSelector: '.js-size-selector',
      productForm: '.js-product-form',
      productAnchor: '.js-product-anchor',
      addToCart: '.js-add-to-cart',
      faveBtn: '.js-fave-btn'
    };
    const classes$7 = {
      preorderInput: 'preorder-note',
      mobile: 'is-mobile',
      preorderOverlay: 'is-preorder-overlay'
    };
    class ComponentProductForm extends HTMLElement {
      productForm = this.getElementsByTagName('form')[0];
      submitBtns = Array.from(this.querySelectorAll('button[type="submit"]'));
      formErrors = this.querySelector('[data-ref="form-errors"]');
      isProcessingAddToCart = false;
      resetTimeout = 0;
      formType = 'basic';
      isVariants = this.submitBtns.some(btn => btn.dataset.isVariants === 'true');
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        this.productForm.removeEventListener('input', this.handleFormChange);
        this.productForm.removeEventListener('submit', this.handleFormSubmit);
        if (this.productForm) {
          this.productForm.removeEventListener('input', this.handleFormChange);
        }
        const labels = this.querySelectorAll('.product-size-selector__variants__variant__label');
        labels.forEach(label => {
          label.removeEventListener('keydown', this.handleRadioLabelKeydown);
        });
      }
      init() {
        this.formType = this.dataset.formType || 'basic';
        if (this.productForm) {
          if (this.formType !== 'quick' || this.formType === 'quick' && !isMobile$5()) {
            this.productForm.addEventListener('input', this.handleFormChange);
            this.productForm.addEventListener('change', this.handleFormChange);
          }
          this.productForm.addEventListener('submit', this.handleFormSubmit);
        }
        if (this.submitBtns.length > 0) {
          this.submitBtns.forEach(btn => {
            btn.addEventListener('click', this.handleFormErrors);
          });
        }
        this.setupRadioLabelKeydown();
      }
      resetErrors = () => {
        if (this.formErrors) {
          this.formErrors.querySelectorAll('span').forEach(error => {
            error.classList.remove('is-visible');
          });
        }
      };
      handleFormErrors = event => {
        this.resetErrors();
        const target = event.currentTarget;
        if (target?.dataset.state === 'disabled') {
          const {
            errorNoSizeSelected
          } = getElementByRef$j('error-no-size-selected', this);
          if (errorNoSizeSelected) errorNoSizeSelected.classList.add('is-visible');
        }
      };
      setupRadioLabelKeydown = () => {
        const labels = this.querySelectorAll('.product-size-selector__variants__variant__label');
        if (labels.length > 0) {
          labels.forEach(label => {
            label.addEventListener('keydown', this.handleRadioLabelKeydown);
          });
        }
      };
      handleRadioLabelKeydown = event => {
        if (event.key !== 'Enter') return;
        const label = event.currentTarget;
        if (!label || !label.htmlFor) return;
        const radioButton = document.getElementById(label.htmlFor);
        if (radioButton && radioButton.type === 'radio' && this.productForm.contains(radioButton)) {
          event.preventDefault();
          radioButton.click();
        }
      };
      updatePreorderInputsState = targetElement => {
        const {
          preorderInputs: selectedPreorderInputs
        } = getElementByRef$j('preorder-inputs', targetElement);
        const {
          preorderInputs
        } = getElementsByRef$d('preorder-inputs', this.productForm);
        const allPreorderInputs = Array.isArray(preorderInputs) ? preorderInputs : [preorderInputs];
        const toggleInputsDisabled = (container, disabled) => {
          if (!container) return;
          container.querySelectorAll('input').forEach(input => {
            if (disabled) {
              input.setAttribute('disabled', 'true');
            } else {
              input.removeAttribute('disabled');
            }
          });
        };
        if (allPreorderInputs) {
          allPreorderInputs.forEach(preorderInput => {
            if (preorderInput) toggleInputsDisabled(preorderInput, true);
          });
        }
        if (selectedPreorderInputs) toggleInputsDisabled(selectedPreorderInputs, false);
      };
      isInCartNotification = () => {
        return Boolean(this.closest('[data-ref="cart-notification"]'));
      };
      handleFormChange = event => {
        this.resetErrors();
        if (!(event.target instanceof HTMLElement)) return;
        let dataset;
        let value;
        if (event.target instanceof HTMLSelectElement) {
          const selected = event.target.selectedOptions && event.target.selectedOptions[0];
          dataset = selected?.dataset;
          value = selected?.value || event.target.value;
          if (event.target.name !== 'id') {
            event.target.setAttribute('name', 'id');
          }
        } else if (event.target instanceof HTMLInputElement) {
          dataset = event.target.dataset;
          value = event.target.value;
        } else {
          return;
        }
        if (this.isProcessingAddToCart) return;
        if (event.target instanceof HTMLSelectElement && value) {
          let hiddenIdInput = this.productForm.querySelector('input[name="id"]');
          if (!hiddenIdInput) {
            hiddenIdInput = document.createElement('input');
            hiddenIdInput.type = 'hidden';
            hiddenIdInput.name = 'id';
            this.productForm.appendChild(hiddenIdInput);
          }
          hiddenIdInput.value = value;
        }
        if (event.target instanceof HTMLInputElement && event.target.type === 'radio' && event.target.name === 'variant_size') {
          const radioValue = event.target.value;
          if (radioValue) {
            let hiddenIdInput = this.productForm.querySelector('input[name="id"]');
            if (!hiddenIdInput) {
              hiddenIdInput = document.createElement('input');
              hiddenIdInput.type = 'hidden';
              hiddenIdInput.name = 'id';
              this.productForm.appendChild(hiddenIdInput);
            }
            hiddenIdInput.value = radioValue;
          }
        }
        if (dataset?.state && dataset?.label && this.submitBtns.length > 0) {
          this.submitBtns.forEach(btn => {
            const {
              defaultLabel
            } = getElementByRef$j('default-label', btn);
            if (defaultLabel) defaultLabel.textContent = dataset.label;
            btn.dataset.state = dataset.state;
            btn.classList.toggle('bis-modal-trigger', dataset.state === 'disabled');
            updateGlobalModals$1();
            if (event.target instanceof HTMLInputElement) btn.dataset.variantid = event.target.value;
          });
          const {
            productContext
          } = getElementByRef$j('product-context', this);
          if (productContext) {
            productContext.innerHTML = dataset?.context ? dataset.context : '&nbsp;';
          }
          const targetParent = event.target.parentElement;
          const scope = event.target instanceof HTMLSelectElement ? this.productForm : targetParent;
          if (scope) {
            this.updatePreorderInputsState(scope);
          }
        } else if (dataset?.availability == 'false') {
          const handle = this.dataset.handle;
          dispatchEvent$2(window, events$9.TOGGLE_BIS, {
            variantId: value,
            handle
          });
          return;
        }
        if (this.formType === 'quick' && this.submitBtns.length > 0 && this.submitBtns[0].dataset.state === 'active') {
          this.handleQuickAddToCart();
        }
        return;
      };
      handleQuickAddToCart = () => {
        if (!this.productForm || this.submitBtns.length === 0) return;
        const submitBtn = this.submitBtns[0];
        if (this.isProcessingAddToCart) return;
        if (submitBtn.dataset.state === 'inactive' || submitBtn.dataset.state === 'disabled' || submitBtn.dataset.state === 'modal' || submitBtn.dataset.state === 'coming-soon') {
          return;
        }
        if (this.classList.contains('quick-buy-form') && this.productForm.querySelector(selectors$3.sizeSelector) && isMobile$5() && !this.isInCartNotification()) {
          this.updateCartNotification(this.productForm, classes$7.mobile, 'variantSelector');
          return;
        }
        const preOrderInput = this.productForm.getElementsByClassName(classes$7.preorderInput);
        if (preOrderInput.length && isMobile$5()) {
          this.updateCartNotification(this.productForm, classes$7.preorderOverlay, 'preorder');
          return;
        }
        this.isProcessingAddToCart = true;
        handleAddToCart({
          productForm: this.productForm,
          submitBtn,
          submitBtns: this.submitBtns
        });
        setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 1000);
      };
      handleFormSubmit = async event => {
        this.resetErrors();
        if (!(event.currentTarget instanceof HTMLElement)) return;
        event.preventDefault();
        const productForm = event.currentTarget;
        const submitBtn = event.submitter;
        if (this.isProcessingAddToCart || !submitBtn || !productForm) return;
        const preOrderInput = productForm.getElementsByClassName(classes$7.preorderInput);
        if (this.isVariants && isMobile$5()) return;
        if (preOrderInput.length && isMobile$5()) {
          this.updateCartNotification(productForm, classes$7.preorderOverlay, 'preorder');
          return;
        }
        if (['inactive', 'modal', 'coming-soon'].includes(submitBtn.dataset.state ?? '')) {
          return;
        }
        this.isProcessingAddToCart = true;
        const success = await handleAddToCart({
          productForm,
          submitBtn,
          submitBtns: this.submitBtns
        });
        if (success && submitBtn.dataset.state !== 'disabled' && !isMobile$5()) {
          const parentModal = submitBtn.closest('component-modal');
          parentModal?.close?.();
        }
        setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 1000);
      };
      updateCartNotification = (form, className, state) => {
        if (this.isProcessingAddToCart) {
          clearTimeout(this.resetTimeout);
        }
        this.isProcessingAddToCart = true;
        const clone = form.cloneNode(true);
        let elementForNotification = clone;
        if (state === 'variantSelector') {
          elementForNotification = this.cloneNode(true);
        }
        const hostHandle = this?.dataset?.handle;
        const resolvedHandle = form?.dataset?.handle || hostHandle;
        if (resolvedHandle && elementForNotification?.setAttribute) {
          elementForNotification.setAttribute('data-handle', String(resolvedHandle));
        }
        this.resetTimeout = Number(setTimeout(() => {
          this.isProcessingAddToCart = false;
        }, 500));
      };
      static define() {
        if (!customElements.get('component-product-form')) {
          customElements.define('component-product-form', ComponentProductForm);
        }
      }
    }
    var componentProductForm = () => {
      ComponentProductForm.define();
    };

    var componentProductForm$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentProductForm
    });

    const {
      inertOutside: inertOutside$1,
      releaseInert: releaseInert$1
    } = window.PoleneLibs.Utils;
    class ComponentDrawer extends HTMLElement {
      previousActiveElement = null;
      trigger = null;
      backgroundInert = [];
      constructor() {
        super();
        this.elements = {
          closeButton: null,
          focusableElements: null
        };
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
        releaseInert$1(this.backgroundInert);
        this.backgroundInert = [];
      }
      initializeElements = () => {
        this.elements.closeButton = this.querySelector('[data-ref="drawer-close-btn"]');
        this.elements.focusableElements = Array.from(this.querySelectorAll(FOCUSABLE_SELECTORS));
      };
      setupEventListeners = () => {
        this.addEventListener('keydown', this.handleKeyDown);
        this.addEventListener('click', this.handleClick);
        this.elements.closeButton?.addEventListener('click', this.close);
      };
      removeEventListeners = () => {
        this.removeEventListener('keydown', this.handleKeyDown);
        this.removeEventListener('click', this.handleClick);
        this.elements.closeButton?.removeEventListener('click', this.close);
      };
      handleClick = e => {
        if (e.target === this) this.close();
      };
      handleKeyDown = e => {
        switch (e.key) {
          case 'Escape':
            this.close();
            break;
          case 'Tab':
            this.manageFocus(e);
            break;
          case 'Enter':
            this.manageEnter(e);
            break;
        }
      };
      manageEnter = e => {
        e.preventDefault();
        e.target?.dispatchEvent(new PointerEvent('click'));
      };
      manageFocus = e => {
        const elements = this.elements.focusableElements;
        if (!elements?.length) return;
        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];
        const isTabbing = !e.shiftKey;
        const isReverseTabbing = e.shiftKey;
        if (isReverseTabbing && document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        } else if (isTabbing && document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      };
      open = trigger => {
        this.previousActiveElement = document.activeElement ?? null;
        this.trigger = trigger ?? this.previousActiveElement;
        this.trigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('drawer-open');
        this.classList.add('active');
        this.ariaHidden = 'false';
        this.backgroundInert = inertOutside$1(this, document.body);
        setTimeout(() => {
          if (this.elements.focusableElements) this.elements.focusableElements[0].focus();
        }, 100);
        document.body.style.overflow = 'hidden';
      };
      close = () => {
        document.body.classList.remove('drawer-open');
        this.classList.remove('active');
        this.ariaHidden = 'true';
        releaseInert$1(this.backgroundInert);
        this.backgroundInert = [];
        this.trigger?.setAttribute('aria-expanded', 'false');
        const originalTrigger = this.trigger ?? this.previousActiveElement;
        originalTrigger?.focus();
        document.body.style.overflow = 'visible';
        window?.zE?.('messenger', 'show');
      };
      static define = () => {
        if (!customElements.get('component-drawer')) {
          customElements.define('component-drawer', ComponentDrawer);
        }
      };
    }
    var componentDrawer = () => {
      ComponentDrawer.define();
    };

    var componentDrawer$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentDrawer: ComponentDrawer,
        default: componentDrawer
    });

    const events$8 = window.PoleneLibs.Events.default;
    const {
      getElementsByRef: getElementsByRef$c,
      getRefs: getRefs$6
    } = window.PoleneLibs.Refs;
    const {
      storeLanguage
    } = window.PoleneLibs.ConstantsDate;
    const {
      getClientToken
    } = window.PoleneLibs.Utils;
    var componentNewsletterSignup = () => {
      const {
        newsletterSignup
      } = getElementsByRef$c('newsletter-signup');
      const newsletterSignups = Array.isArray(newsletterSignup) ? [...newsletterSignup] : [newsletterSignup];
      if (!newsletterSignup || newsletterSignups.length === 0) return;
      const cleaners = [];
      newsletterSignups.forEach(signupContainer => {
        const {
          signupForm,
          formInput,
          messageContainer
        } = getRefs$6(signupContainer);
        const {
          messageSuccess,
          messageError,
          messageAlreadySubscribed,
          messageNotValidEmail,
          klaviyoEventKey
        } = signupForm.dataset;
        if (!messageContainer || !signupForm || !formInput) return;
        const init = () => {
          setEventListeners();
        };
        const setEventListeners = () => {
          signupForm.addEventListener('submit', handleSubmit);
        };
        const removeEventListeners = () => {
          signupForm.removeEventListener('submit', handleSubmit);
        };
        const handleSubmit = async e => {
          e.preventDefault();
          if (!formInput) return;
          if (!validateEmail(formInput.value)) {
            messageContainer.innerHTML = `<p class="ts-error">${messageNotValidEmail}</p>`;
            formInput.setAttribute('aria-invalid', 'true');
            formInput.focus();
            return;
          }
          formInput.setAttribute('aria-invalid', 'false');
          messageContainer.innerHTML = '';
          const email = formInput.value;
          const formData = new FormData();
          formData.set('email', email);
          formData.set('locale', storeLanguage);
          if (klaviyoEventKey) formData.set('event', klaviyoEventKey);
          try {
            const clientToken = getClientToken();
            if (clientToken) formData.set('client_token', clientToken);
            const cartToken = await getCartToken();
            if (cartToken) formData.set('cart_token', cartToken);
            const response = await fetch(`${API_PROXY.MARKETING_SUBSCRIBE}`, {
              method: 'POST',
              body: formData
            });
            handleResponse(response, email);
          } catch {
            messageContainer.innerHTML = `<p class="ts-error">${messageError}</p>`;
          }
        };
        const handleResponse = async (res, email) => {
          if (res.status === 200) {
            messageContainer.innerHTML = `<p class="ts-label-m">${messageSuccess}</p>`;
            const event = new CustomEvent(events$8.NEWSLETTER_SUBSCRIBED, {
              detail: {
                source: 'footer',
                email
              }
            });
            window.dispatchEvent(event);
          } else if (res.status === 409) {
            messageContainer.innerHTML = `<p class="ts-label-m">${messageAlreadySubscribed}</p>`;
          } else {
            messageContainer.innerHTML = `<p class="ts-error">${messageError}</p>`;
          }
          formInput.value = '';
        };
        init();
        cleaners.push(removeEventListeners);
      });
      return () => {
        cleaners.forEach(cleanup => cleanup());
      };
    };

    var componentNewsletterSignup$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentNewsletterSignup
    });

    const {
      getElementByRef: getElementByRef$i
    } = window.PoleneLibs.Refs;
    const {
      isMobile: isMobile$4
    } = window.PoleneLibs.Utils;
    const events$7 = window.PoleneLibs.Events.default;
    class ComponentAccordion extends HTMLElement {
      static currentOpenByParent = new Map();
      controller = undefined;
      content = undefined;
      counter = undefined;
      observer = undefined;
      open = false;
      autoClose = false;
      autoCloseMobile = false;
      autoSetHiddenAttribute = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupCounter();
        this.setupAccordion();
        this.syncInitialState();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.buttonEl) {
          this.buttonEl.removeAttribute('data-accordion-initialized');
        }
        if (this.parentContainer) {
          const currentOpen = ComponentAccordion.currentOpenByParent.get(this.parentContainer);
          if (currentOpen === this) {
            ComponentAccordion.currentOpenByParent.delete(this.parentContainer);
          }
        }
      }
      initializeElements = () => {
        const {
          accordionCounter,
          accordionContent
        } = getElementByRef$i(['accordion-counter', 'accordion-content'], this);
        this.content = accordionContent;
        this.counter = accordionCounter;
        this.buttonEl = this.querySelector('button[aria-expanded]') ?? undefined;
        const controlsId = this.buttonEl?.getAttribute('aria-controls') ?? undefined;
        this.contentEl = controlsId ? this.querySelector(`#${CSS.escape(controlsId)}`) ?? undefined : undefined;
        this.closeIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-close') : undefined;
        this.openIconEl = this.buttonEl ? this.buttonEl?.querySelector('.icon-open') : undefined;
        this.open = this.buttonEl?.getAttribute('aria-expanded') === 'true';
        this.parentContainer = this.parentElement;
        this.autoClose = this.dataset.closeOthers === 'true' || this.parentContainer?.dataset.accordionCloseOthers === 'true';
        this.autoCloseMobile = this.dataset.closeOthersMobile === 'true' || this.parentContainer?.dataset.accordionCloseOthersMobile === 'true';
        this.autoSetHiddenAttribute = this.dataset.autoSetHiddenAttribute === 'true' || this.parentContainer?.dataset.accordionAutoSetHiddenAttribute === 'true';
        if (this.open && this.parentContainer) {
          ComponentAccordion.currentOpenByParent.set(this.parentContainer, this);
        }
      };
      setupCounter = () => {
        if (!this.content || !this.counter) return;
        this.counter.innerText = (this.content.childElementCount ?? 0).toString();
        this.observer = new MutationObserver(() => {
          if (this.content && this.counter) {
            this.counter.innerText = (this.content.childElementCount ?? 0).toString();
          }
        });
        this.observer.observe(this.content, {
          childList: true
        });
      };
      setupAccordion = () => {
        if (!this.buttonEl) return;
        if (this.buttonEl.hasAttribute('data-accordion-initialized')) {
          return;
        }
        this.buttonEl.setAttribute('data-accordion-initialized', 'true');
        this.buttonEl.addEventListener('click', this.onButtonClick, {
          signal: this.controller?.signal
        });
      };
      syncInitialState = () => {
        if (this.open) {
          const grandParentNode = this.buttonEl?.parentNode?.parentNode;
          if (grandParentNode) {
            grandParentNode.classList.add('active');
          }
          this.classList.add('active');
          if (this.contentEl instanceof HTMLElement) {
            this.contentEl.removeAttribute('hidden');
            this.contentEl.classList.remove('hidden');
            this.contentEl.tabIndex = 0;
          }
          if (this.closeIconEl) this.show(this.closeIconEl);
          if (this.openIconEl) this.hide(this.openIconEl);
        } else {
          this.classList.remove('active');
          const grandParentNode = this.buttonEl?.parentNode?.parentNode;
          if (grandParentNode) {
            grandParentNode.classList.remove('active');
          }
          if (this.autoSetHiddenAttribute) {
            if (this.contentEl instanceof HTMLElement) {
              this.contentEl.setAttribute('hidden', '');
              this.contentEl.tabIndex = -1;
            }
          } else {
            if (this.contentEl instanceof HTMLElement) {
              this.contentEl.classList.add('hidden');
              this.contentEl.tabIndex = -1;
            }
          }
          if (this.closeIconEl) this.hide(this.closeIconEl);
          if (this.openIconEl) this.show(this.openIconEl);
        }
      };
      onButtonClick = () => {
        const isMobileViewport = isMobile$4();
        const currentOpen = this.parentContainer ? ComponentAccordion.currentOpenByParent.get(this.parentContainer) : null;
        const closeCurrentOpenDesktop = !isMobileViewport && !this.open && currentOpen && this.autoClose;
        const closeCurrentOpenMobile = isMobileViewport && !this.open && currentOpen && this.autoCloseMobile;
        if (closeCurrentOpenDesktop || closeCurrentOpenMobile) {
          if (currentOpen && currentOpen !== this) {
            currentOpen.toggle(false);
          }
        }
        this.toggle(!this.open);
      };
      toggle = open => {
        if (open === this.open) {
          return;
        }
        this.open = open;
        if (this.parentContainer) {
          if (open) {
            ComponentAccordion.currentOpenByParent.set(this.parentContainer, this);
          } else {
            const currentOpen = ComponentAccordion.currentOpenByParent.get(this.parentContainer);
            if (currentOpen === this) {
              ComponentAccordion.currentOpenByParent.delete(this.parentContainer);
            }
          }
        }
        this.buttonEl?.setAttribute('aria-expanded', `${open}`);
        this.classList.toggle('active', open);
        const grandParentNode = this.buttonEl?.parentNode?.parentNode;
        if (grandParentNode) {
          grandParentNode.classList.toggle('active', open);
        }
        if (open) {
          this.contentEl?.removeAttribute('hidden');
          if (this.autoSetHiddenAttribute) ; else {
            this.contentEl?.classList.remove('hidden');
          }
          if (this.closeIconEl) this.show(this.closeIconEl);
          if (this.openIconEl) this.hide(this.openIconEl);
          if (this.contentEl instanceof HTMLElement) {
            this.contentEl.tabIndex = 0;
            this.contentEl.focus();
          }
          if (this.buttonEl) {
            const titleElement = this.buttonEl.querySelector('.component-accordion__title');
            const accordionTitle = titleElement?.innerText?.trim() || this.buttonEl.innerText?.trim() || '';
            window.dispatchEvent(new CustomEvent(events$7.ACCORDION_OPENED, {
              detail: {
                title: accordionTitle,
                state: this.dataset.trackingState
              }
            }));
          }
        } else {
          if (this.autoSetHiddenAttribute) {
            this.contentEl?.setAttribute('hidden', '');
          } else {
            this.contentEl?.classList.add('hidden');
          }
          if (this.closeIconEl) this.hide(this.closeIconEl);
          if (this.openIconEl) this.show(this.openIconEl);
          if (this.contentEl instanceof HTMLElement) {
            this.contentEl.tabIndex = -1;
          }
        }
      };
      hide = element => {
        element.classList.add('hidden');
        element.ariaHidden = 'true';
      };
      show = element => {
        element.classList.remove('hidden');
        element.ariaHidden = 'false';
      };
      setOpen = () => {
        this.toggle(true);
      };
      setClose = () => {
        this.toggle(false);
      };
      static define = () => {
        if (!customElements.get('component-accordion')) customElements.define('component-accordion', ComponentAccordion);
      };
    }
    var componentAccordion = () => {
      ComponentAccordion.define();
    };

    var componentAccordion$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentAccordion
    });

    const {
      getElementsByRef: getElementsByRef$b
    } = window.PoleneLibs.Refs;
    class ComponentTabs extends HTMLElement {
      tabs = [];
      panels = [];
      activePanel = undefined;
      activeTab = undefined;
      isLastInFocusTrap = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          tab,
          tabPanel
        } = getElementsByRef$b(['tab', 'tab-panel'], this);
        if (!tab || !tabPanel) return;
        this.tabs = Array.isArray(tab) ? tab : [tab];
        this.panels = Array.isArray(tabPanel) ? tabPanel : [tabPanel];
        this.activeTab = this.tabs.find(trigger => trigger?.classList.contains('active'));
        this.activePanel = this.panels.find(panel => panel?.classList.contains('active') && this.activeTab?.dataset.panelId === panel.id);
        this.isLastInFocusTrap = this.dataset.isLastInFocusTrap === 'true';
      };
      setupEventListeners = () => {
        this.tabs.forEach(tab => tab?.addEventListener('click', this.handleClick));
      };
      removeEventListeners = () => {
        this.tabs.forEach(tab => tab?.removeEventListener('click', this.handleClick));
      };
      setupAccessibility = () => {
        if (this.isLastInFocusTrap) {
          this.panels.forEach(panel => {
            if (panel && panel.lastElementChild) panel.lastElementChild.setAttribute('data-is-last-focus', 'true');
          });
        }
      };
      handleClick = event => {
        const triggeredTab = event.currentTarget;
        const {
          panelId
        } = triggeredTab.dataset;
        if (triggeredTab === this.activeTab) return;
        this.switchTab(triggeredTab);
        if (panelId) this.switchPanel(panelId);
      };
      switchTab = targetTab => {
        if (this.activeTab) {
          this.activeTab.classList.remove('active');
          this.activeTab.ariaSelected = 'false';
        }
        if (!targetTab.classList.contains('active')) {
          targetTab.classList.add('active');
          targetTab.ariaSelected = 'true';
        }
        this.activeTab = targetTab;
      };
      switchPanel = targetPanelId => {
        const newActivePanel = this.panels.find(panel => targetPanelId === panel?.id);
        if (this.activePanel) {
          this.activePanel.classList.remove('active');
          this.activePanel.ariaHidden = 'true';
        }
        if (newActivePanel && !newActivePanel.classList.contains('active')) {
          newActivePanel.classList.add('active');
          newActivePanel.ariaHidden = 'false';
          this.activePanel = newActivePanel;
        }
      };
      static define = () => {
        if (!customElements.get('component-tabs')) {
          customElements.define('component-tabs', ComponentTabs);
        }
      };
    }
    var componentTabs = () => {
      ComponentTabs.define();
    };

    var componentTabs$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentTabs: ComponentTabs,
        default: componentTabs
    });

    class ComponentSnackbar extends HTMLElement {
      autoHideDuration = 3000;
      hideTimer = undefined;
      showTimer = undefined;
      static snackbarInstances = {};
      static defaultSnackbar = null;
      static activeSnackbar = null;
      static SHOW_DELAY = 300;
      static LIVE_REGION_ID = 'snackbar-live-region';
      static ANNOUNCE_DELAY = 50;
      constructor() {
        super();
      }
      connectedCallback() {
        this.autoHideDuration = this.dataset.displayDuration ? +this.dataset.displayDuration : this.autoHideDuration;
      }
      resetActiveSnackbar = () => {
        clearTimeout(this.showTimer);
        this.showTimer = undefined;
        ComponentSnackbar.activeSnackbar?.dismiss();
        ComponentSnackbar.activeSnackbar = null;
      };
      static announce = message => {
        if (!message) return;
        let region = document.getElementById(ComponentSnackbar.LIVE_REGION_ID);
        if (!region) {
          region = document.createElement('div');
          region.id = ComponentSnackbar.LIVE_REGION_ID;
          region.className = 'sr-only';
          region.setAttribute('role', 'status');
          region.setAttribute('aria-live', 'polite');
          document.body.appendChild(region);
        }
        region.textContent = '';
        window.setTimeout(() => {
          region.textContent = message;
        }, ComponentSnackbar.ANNOUNCE_DELAY);
      };
      show = innerHTML => {
        const isSnackbarActive = !!ComponentSnackbar.activeSnackbar;
        this.resetActiveSnackbar();
        if (innerHTML) this.innerHTML = innerHTML;
        ComponentSnackbar.announce(this.textContent?.trim() ?? '');
        this.showTimer = setTimeout(() => {
          this.classList.add('active');
          ComponentSnackbar.activeSnackbar = this;
        }, isSnackbarActive ? ComponentSnackbar.SHOW_DELAY : 0);
        this.hideTimer = setTimeout(() => {
          this.resetActiveSnackbar();
        }, isSnackbarActive ? ComponentSnackbar.SHOW_DELAY + this.autoHideDuration : this.autoHideDuration);
      };
      dismiss = () => {
        clearTimeout(this.hideTimer);
        this.classList.remove('active');
        this.hideTimer = undefined;
      };
      static open = ({
        templateId,
        innerHTML
      }) => {
        const selector = `component-snackbar${templateId ? '#snackbar-' + templateId : ''}`;
        let instance = null;
        if (templateId) instance = this.snackbarInstances[templateId] ?? document.body.querySelector(selector);else {
          if (!this.defaultSnackbar) this.defaultSnackbar = document.body.querySelector(selector);
          instance = this.defaultSnackbar;
        }
        if (instance) instance.show(innerHTML);
      };
      static define() {
        if (!customElements.get('component-snackbar')) customElements.define('component-snackbar', ComponentSnackbar);
      }
    }
    var componentSnackbar = () => {
      ComponentSnackbar.define();
    };

    var componentSnackbar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentSnackbar: ComponentSnackbar,
        default: componentSnackbar
    });

    const SnackbarTemplate = {
      ERROR: 'error',
      ADD_TO_WISHLIST: 'add-to-wishlist',
      REMOVE_FROM_WISHLIST: 'remove-from-wishlist'
    };

    const {
      getElementByRef: getElementByRef$h
    } = window.PoleneLibs.Refs;
    class ComponentAddToWishlist extends HTMLElement {
      isInWishlist = false;
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.updateWishlistState();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      disconnectedCallback() {
        this.controller.abort();
      }
      updatedCallback() {
        this.controller.abort();
        this.controller = new AbortController();
        this.initializeElements();
        this.updateWishlistState();
        this.setupEventListeners();
        this.setupAccessibility();
      }
      initializeElements = () => {
        const {
          iconHeartFilled,
          buttonTextAdd,
          buttonTextAlready
        } = getElementByRef$h(['icon-heart-filled', 'button-text-add', 'button-text-already'], this);
        this.buttonTextAdd = buttonTextAdd;
        this.buttonTextAlready = buttonTextAlready;
        this.iconHeartFilled = iconHeartFilled;
        this.productId = this.dataset.productId;
      };
      emitWishlistEvent = eventName => {
        const handle = this.dataset.productHandle;
        if (!handle) {
          return;
        }
        window.dispatchEvent(new CustomEvent(eventName, {
          detail: {
            handle,
            productId: this.productId,
            state: this.dataset.trackingState
          }
        }));
      };
      setupEventListeners = () => {
        this.addEventListener('click', this.handleClick, {
          signal: this.controller.signal
        });
      };
      setupAccessibility = () => {
        this.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleClick(e);
          }
        }, {
          signal: this.controller.signal
        });
      };
      updateWishlistState = () => {
        if (!this.productId) return;
        this.isInWishlist = Wishlist.isInWishlist(this.productId);
        this.syncUI();
      };
      syncUI = () => {
        const {
          buttonTextAdd,
          buttonTextAlready
        } = this;
        this.iconHeartFilled?.classList.toggle('hidden', !this.isInWishlist);
        if (buttonTextAdd && buttonTextAlready) {
          buttonTextAdd.classList.toggle('hidden', this.isInWishlist);
          buttonTextAlready.classList.toggle('hidden', !this.isInWishlist);
          this.classList.toggle('already', this.isInWishlist);
          if (this.isInWishlist) {
            this.removeAttribute('role');
            this.removeAttribute('aria-pressed');
            this.removeAttribute('aria-label');
            return;
          }
          this.setAttribute('role', 'button');
        }
        this.ariaPressed = String(this.isInWishlist);
        if (this.dataset.addLabel) this.ariaLabel = this.dataset.addLabel;
      };
      handleClick = async e => {
        e.preventDefault();
        if (e.target instanceof HTMLAnchorElement) {
          window.location.href = e.target.href;
          return;
        }
        if (this.isInWishlist && this.buttonTextAlready) {
          return;
        }
        if (!this.productId || !this.iconHeartFilled) return;
        this.iconHeartFilled.classList.toggle('hidden', this.isInWishlist);
        if (this.buttonTextAlready && this.buttonTextAdd) {
          this.buttonTextAdd.classList.toggle('hidden');
          this.buttonTextAlready.classList.toggle('hidden');
          this.classList.toggle('already');
        }
        const success = await (this.isInWishlist ? Wishlist.remove(this.productId) : Wishlist.add(this.productId));
        if (success) {
          this.isInWishlist = !this.isInWishlist;
          ComponentSnackbar.open({
            templateId: this.isInWishlist ? SnackbarTemplate.ADD_TO_WISHLIST : SnackbarTemplate.REMOVE_FROM_WISHLIST
          });
          this.emitWishlistEvent(this.isInWishlist ? 'WISHLIST_ADDED' : 'WISHLIST_REMOVED');
        } else ComponentSnackbar.open({
          templateId: SnackbarTemplate.ERROR
        });
        this.syncUI();
      };
      static define = () => {
        if (!customElements.get('component-add-to-wishlist')) customElements.define('component-add-to-wishlist', ComponentAddToWishlist);
      };
    }
    var componentAddToWishlist = () => {
      ComponentAddToWishlist.define();
    };

    var componentAddToWishlist$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentAddToWishlist
    });

    const {
      isMobile: isMobile$3
    } = window.PoleneLibs.Utils;
    const {
      getElementsByRef: getElementsByRef$a,
      getElementByRef: getElementByRef$g
    } = window.PoleneLibs.Refs;
    class ComponentQuickAdd extends HTMLElement {
      abortController = undefined;
      variantBtns = [];
      quickAddBtn = null;
      isVariants = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      initializeElements = () => {
        const {
          quickAddBtn
        } = getElementByRef$g('quick-add-btn', this);
        const {
          quickAddVariantBtn
        } = getElementsByRef$a('quick-add-variant-btn', this);
        if (!quickAddBtn || !quickAddVariantBtn) return;
        this.variantBtns = Array.isArray(quickAddVariantBtn) ? quickAddVariantBtn : [quickAddVariantBtn];
        this.quickAddBtn = quickAddBtn;
        this.isVariants = quickAddBtn.dataset.isVariants === 'true';
        this.handleQuickAddBtnState();
      };
      setupEventListeners = () => {
        window.addEventListener('resize', this.handleQuickAddBtnState, {
          signal: this.abortController?.signal
        });
        this.variantBtns.forEach(variant => {
          variant.addEventListener('mouseenter', this.handleVariantMouseEnter, {
            signal: this.abortController?.signal
          });
          variant.addEventListener('mouseleave', this.handleVariantMouseLeave, {
            signal: this.abortController?.signal
          });
          variant.addEventListener('click', this.handleVariantClick, {
            signal: this.abortController?.signal
          });
        });
      };
      handleQuickAddBtnState = () => {
        if (!this.quickAddBtn || this.isVariants === false) return;
        if (isMobile$3()) this.quickAddBtn.disabled = false;else this.quickAddBtn.disabled = true;
      };
      handleVariantClick = event => {
        const clickedBtn = event.currentTarget;
        this.variantBtns.forEach(btn => {
          const isClicked = btn === clickedBtn;
          btn.querySelectorAll('input[type="hidden"]').forEach(input => {
            input.disabled = !isClicked;
          });
        });
      };
      handleVariantMouseEnter = event => {
        const inputs = event.currentTarget.querySelectorAll('input[type="hidden"]');
        inputs.forEach(input => input.disabled = false);
      };
      handleVariantMouseLeave = event => {
        const inputs = event.currentTarget.querySelectorAll('input[type="hidden"]');
        inputs.forEach(input => input.disabled = true);
      };
      static define = () => {
        if (!customElements.get('component-quick-add')) {
          customElements.define('component-quick-add', ComponentQuickAdd);
        }
      };
    }
    var componentQuickAdd = () => {
      ComponentQuickAdd.define();
    };

    var componentQuickAdd$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentQuickAdd: ComponentQuickAdd,
        default: componentQuickAdd
    });

    const Events = window.PoleneLibs.Events.default;
    const scrollLock$4 = window.PoleneLibs.ScrollLock.default;
    const {
      isMobile: isMobile$2,
      throttle
    } = window.PoleneLibs.Utils;
    const {
      getRefs: getRefs$5
    } = window.PoleneLibs.Refs;
    const {
      morph: morph$2
    } = window.PoleneLibs.DOMMorph;
    const classes$6 = {
      active: 'is-active',
      visible: 'is-visible',
      preorderInput: 'preorder-note'
    };
    const states = {
      variantSelector: 'variant-selector',
      productAdded: 'product-added',
      preorder: 'preorder'
    };
    class ComponentCartNotification extends HTMLElement {
      xDown = null;
      yDown = null;
      isOpen = false;
      isProcessingCartUpdate = false;
      refs = null;
      autoCloseTimer = null;
      constructor() {
        super();
        this.controller = new AbortController();
      }
      connectedCallback() {
        this.refs = getRefs$5(this);
        this.controller = new AbortController();
        this.setEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.cancelAutoClose();
      }
      setEventListeners() {
        window.addEventListener(Events.CART_UPDATED, this.handleCartUpdated, {
          signal: this.controller?.signal
        });
        document.addEventListener('touchstart', this.handleTouchStart, {
          signal: this.controller?.signal
        });
        document.addEventListener('touchmove', throttle(this.handleTouchMove, TIMEOUTS.DELAY_50), {
          signal: this.controller?.signal
        });
        this.addEventListener('click', this.handleClick, {
          signal: this.controller?.signal
        });
      }
      handleCartUpdated = async e => {
        if (window.location.pathname.includes('/cart')) {
          this.closePopUp();
          return;
        }
        if (this.isProcessingCartUpdate || !e.detail?.sections?.['cart-notification-content']) return;
        this.isProcessingCartUpdate = true;
        this.cancelAutoClose();
        let parser = new DOMParser();
        let markup = parser.parseFromString(e.detail.sections['cart-notification-content'], 'text/html');
        const itemKey = e.detail.items?.[0]?.key;
        let updatedContent = markup.documentElement.querySelector(itemKey ? `[id="cart-notification-product-${itemKey}"]` : '[id^="cart-notification-product-"]');
        if (updatedContent) this.morphContent(updatedContent);
        this.openPopUp(states.productAdded);
        this.scheduleAutoClose();
        setTimeout(() => {
          this.isProcessingCartUpdate = false;
        }, TIMEOUTS.DELAY_500);
      };
      closePopUp = () => {
        this.updateState(false);
        const delay = isMobile$2() ? TIMEOUTS.DELAY_150 : TIMEOUTS.DELAY_600;
        this.classList.remove(classes$6.active);
        this.setAttribute('aria-hidden', 'true');
        this.refs?.notificationProduct?.classList.remove(classes$6.visible);
        this.cancelAutoClose();
        setTimeout(() => {
          this.isProcessingCartUpdate = false;
        }, delay);
      };
      openPopUp = state => {
        this.updateState(true);
        this.dataset.state = state;
        this.classList.add(classes$6.active);
        this.setAttribute('aria-hidden', 'false');
        if (state == states.productAdded || state == states.preorder || state == states.variantSelector) {
          this.refs?.notificationProduct?.classList.add(classes$6.visible);
        }
      };
      updateState = state => {
        this.isOpen = state;
        if (isMobile$2()) {
          scrollLock$4(state);
        }
      };
      morphContent = newContent => {
        if (this.refs?.notificationProduct) morph$2(this.refs.notificationProduct, newContent);
      };
      handleClick = e => {
        const target = e.target;
        const closeBtn = target.closest('[data-ref="close-btn"]');
        const notificationBg = target.closest('[data-ref="notification-bg"]');
        if (closeBtn || notificationBg) {
          this.closePopUp();
          return;
        }
      };
      getTouches = e => {
        return e.touches || e.originalEvent.touches;
      };
      handleTouchStart = e => {
        if (!this.isOpen) return;
        const firstTouch = this.getTouches(e)[0];
        this.xDown = firstTouch.clientX;
        this.yDown = firstTouch.clientY;
      };
      handleTouchMove = e => {
        if (!this.xDown || !this.yDown || !this.isOpen) {
          return;
        }
        const xUp = e.touches[0].clientX;
        const yUp = e.touches[0].clientY;
        const xDiff = this.xDown - xUp;
        const yDiff = this.yDown - yUp;
        if (Math.abs(xDiff) < Math.abs(yDiff)) {
          if (yDiff > 0) {
            return;
          } else {
            this.closePopUp();
          }
        }
        this.xDown = null;
        this.yDown = null;
      };
      scheduleAutoClose = () => {
        this.cancelAutoClose();
        this.autoCloseTimer = setTimeout(this.closePopUp, TIMEOUTS.DELAY_4000);
      };
      cancelAutoClose = () => {
        if (!this.autoCloseTimer) return;
        clearTimeout(this.autoCloseTimer);
        this.autoCloseTimer = null;
      };
      static define() {
        if (!customElements.get('component-cart-notification')) {
          customElements.define('component-cart-notification', ComponentCartNotification);
        }
      }
    }
    var componentCartNotification = () => {
      ComponentCartNotification.define();
    };

    var componentCartNotification$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentCartNotification: ComponentCartNotification,
        default: componentCartNotification
    });

    const {
      dispatchCartError,
      cartErrorMessage
    } = window.PoleneLibs.CartEvents;
    const getCartLineItems = async () => {
      try {
        const response = await fetch(`${ROOT_PATH}cart.js`);
        if (!response.ok) {
          dispatchCartError({
            endpoint: 'cart.js',
            method: 'GET',
            status: response.status,
            message: `HTTP ${response.status}`
          });
          return [];
        }
        const cart = await response.json();
        if (!Array.isArray(cart?.items)) return [];
        return cart.items.reduce((acc, item) => {
          const variantId = item?.variant_id;
          const quantity = item?.quantity;
          if (typeof variantId === 'number' && typeof quantity === 'number') {
            acc.push({
              variant_id: variantId,
              quantity
            });
          }
          return acc;
        }, []);
      } catch (error) {
        dispatchCartError({
          endpoint: 'cart.js',
          method: 'GET',
          status: null,
          message: cartErrorMessage(error)
        });
        return [];
      }
    };

    const pingCartBinding = async (clientToken, cartToken, lineItems) => {
      try {
        await fetch(API_PROXY.CART_IDENTITY, {
          method: 'POST',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            client_token: clientToken,
            cart_token: cartToken,
            line_items: lineItems
          })
        });
      } catch {}
    };

    var cartBindingPing = () => {
      const {
        getClientToken
      } = window.PoleneLibs.Utils;
      const Events = window.PoleneLibs.Events.default;
      const controller = new AbortController();
      const ping = async () => {
        const clientToken = getClientToken();
        if (!clientToken) return;
        const cartToken = await getCartToken();
        if (!cartToken) return;
        const lineItems = await getCartLineItems();
        await pingCartBinding(clientToken, cartToken, lineItems);
      };
      ping();
      window.addEventListener(Events.CART_UPDATED, ping, {
        signal: controller.signal
      });
      return () => controller.abort();
    };

    var cartBindingPing$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: cartBindingPing
    });

    const getExchangeId = () => {
      const {
        getCookie
      } = window.PoleneLibs.Utils;
      const exchangeIdFromUrl = new URLSearchParams(window.location.search).get(KLAVIYO_EXCHANGE_ID_PARAM);
      if (exchangeIdFromUrl) return exchangeIdFromUrl;
      const cookieValue = getCookie(KLAVIYO_ID_COOKIE_NAME);
      if (!cookieValue) return null;
      try {
        const decoded = JSON.parse(atob(decodeURIComponent(cookieValue)));
        const exchangeId = decoded?.$exchange_id;
        return typeof exchangeId === 'string' && exchangeId ? exchangeId : null;
      } catch {
        return null;
      }
    };

    const readConsent = kind => {
      const customerPrivacy = window.Shopify?.customerPrivacy;
      if (kind === 'analytics') return customerPrivacy?.analyticsProcessingAllowed() === true;
      return customerPrivacy?.marketingAllowed() === true;
    };
    const isConsentAllowed = kind => new Promise(resolve => {
      let settled = false;
      const settle = allowed => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timeoutId);
        resolve(allowed);
      };
      const timeoutId = window.setTimeout(() => settle(false), TRACKING_CONSENT_TIMEOUT);
      try {
        const shopify = window.Shopify;
        if (!shopify?.loadFeatures) return settle(false);
        shopify.loadFeatures([CONSENT_TRACKING_API_FEATURE], error => {
          if (error) return settle(false);
          try {
            settle(readConsent(kind));
          } catch {
            settle(false);
          }
        });
      } catch {
        settle(false);
      }
    });

    const postKlaviyoResolver = async (clientToken, exchangeId, cartToken) => {
      try {
        await fetch(API_PROXY.KLAVIYO_RESOLVER, {
          method: 'POST',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            client_token: clientToken,
            exchange_id: exchangeId,
            ...(cartToken ? {
              cart_token: cartToken
            } : {})
          })
        });
      } catch {}
    };

    const hasAlreadyResolved = exchangeId => {
      try {
        return sessionStorage.getItem(KLAVIYO_EXCHANGE_ID_SESSION_KEY) === exchangeId;
      } catch {
        return false;
      }
    };
    const rememberResolved = exchangeId => {
      try {
        sessionStorage.setItem(KLAVIYO_EXCHANGE_ID_SESSION_KEY, exchangeId);
      } catch {}
    };
    var klaviyoIdentityResolve = () => {
      const exchangeId = getExchangeId();
      if (!exchangeId) return;
      const {
        getClientToken
      } = window.PoleneLibs.Utils;
      const controller = new AbortController();
      const resolveIdentity = async () => {
        if (hasAlreadyResolved(exchangeId)) return;
        const consentEnforced = window.P1?.themeSettings?.devSettings?.featureRespectMarketingConsent !== false;
        const [marketingAllowed, cartToken] = await Promise.all([consentEnforced ? isConsentAllowed('marketing') : Promise.resolve(true), getCartToken()]);
        if (!marketingAllowed) return;
        if (hasAlreadyResolved(exchangeId)) return;
        const clientToken = getClientToken();
        if (!clientToken) return;
        rememberResolved(exchangeId);
        await postKlaviyoResolver(clientToken, exchangeId, cartToken);
      };
      resolveIdentity();
      document.addEventListener(VISITOR_CONSENT_COLLECTED_EVENT, resolveIdentity, {
        signal: controller.signal
      });
      return () => controller.abort();
    };

    var klaviyoIdentityResolve$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: klaviyoIdentityResolve
    });

    var sessionReplay = () => {
      const config = window.P1?.themeSettings?.mixpanelSessionReplay;
      writeBridgeFields({
        mp_replay_id: undefined
      });
      if (!config?.enabled || !config.token || !config.percent) return;
      const controller = new AbortController();
      const {
        signal
      } = controller;
      const consentEnforced = config.respectConsent !== false;
      let consented = false;
      let sdkRequested = false;
      let instance = null;
      let intervalId;
      let lastReplayId = null;
      const syncReplayId = loaded => {
        const replayId = loaded.get_session_recording_properties().$mp_replay_id ?? null;
        if (replayId === lastReplayId) return;
        lastReplayId = replayId;
        writeBridgeFields({
          mp_replay_id: replayId ?? undefined
        });
      };
      const stopReplayIdSync = () => {
        window.clearInterval(intervalId);
        intervalId = undefined;
      };
      const stopRecording = () => {
        if (!instance) return;
        instance.stop_session_recording();
        stopReplayIdSync();
        lastReplayId = null;
        writeBridgeFields({
          mp_replay_id: undefined
        });
      };
      const onLoaded = loaded => {
        if (signal.aborted) return;
        instance = loaded;
        if (!consented) return stopRecording();
        syncReplayId(loaded);
        intervalId = window.setInterval(() => syncReplayId(loaded), MIXPANEL_REPLAY_ID_SYNC_INTERVAL);
      };
      const loadSdk = () => {
        const initConfig = {
          api_host: MIXPANEL_API_HOST,
          autocapture: false,
          track_pageview: false,
          record_sessions_percent: config.percent,
          loaded: onLoaded
        };
        const queue = [[config.token, initConfig, 'mixpanel']];
        window.mixpanel = Object.assign([], {
          __SV: 1.2,
          _i: queue
        });
        const script = document.createElement('script');
        script.src = MIXPANEL_SDK_URL;
        script.async = true;
        document.head.append(script);
      };
      const requestSdk = () => {
        if (sdkRequested) return;
        sdkRequested = true;
        if (document.readyState === 'complete') loadSdk();else window.addEventListener('load', loadSdk, {
          once: true,
          signal
        });
      };
      const syncConsent = async () => {
        const allowed = !consentEnforced || (await isConsentAllowed('analytics'));
        if (signal.aborted) return;
        consented = allowed;
        if (allowed) requestSdk();else stopRecording();
      };
      syncConsent();
      document.addEventListener(VISITOR_CONSENT_COLLECTED_EVENT, syncConsent, {
        signal
      });
      signal.addEventListener('abort', stopReplayIdSync);
      return () => controller.abort();
    };

    var sessionReplay$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sessionReplay
    });

    const readRolloutTreatmentIds = () => {
      const raw = document.querySelector(ROLLOUT_TREATMENT_IDS_SELECTOR)?.dataset.treatmentIds ?? '';
      return raw.split(',').map(id => id.trim()).filter(id => /^\d+$/.test(id));
    };
    var themeBridge = () => {
      const themeId = window.Shopify?.theme?.id;
      writeBridgeFields({
        theme_id: themeId ? String(themeId) : undefined,
        rollout_treatment_ids: readRolloutTreatmentIds()
      });
    };

    var themeBridge$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: themeBridge
    });

    const {
      getElementByRef: getElementByRef$f
    } = window.PoleneLibs.Refs;
    const {
      breakpoints: breakpoints$2
    } = window.PoleneLibs.Breakpoints;
    class ComponentSeeMore extends HTMLElement {
      controller = undefined;
      button = undefined;
      remaining = undefined;
      mediaQuery = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.controller = new AbortController();
        this.initializeElements();
        this.setupMediaQuery();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      initializeElements = () => {
        const {
          seeMoreButton,
          seeMoreRemaining
        } = getElementByRef$f(['see-more-button', 'see-more-remaining'], this);
        this.button = seeMoreButton;
        this.remaining = seeMoreRemaining;
      };
      setupMediaQuery = () => {
        this.mediaQuery = window.matchMedia(`(min-width: ${breakpoints$2.md}px)`);
        this.mediaQuery.addEventListener('change', this.handleViewportChange, {
          signal: this.controller?.signal
        });
      };
      handleViewportChange = () => {
        if (this.button && this.remaining) {
          this.button.setAttribute('aria-expanded', 'false');
          this.remaining.hidden = true;
          this.button.hidden = false;
        }
      };
      setupEventListeners = () => {
        this.button?.addEventListener('click', this.handleToggle, {
          signal: this.controller?.signal
        });
      };
      handleToggle = () => {
        if (!this.button || !this.remaining) return;
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        const newExpandedState = !isExpanded;
        this.button.setAttribute('aria-expanded', String(newExpandedState));
        this.remaining.hidden = !newExpandedState;
        this.button.hidden = newExpandedState;
      };
      static define = () => {
        if (!customElements.get('component-see-more')) {
          customElements.define('component-see-more', ComponentSeeMore);
        }
      };
    }
    var componentSeeMore = () => {
      ComponentSeeMore.define();
    };

    var componentSeeMore$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentSeeMore
    });

    const scrollLock$3 = window.PoleneLibs.ScrollLock.default;
    const events$6 = window.PoleneLibs.Events.default;
    class ThemeSearchOverlay extends HTMLElement {
      abortController = undefined;
      searchInput = null;
      closeBtn = null;
      focusTrap = undefined;
      focusTrapActive = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.abortController = new AbortController();
        this.focusTrap = new FocusTrap(this);
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      initializeElements = () => {
        this.searchInput = this.querySelector('input[type="search"]');
        this.closeBtn = this.querySelector('button.theme-search-overlay__close');
      };
      setupEventListeners = () => {
        this.closeBtn?.addEventListener('click', this.handleClose, {
          signal: this.abortController?.signal
        });
        window.addEventListener(events$6.SEARCH_OVERLAY_TOGGLED, this.toggleSearchOverlay, {
          signal: this.abortController?.signal
        });
      };
      isDisplayed = () => this.getClientRects().length > 0;
      releaseFocus = () => {
        if (this.focusTrapActive) {
          this.focusTrap?.deactivate();
          this.focusTrapActive = false;
        }
      };
      handleClose = () => {
        this.classList.remove('is-open');
        scrollLock$3(false);
        this.ariaHidden = 'true';
        this.releaseFocus();
      };
      toggleSearchOverlay = e => {
        const {
          isOpen
        } = e.detail;
        this.classList.toggle('is-open', isOpen);
        this.ariaHidden = isOpen ? 'false' : 'true';
        if (this.classList.contains('is-open')) {
          if (!this.isDisplayed()) return;
          this.focusTrap?.activate();
          this.focusTrapActive = true;
          if ('ontouchstart' in window) {
            this.closeBtn?.focus();
          } else {
            this.searchInput?.focus();
          }
        } else {
          this.releaseFocus();
        }
      };
      static define = () => {
        if (!customElements.get('theme-search-overlay')) {
          customElements.define('theme-search-overlay', ThemeSearchOverlay);
        }
      };
    }
    var themeSearchOverlay = () => {
      ThemeSearchOverlay.define();
    };

    var themeSearchOverlay$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ThemeSearchOverlay: ThemeSearchOverlay,
        default: themeSearchOverlay
    });

    const {
      getElementByRef: getElementByRef$e
    } = window.PoleneLibs.Refs;
    class WishlistCounter extends HTMLElement {
      counterEl = undefined;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        const {
          wishlistCounter
        } = getElementByRef$e('wishlist-counter', this);
        this.counterEl = wishlistCounter;
        if (this.counterEl) this.counterEl.innerText = Wishlist.count().toString();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.handleWishlistUpdate);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.handleWishlistUpdate);
      };
      handleWishlistUpdate = productIds => {
        if (this.counterEl) this.counterEl.innerText = productIds.length.toString();
      };
      static define = () => {
        if (!customElements.get('wishlist-counter')) customElements.define('wishlist-counter', WishlistCounter);
      };
    }
    var wishlistCounter = () => {
      WishlistCounter.define();
    };

    var wishlistCounter$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistCounter
    });

    const {
      updateGlobalModals
    } = window.PoleneLibs.Utils;
    const {
      SSRComponent
    } = window.PoleneLibs.BaseComponent;
    class WishlistGrid extends SSRComponent {
      onMount() {
        this.renderGrid();
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.renderGrid);
      }
      onUnmount() {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.renderGrid);
      }
      renderGrid = async () => {
        const grid = await Wishlist.getHTML();
        this.syncHTML(grid);
        updateGlobalModals();
      };
      static define = () => {
        if (!customElements.get('wishlist-grid')) customElements.define('wishlist-grid', WishlistGrid);
      };
    }
    var wishlistGrid = () => {
      WishlistGrid.define();
    };

    var wishlistGrid$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistGrid
    });

    const {
      getElementByRef: getElementByRef$d
    } = window.PoleneLibs.Refs;
    class WishlistStateBlock extends HTMLElement {
      emptyWishlistText = undefined;
      saveWishlistText = undefined;
      isLoggedIn = false;
      constructor() {
        super();
      }
      connectedCallback() {
        this.initializeElements();
        this.setupEventListeners();
      }
      disconnectedCallback() {
        this.removeEventListeners();
      }
      initializeElements = async () => {
        const {
          wishlistSaveText,
          wishlistEmptyText
        } = getElementByRef$d(['wishlist-save-text', 'wishlist-empty-text'], this);
        this.saveWishlistText = wishlistSaveText;
        this.emptyWishlistText = wishlistEmptyText;
        if (this.emptyWishlistText && this.saveWishlistText) this.isLoggedIn = true;
        this.syncUI();
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.syncUI);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.syncUI);
      };
      syncUI = () => {
        const isEmpty = Wishlist.count() === 0;
        if (this.isLoggedIn) {
          this.emptyWishlistText?.classList.toggle('hidden', !isEmpty);
          this.saveWishlistText?.classList.toggle('hidden', isEmpty);
        } else this.classList.toggle('hidden', !isEmpty);
      };
      static define = () => {
        if (!customElements.get('wishlist-state-block')) customElements.define('wishlist-state-block', WishlistStateBlock);
      };
    }
    var wishlistStateBlock = () => {
      WishlistStateBlock.define();
    };

    var wishlistStateBlock$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: wishlistStateBlock
    });

    const events$5 = window.PoleneLibs.Events.default;
    const {
      getElementByRef: getElementByRef$c
    } = window.PoleneLibs.Refs;
    const classes$5 = {
      visible: 'is-visible',
      constrast: 'has-contrast'
    };
    let type = null;
    let isTouchDevice = !document.getElementsByTagName('html')[0].classList.contains('no-touch');
    var fragmentCursor = () => {
      const {
        cursor
      } = getElementByRef$c('cursor');
      if (!cursor || isTouchDevice) return;
      const init = () => {
        setEventListeners();
      };
      const setEventListeners = () => {
        window.addEventListener(events$5.CHANGE_CURSOR, handleChangeCursor);
        window.addEventListener('mousemove', handleMouseMove);
      };
      const resetCursor = () => {
        document.body.style.cursor = 'auto';
        cursor.classList.remove(classes$5.visible);
      };
      const handleMouseMove = e => {
        const bounds = cursor.getBoundingClientRect();
        const cursorX = e.clientX - bounds.width / 2;
        const cursorY = e.clientY - bounds.height / 2;
        cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0)`;
      };
      const handleChangeCursor = e => {
        document.body.style.cursor = 'none';
        type = e.detail.type;
        if (type === 'default') {
          resetCursor();
          return;
        }
        if (e.detail.contrast) {
          cursor.classList.add(classes$5.constrast);
        } else {
          cursor.classList.remove(classes$5.constrast);
        }
        cursor.classList.add(classes$5.visible);
        cursor.dataset.type = e.detail.type;
      };
      init();
      return () => {
        window.removeEventListener(events$5.CHANGE_CURSOR, handleChangeCursor);
        window.removeEventListener('mousemove', handleMouseMove);
        document.body.style.cursor = 'auto';
      };
    };

    var fragmentCursor$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentCursor
    });

    const {
      BaseComponent: BaseComponent$7
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef: getElementByRef$b,
      getElementsByRef: getElementsByRef$9
    } = window.PoleneLibs.Refs;
    class EyesCursor extends BaseComponent$7 {
      pupils = [];
      sourceImg = null;
      reducedMotion = false;
      travelRatio = 0.6;
      pointer = {
        x: 0,
        y: 0
      };
      hasPointer = false;
      rafId = null;
      isCoarse = false;
      touchActive = false;
      parallelGaze = false;
      gazeMode = 'converge';
      saturation = 4;
      rotations = new Map();
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
        if (this.isCoarse) {
          this.classList.add('is-touch');
          this.setAmbientTarget();
          this.schedule();
        }
      }
      onUnmount() {
        if (this.rafId !== null) cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      initializeElements = () => {
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.isCoarse = !this.reducedMotion && window.matchMedia('(pointer: coarse)').matches;
        const {
          eyesCursorSourceImg
        } = getElementByRef$b('eyes-cursor-source-img', this);
        this.sourceImg = eyesCursorSourceImg ?? null;
        const {
          eyesCursorPupil
        } = getElementsByRef$9('eyes-cursor-pupil', this);
        this.pupils = Array.isArray(eyesCursorPupil) ? eyesCursorPupil : eyesCursorPupil ? [eyesCursorPupil] : [];
        const travel = Number(this.dataset.pupilTravel);
        if (!Number.isNaN(travel)) this.travelRatio = Math.max(0, travel / 100);
        this.gazeMode = this.dataset.gazeMode === 'parallel' ? 'parallel' : 'converge';
        const reach = Number(this.dataset.gazeReach);
        if (!Number.isNaN(reach) && reach > 0) this.saturation = reach;
        this.rotations.clear();
        for (const pupil of this.pupils) {
          const eye = pupil.parentElement;
          if (!eye) continue;
          const rad = (Number(eye.dataset.rotation) || 0) * Math.PI / 180;
          this.rotations.set(eye, {
            cos: Math.cos(rad),
            sin: Math.sin(rad)
          });
        }
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        if (this.sourceImg) this.addEventListener('click', this.handleToggle, {
          signal
        });
        if (this.reducedMotion || !this.pupils.length) return;
        if (this.isCoarse) {
          window.addEventListener('scroll', this.handleAmbient, {
            signal,
            passive: true
          });
          window.addEventListener('resize', this.handleAmbient, {
            signal,
            passive: true
          });
          window.addEventListener('touchstart', this.handleTouch, {
            signal,
            passive: true
          });
          window.addEventListener('touchmove', this.handleTouch, {
            signal,
            passive: true
          });
          window.addEventListener('touchend', this.handleTouchEnd, {
            signal,
            passive: true
          });
        } else {
          window.addEventListener('mousemove', this.handleMouseMove, {
            signal
          });
          window.addEventListener('scroll', this.handleReaim, {
            signal,
            passive: true
          });
          window.addEventListener('resize', this.handleReaim, {
            signal,
            passive: true
          });
        }
      };
      handleToggle = () => {
        this.classList.toggle('off');
      };
      handleReaim = () => {
        this.schedule();
      };
      setAmbientTarget = () => {
        this.pointer = {
          x: window.innerWidth / 2,
          y: window.innerHeight / 2
        };
        this.hasPointer = true;
        this.parallelGaze = true;
      };
      handleAmbient = () => {
        if (this.touchActive) return;
        this.setAmbientTarget();
        this.schedule();
      };
      handleTouch = event => {
        const touch = event.touches[0];
        if (!touch) return;
        this.touchActive = true;
        this.pointer = {
          x: touch.clientX,
          y: touch.clientY
        };
        this.hasPointer = true;
        this.parallelGaze = false;
        this.schedule();
      };
      handleTouchEnd = () => {
        this.touchActive = false;
        this.setAmbientTarget();
        this.schedule();
      };
      handleMouseMove = event => {
        this.pointer = {
          x: event.clientX,
          y: event.clientY
        };
        this.hasPointer = true;
        this.parallelGaze = false;
        this.schedule();
      };
      schedule = () => {
        if (this.rafId === null) this.rafId = requestAnimationFrame(this.render);
      };
      render = () => {
        this.rafId = null;
        if (!this.hasPointer) return;
        const shared = this.parallelGaze || this.gazeMode === 'parallel' ? this.groupCenter() : null;
        for (const pupil of this.pupils) {
          const eye = pupil.parentElement;
          if (!eye) continue;
          const rect = eye.getBoundingClientRect();
          const a = eye.offsetWidth / 2;
          const b = eye.offsetHeight / 2;
          if (!a || !b) continue;
          const center = shared ?? {
            x: rect.left + rect.width / 2,
            y: rect.top + rect.height / 2
          };
          const rotation = this.rotations.get(eye) ?? {
            cos: 1,
            sin: 0
          };
          const pupilRadius = pupil.offsetWidth / 2;
          const {
            x,
            y
          } = this.computePupilOffset(center, this.pointer, a, b, pupilRadius, rotation);
          pupil.style.transform = `translate(${x}px, ${y}px)`;
        }
      };
      groupCenter = () => {
        let sumX = 0;
        let sumY = 0;
        let count = 0;
        for (const pupil of this.pupils) {
          const eye = pupil.parentElement;
          if (!eye) continue;
          const rect = eye.getBoundingClientRect();
          sumX += rect.left + rect.width / 2;
          sumY += rect.top + rect.height / 2;
          count++;
        }
        return count ? {
          x: sumX / count,
          y: sumY / count
        } : this.pointer;
      };
      computePupilOffset = (eyeCenter, cursor, a, b, pupilRadius, rotation) => {
        const dx = cursor.x - eyeCenter.x;
        const dy = cursor.y - eyeCenter.y;
        const lx = dx * rotation.cos + dy * rotation.sin;
        const ly = dy * rotation.cos - dx * rotation.sin;
        const nx = lx / a;
        const ny = ly / b;
        const dist = Math.hypot(nx, ny);
        if (dist === 0) return {
          x: 0,
          y: 0
        };
        const maxMagnitude = Math.min(this.travelRatio, Math.max(0, 1 - pupilRadius / Math.min(a, b)));
        const magnitude = maxMagnitude * Math.min(1, dist / this.saturation);
        const scale = magnitude / dist;
        return {
          x: nx * scale * a,
          y: ny * scale * b
        };
      };
      static define = () => {
        if (!customElements.get('eyes-cursor')) {
          customElements.define('eyes-cursor', EyesCursor);
        }
      };
    }
    var eyesCursor = () => {
      EyesCursor.define();
    };

    var eyesCursor$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: eyesCursor
    });

    const {
      preorderInputTemplate
    } = window.PoleneLibs.ElementTemplates;
    const {
      VariantSelectedEvent
    } = window.PoleneLibs.ProductEvents;
    const events$4 = window.PoleneLibs.Events.default;
    const {
      envelope
    } = window.PoleneLibs.SvgTemplates;
    const {
      getElementByRef: getElementByRef$a,
      getElementsByRef: getElementsByRef$8,
      getRefs: getRefs$4
    } = window.PoleneLibs.Refs;
    const classes$4 = {
      hidden: 'is-hidden',
      open: 'is-open',
      disabled: 'is-disabled',
      preorder: 'is-preorder',
      active: 'is-active'
    };
    const selectors$2 = {
      trigger: '.p-select__selected'
    };
    let selectCount = 0;
    var fragmentOptionSelect = () => {
      const ref = getElementByRef$a(['grid']);
      const {
        customSelect,
        productDetails,
        searchResults
      } = getElementsByRef$8(['custom-select', 'product-details', 'search-results']);
      if (!ref.grid && !customSelect) return;
      const controller = new AbortController();
      const refs = getRefs$4(ref.grid, true);
      const instances = new Map();
      const releaseDetached = () => {
        instances.forEach((instance, selectEl) => {
          if (selectEl.isConnected) return;
          instance.controller.abort();
          instances.delete(selectEl);
        });
      };
      const handleDocumentClick = e => {
        releaseDetached();
        instances.forEach(({
          close
        }, selectEl) => {
          if (!selectEl.contains(e.target)) close();
        });
      };
      const initSelects = () => {
        setTimeout(() => {
          releaseDetached();
          const select = Array.isArray(customSelect) ? [...customSelect] : [customSelect];
          const selectElements = refs && refs.current && Array.isArray(refs.current.customSelect) ? [...refs.current.customSelect] : select;
          selectElements.forEach(selectEl => initSelect(selectEl));
        });
      };
      const initSelect = selectEl => {
        const {
          select,
          options,
          arrowIcon
        } = getRefs$4(selectEl);
        if (!select || selectEl.querySelector(selectors$2.trigger)) return;
        const selectController = new AbortController();
        const {
          signal
        } = selectController;
        const uid = `p-select-${++selectCount}`;
        const label = window.translations?.select_size ?? '';
        const items = [];
        let activeIndex = -1;
        const selected = document.createElement('div');
        selected.className = 'p-select__selected ts-label-s';
        selected.id = `${uid}-combobox`;
        selected.tabIndex = 0;
        selected.setAttribute('role', 'combobox');
        selected.setAttribute('aria-haspopup', 'listbox');
        selected.setAttribute('aria-expanded', 'false');
        selected.setAttribute('aria-controls', `${uid}-listbox`);
        selected.innerHTML = options[select.selectedIndex].innerHTML;
        const container = document.createElement('div');
        container.className = `p-select__item-list ${classes$4.hidden}`;
        container.id = `${uid}-listbox`;
        container.setAttribute('role', 'listbox');
        const labelEl = document.createElement('span');
        labelEl.className = 'sr-only';
        labelEl.id = `${uid}-label`;
        labelEl.textContent = label;
        if (label) {
          selected.setAttribute('aria-labelledby', labelEl.id);
          container.setAttribute('aria-labelledby', labelEl.id);
        }
        const isOpen = () => !container.classList.contains(classes$4.hidden);
        const scrollListTo = item => {
          const listRect = container.getBoundingClientRect();
          const itemRect = item.getBoundingClientRect();
          if (itemRect.top < listRect.top) container.scrollTop -= listRect.top - itemRect.top;else if (itemRect.bottom > listRect.bottom) container.scrollTop += itemRect.bottom - listRect.bottom;
        };
        const setActive = index => {
          if (!items.length) return;
          activeIndex = Math.max(0, Math.min(index, items.length - 1));
          items.forEach((item, i) => item.classList.toggle(classes$4.active, i === activeIndex));
          selected.setAttribute('aria-activedescendant', items[activeIndex].id);
          scrollListTo(items[activeIndex]);
        };
        const openList = index => {
          if (!isOpen()) {
            container.classList.remove(classes$4.hidden);
            selectEl.classList.add(classes$4.open);
            selected.setAttribute('aria-expanded', 'true');
          }
          const selectedIndex = items.findIndex(item => item.getAttribute('aria-selected') === 'true');
          setActive(index ?? (selectedIndex >= 0 ? selectedIndex : 0));
        };
        const closeList = () => {
          container.classList.add(classes$4.hidden);
          selectEl.classList.remove(classes$4.open);
          selected.setAttribute('aria-expanded', 'false');
          selected.removeAttribute('aria-activedescendant');
          items.forEach(item => item.classList.remove(classes$4.active));
          activeIndex = -1;
        };
        const openBisModal = (item, optionIndex) => {
          const {
            bisModal: modal
          } = getElementByRef$a('bis-modal');
          if (!modal) return;
          const handle = selectEl.closest('component-product-form')?.dataset.handle;
          item.dataset.variantid = options[optionIndex].value;
          item.dataset.state = 'disabled';
          if (handle) item.dataset.handle = handle;
          selected.focus({
            preventScroll: true
          });
          modal.open(item);
        };
        const selectItem = item => {
          const optionIndex = Number(item.dataset.optionIndex);
          closeList();
          if (item.classList.contains(classes$4.disabled)) {
            openBisModal(item, optionIndex);
            return;
          }
          select.selectedIndex = optionIndex;
          const formState = selectEl.nextElementSibling;
          if (formState.querySelector('input#pre-order') !== null) {
            formState.querySelector('input#pre-order')?.remove();
            formState.querySelector('input#pre-order-tag')?.remove();
            formState.querySelector('input#pre-order-date')?.remove();
          }
          formState.parentElement?.querySelector('div.preorder-description')?.remove();
          const isPreorder = item.classList.contains(classes$4.preorder);
          if (isPreorder) {
            const {
              pol,
              pofd,
              pod,
              preorderDescription
            } = options[optionIndex].dataset;
            formState.dataset.state = 'preorder';
            formState.dataset.defaultState = 'preorder';
            formState.innerHTML += preorderInputTemplate(pol, pofd, pod);
            const description = document.createElement('div');
            description.className = 'preorder-description';
            description.textContent = preorderDescription ?? '';
            formState.parentElement?.append(description);
          } else {
            formState.dataset.state = 'default';
            formState.dataset.defaultState = 'default';
          }
          items.forEach(el => el.setAttribute('aria-selected', String(el === item)));
          selected.innerHTML = item.innerHTML;
          selectEl.dispatchEvent(new VariantSelectedEvent(options[optionIndex].value, isPreorder));
        };
        const handleTriggerClick = e => {
          e.preventDefault();
          e.stopPropagation();
          if (isOpen()) closeList();else openList();
        };
        const handleItemClick = e => {
          e.preventDefault();
          e.stopPropagation();
          const item = e.target.closest('[role="option"]');
          if (item) selectItem(item);
        };
        const handleTriggerKeydown = e => {
          if (!isOpen()) {
            if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(e.key)) {
              e.preventDefault();
              openList();
            } else if (e.key === 'Home' || e.key === 'End') {
              e.preventDefault();
              openList(e.key === 'Home' ? 0 : items.length - 1);
            }
            return;
          }
          switch (e.key) {
            case 'ArrowDown':
              e.preventDefault();
              setActive(activeIndex + 1);
              break;
            case 'ArrowUp':
              e.preventDefault();
              if (!e.altKey) setActive(activeIndex - 1);else if (items[activeIndex]) selectItem(items[activeIndex]);else closeList();
              break;
            case 'Home':
              e.preventDefault();
              setActive(0);
              break;
            case 'End':
              e.preventDefault();
              setActive(items.length - 1);
              break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              if (items[activeIndex]) selectItem(items[activeIndex]);
              break;
            case 'Escape':
              e.preventDefault();
              e.stopPropagation();
              closeList();
              break;
            case 'Tab':
              closeList();
              break;
          }
        };
        options.forEach((option, i) => {
          if (i === 0) return;
          const item = document.createElement('div');
          item.className = 'p-select__item js-option ts-label-s';
          item.id = `${uid}-option-${i}`;
          item.dataset.optionIndex = String(i);
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', String(i === select.selectedIndex));
          let optionInner = `<span class="option">${option.innerHTML}</span>`;
          if (option.dataset.availability === 'false') {
            item.classList.add(classes$4.disabled);
            item.setAttribute('aria-disabled', 'true');
            optionInner = `<span class="option">${option.innerHTML}</span>
					<div class="option-message">
						<span>${option.dataset.notifyLabel}</span>
						${envelope}
					</div>`;
          }
          if (option.dataset.availability === 'true' && 'pod' in option.dataset) {
            item.classList.add(classes$4.preorder);
            optionInner = `<span class="option">${option.innerHTML}</span>
					<div class="option-message">
						<span>${option.dataset.preorderLabel}</span>
					</div>`;
          }
          item.innerHTML = optionInner;
          item.addEventListener('click', handleItemClick, {
            signal
          });
          items.push(item);
          container.appendChild(item);
        });
        if (label) selectEl.prepend(labelEl);
        selectEl.insertBefore(selected, arrowIcon);
        selectEl.appendChild(container);
        selected.addEventListener('click', handleTriggerClick, {
          signal
        });
        selected.addEventListener('keydown', handleTriggerKeydown, {
          signal
        });
        selected.addEventListener('blur', closeList, {
          signal
        });
        container.addEventListener('mousedown', e => e.preventDefault(), {
          signal
        });
        instances.get(selectEl)?.controller.abort();
        instances.set(selectEl, {
          controller: selectController,
          close: () => {
            if (isOpen()) closeList();
          }
        });
      };
      if (productDetails || searchResults) {
        initSelects();
      }
      document.addEventListener('click', handleDocumentClick, {
        signal: controller.signal
      });
      window.addEventListener(events$4.PRODUCT_CARD_RENDERED, initSelects, {
        signal: controller.signal
      });
      return () => {
        controller.abort();
        instances.forEach(instance => instance.controller.abort());
        instances.clear();
      };
    };

    var fragmentOptionSelect$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentOptionSelect
    });

    const {
      getElementsByRef: getElementsByRef$7
    } = window.PoleneLibs.Refs;
    const scrollLock$2 = window.PoleneLibs.ScrollLock.default;
    const events$3 = window.PoleneLibs.Events.default;
    const classes$3 = {
      open: 'is-open',
      menuOpen: 'menu-open'
    };
    let isOpen = false;
    let focusTrap;
    let focusTrapActive = false;
    const update = ref => {
      if (!ref.searchOverlay || !ref.searchInput || !ref.siteHeader || !ref.navPanel || !ref.searchTrigger || !ref.searchOverlayBackdrop) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      if (Array.isArray(ref.searchOverlay)) return;
      ref.searchOverlay.classList.toggle(classes$3.open, isOpen);
      elements.forEach(element => {
        element.classList.toggle('is-active', isOpen);
      });
      scrollLock$2(isOpen);
      if (isOpen && !Array.isArray(ref.siteHeader) && !Array.isArray(ref.navPanel) && !Array.isArray(ref.searchOverlayBackdrop)) {
        focusTrap ??= new FocusTrap(ref.searchOverlay);
        focusTrap.activate();
        focusTrapActive = true;
        if (Array.isArray(ref.searchInput)) {
          ref.searchInput.forEach(input => {
            if (input.closest('[data-overlay="search"]')?.classList.contains('is-open')) {
              input.focus();
              input.select();
            }
          });
        } else {
          ref.searchInput.focus();
          ref.searchInput.select();
        }
        ref.siteHeader.style.backgroundColor = 'hsl(var(--white))';
        const isMobile = window.innerWidth < 1024;
        if (!isMobile) {
          ref.navPanel.classList.remove(classes$3.open);
          ref.siteHeader.classList.remove(classes$3.menuOpen);
        }
        document.body.classList.add('search-open');
        ref.searchOverlayBackdrop.classList.add('is-open');
      } else if (!Array.isArray(ref.siteHeader) && !Array.isArray(ref.searchOverlayBackdrop)) {
        if (focusTrapActive) {
          focusTrap?.deactivate();
          focusTrapActive = false;
        }
        ref.siteHeader.style.removeProperty('background-color');
        document.body.classList.remove('search-open');
        ref.searchOverlayBackdrop.classList.remove('is-open');
      }
    };
    const setSearchOverlayOpenState = (ref, doOpen) => {
      if (doOpen === undefined) {
        isOpen = !isOpen;
      } else {
        isOpen = doOpen;
      }
      update(ref);
      window.dispatchEvent(new CustomEvent(events$3.SEARCH_OVERLAY_TOGGLED, {
        detail: {
          isOpen
        }
      }));
    };
    var fragmentSearchTrigger = () => {
      const ref = getElementsByRef$7(['search-trigger', 'search-overlay', 'search-input', 'site-header', 'nav-panel', 'search-overlay-backdrop']);
      if (!ref.searchTrigger) return;
      const elements = Array.isArray(ref.searchTrigger) ? [...ref.searchTrigger] : [ref.searchTrigger];
      const handleClick = () => setSearchOverlayOpenState(ref);
      const handleKeypress = e => {
        if (e.key !== 'Escape') return;
        setSearchOverlayOpenState(ref, false);
      };
      update(ref);
      const teardowns = elements.map(element => {
        element.addEventListener('click', handleClick);
        return () => element.removeEventListener('click', handleClick);
      });
      window.addEventListener('keydown', handleKeypress);
      if (ref.searchOverlayBackdrop && ref.searchOverlayBackdrop instanceof HTMLElement) {
        ref.searchOverlayBackdrop.addEventListener('click', () => setSearchOverlayOpenState(ref, false));
      }
      return () => {
        teardowns.forEach(teardown => teardown());
        window.removeEventListener('keydown', handleKeypress);
        setSearchOverlayOpenState(ref, false);
        if (ref.searchOverlayBackdrop && ref.searchOverlayBackdrop instanceof HTMLElement) {
          ref.searchOverlayBackdrop.removeEventListener('click', () => setSearchOverlayOpenState(ref, false));
        }
      };
    };

    var fragmentSearchTrigger$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSearchTrigger,
        setSearchOverlayOpenState: setSearchOverlayOpenState
    });

    const {
      getElementByRef: getElementByRef$9,
      getRefs: getRefs$3
    } = window.PoleneLibs.Refs;
    const scrollLock$1 = window.PoleneLibs.ScrollLock.default;
    const selectors$1 = {
      navItem: '.js-nav-item'
    };
    const classes$2 = {
      hasChildList: 'has-active-child',
      subMenuOpen: 'open-sub-menu',
      open: 'is-open',
      current: 'is-current'
    };
    var fragmentSubMenu = () => {
      const {
        subMenu,
        subMenuClose
      } = getElementByRef$9(['sub-menu', 'sub-menu-close']);
      if (!subMenu || !subMenuClose) return;
      const {
        activeMenus
      } = getRefs$3(subMenu);
      const activeItems = activeMenus ? [...activeMenus] : [];
      const init = () => {
        subMenu.addEventListener('click', handleClick);
        window.addEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.addEventListener('click', handleClose);
        }
      };
      const handleClose = () => {
        closeMenu();
      };
      const handleClick = e => {
        e.preventDefault();
        const subMenu = activeItems.length ? activeItems[activeItems.length - 1].parentNode : null;
        const navItem = e.target.closest(selectors$1.navItem);
        if (navItem && !navItem.classList.contains(classes$2.current) && !navItem.classList.contains(classes$2.hasChildList)) {
          const links = navItem.getElementsByTagName('a');
          const url = links[0].getAttribute('href');
          window.location.href = url;
          closeMenu();
        }
        if (!subMenu) return;
        if (subMenu.classList.contains(classes$2.open)) {
          subMenu.classList.remove(classes$2.open);
          document.body.classList.remove(classes$2.subMenuOpen);
          scrollLock$1(false);
        } else {
          subMenu.classList.add(classes$2.open);
          document.body.classList.add(classes$2.subMenuOpen);
          scrollLock$1(true);
        }
      };
      const closeMenu = () => {
        if (activeItems.length > 0) {
          activeItems.forEach(item => {
            item.parentNode.classList.remove(classes$2.open);
          });
        }
        document.body.classList.remove(classes$2.subMenuOpen);
        scrollLock$1(false);
      };
      init();
      return () => {
        subMenu.removeEventListener('click', handleClick);
        window.removeEventListener('resize', closeMenu);
        if (subMenuClose) {
          subMenuClose.removeEventListener('click', handleClose);
        }
      };
    };

    var fragmentSubMenu$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentSubMenu
    });

    const {
      intersection
    } = window.PoleneLibs.Observer;
    const {
      getElementsByRef: getElementsByRef$6,
      getRefs: getRefs$2
    } = window.PoleneLibs.Refs;
    const zeroPad = x => x.toString().padStart(2, '0');
    const parseBool = str => str && str === 'true' ? true : false;
    const parseTime = time => {
      const minutes = Math.floor(time / 60);
      const seconds = Math.round(time - minutes * 60);
      return `${zeroPad(minutes)}:${zeroPad(seconds)}`;
    };
    var fragmentVideo = () => {
      const {
        video,
        videoNative
      } = getElementsByRef$6(['video', 'video-native']);
      if (!video) return;
      const videos = Array.isArray(video) ? [...video] : [video];
      const handleIntersection = entries => {
        entries.forEach(entry => {
          const {
            isIntersecting,
            target
          } = entry;
          if (isIntersecting) {
            target.src = target.dataset.src;
            observer.unobserve(target);
          }
        });
      };
      const observer = intersection(null, handleIntersection, {
        rootMargin: `500px 0px 500px 0px`,
        threshold: [0]
      });
      if (videoNative) {
        const videos = videoNative ? Array.isArray(videoNative) ? [...videoNative] : [videoNative] : [];
        videos.forEach(videoNative => {
          observer.observe(videoNative);
        });
      }
      videos.map(video => {
        const refs = getRefs$2(video);
        if (refs.vimeoPlayer) {
          const options = {
            ...(refs.vimeoPlayer.dataset.vimeoUrl.includes('vimeo.com') ? {
              url: refs.vimeoPlayer.dataset.vimeoUrl
            } : {
              id: refs.vimeoPlayer.dataset.vimeoUrl
            }),
            byline: false,
            portrait: false,
            title: false,
            responsive: true
          };
          const player = new Vimeo.Player(refs.vimeoPlayer.id, options);
          let duration = 0;
          player.on('timeupdate', e => {
            duration = e.duration;
            if (refs.currentTime) refs.currentTime.textContent = parseTime(e.duration * e.percent);
            if (refs.duration) refs.duration.textContent = parseTime(e.duration);
            if (refs.timeline) {
              refs.timeline.value = e.percent;
              refs.timeline.style.setProperty('--progress', e.percent);
            }
          });
          player.on('volumechange', e => {
            if (refs.volume) refs.volume.value = e.volume;
            if (volume) volume.style.setProperty('--progress', e.volume);
          });
          player.on('loaded', async () => {
            const initVolume = await player.getVolume();
            if (refs.play) refs.play.textContent = parseBool(refs.vimeoPlayer.dataset.vimeoAutoplay) ? 'Pause' : 'Play';
            if (refs.volume) {
              refs.volume.value = initVolume;
              refs.volume.style.setProperty('--progress', initVolume);
            }
          });
          const handlePlay = async ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            if (await player.getPaused()) {
              player.play();
              if (refs.play) refs.play.textContent = 'Pause';
            } else {
              player.pause();
              if (refs.play) refs.play.textContent = 'Play';
            }
          };
          const handleSeek = e => {
            player.setCurrentTime(parseFloat(e.target.value) * duration);
            if (refs.timeline) refs.timeline.style.setProperty('--progress', parseFloat(e.target.value));
          };
          const handleVolume = e => {
            player.setVolume(parseFloat(e.target.value));
            if (refs.volume) {
              refs.volume.style.setProperty('--progress', parseFloat(e.target.value));
            }
          };
          const handleMute = async () => {
            const volume = await player.getVolume();
            if (refs.mute) {
              if (volume > 0.5) {
                player.setVolume(0);
                refs.mute.dataset.state = 'unmute';
              } else {
                player.setVolume(1);
                refs.mute.dataset.state = 'mute';
              }
            }
          };
          refs.play?.addEventListener('click', handlePlay);
          refs.vimeoPlayer?.addEventListener('click', handlePlay);
          refs.timeline?.addEventListener('input', handleSeek);
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('input', handleMute);
        }
        if (refs.videoNative) {
          let isPlaying = parseBool(refs.videoNative.getAttribute('muted')) && parseBool(refs.videoNative.getAttribute('autoplay'));
          let progress = 0;
          const updateUI = () => {
            progress = refs.videoNative.currentTime / refs.videoNative.duration;
            if (refs.timeline) {
              refs.timeline.style.setProperty('--progress', parseFloat(progress.toString()));
              refs.timeline.value = parseFloat(progress.toString());
            }
            if (refs.volume) {
              refs.volume.value = refs.videoNative.muted ? 0 : refs.videoNative.volume;
              refs.volume.style.setProperty('--progress', parseFloat(refs.volume.value));
            }
            if (refs.currentTime) {
              refs.currentTime.textContent = parseTime(refs.videoNative.currentTime);
            }
            if (refs.duration) {
              refs.duration.textContent = parseTime(refs.videoNative.duration);
            }
            if (refs.mute) {
              if (refs.videoNative.muted) {
                refs.mute.dataset.state = 'unmute';
              } else {
                refs.mute.dataset.state = 'mute';
              }
            }
            if (refs.play) {
              if (isPlaying) {
                refs.play.textContent = 'Pause';
              } else {
                refs.play.textContent = 'Play';
              }
            }
            if (isPlaying) requestAnimationFrame(updateUI);
          };
          updateUI();
          const handlePlay = ({
            target
          }) => {
            if (target.closest('.controls') && !target.closest('[data-ref="play"]')) return;
            isPlaying = !isPlaying;
            if (isPlaying) {
              refs.videoNative.play();
            } else {
              refs.videoNative.pause();
            }
            updateUI();
          };
          const handleSeek = e => {
            refs.videoNative.currentTime = e.target.value * refs.videoNative.duration;
            updateUI();
          };
          const handleVolume = e => {
            refs.videoNative.muted = false;
            refs.videoNative.volume = e.target.value;
            updateUI();
          };
          const handleMute = () => {
            const muted = parseBool(refs.videoNative.getAttribute('muted'));
            refs.videoNative.setAttribute('muted', !muted);
            refs.videoNative.muted = !muted;
            updateUI();
          };
          if (refs.play) {
            video?.addEventListener('click', handlePlay);
          }
          refs.volume?.addEventListener('input', handleVolume);
          refs.mute?.addEventListener('click', handleMute);
          refs.timeline?.addEventListener('input', handleSeek);
        }
      });
    };

    var fragmentVideo$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: fragmentVideo
    });

    const events$2 = window.PoleneLibs.Events.default;
    const {
      dispatchEvent: dispatchEvent$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$8
    } = window.PoleneLibs.Refs;
    const classes$1 = {
      announcementBarActive: 'announcement-bar-active',
      appear: 'appear'
    };
    var sectionAnnouncementBar = () => {
      const {
        announcementBar,
        siteHeader
      } = getElementByRef$8(['announcement-bar', 'site-header']);
      if (!announcementBar || !siteHeader) return;
      const init = () => {
        document.body.style.setProperty('--announcement-bar-height', '30px');
        document.body.style.setProperty('--header-top-pos', '30px');
        siteHeader.classList.add(classes$1.announcementBarActive);
        document.body.classList.add(classes$1.announcementBarActive);
        announcementBar.classList.add(classes$1.appear);
        dispatchEvent$1(window, events$2.ANNOUNCEMENT_BAR_RENDERED);
      };
      init();
    };

    var sectionAnnouncementBar$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionAnnouncementBar
    });

    const {
      breakpoints: breakpoints$1
    } = window.PoleneLibs.Breakpoints;
    const {
      getElementsByRef: getElementsByRef$5,
      getRefs: getRefs$1
    } = window.PoleneLibs.Refs;
    const selectors = {
      item: '.js-teaser-item'
    };
    const classes = {
      reveal: 'reveal',
      active: 'is-active'
    };
    var sectionArticleTeaser = () => {
      const {
        articleTeaser
      } = getElementsByRef$5(['article-teaser']);
      if (!articleTeaser) return;
      const articleTeasers = Array.isArray(articleTeaser) ? articleTeaser : [articleTeaser];
      articleTeasers.forEach(teaser => {
        let interval;
        let currentIdx = 0;
        let lastIdx = 0;
        let mobileIndex = 0;
        let mobileInterval;
        const {
          previewImages,
          items,
          articleTeaserItem
        } = getRefs$1(teaser);
        const init = () => {
          setEventlisteners();
        };
        const setEventlisteners = () => {
          teaser.addEventListener('mouseover', handleMouseOver);
        };
        const handleMouseOver = e => {
          const item = e.target instanceof Element ? e.target.closest(selectors.item) : null;
          if (item) {
            const activeIdx = item.dataset.index ? item.dataset.index : 0;
            const links = items ? Array.from(items) : [];
            links.forEach(link => {
              if (link == item) {
                link.classList.add(classes.active);
              } else {
                link.classList.remove(classes.active);
              }
            });
            if (lastIdx === activeIdx) return;
            lastIdx = activeIdx;
            stopCounter();
            revealImage(previewImages, activeIdx);
            if (item.dataset.imageAmount) {
              const imageAmount = item.dataset.imageAmount;
              const preview = previewImages.find(p => p?.dataset?.index === activeIdx);
              const {
                revealImages
              } = getRefs$1(preview);
              if (revealImages.length) {
                revealImage(revealImages, 0);
                interval = setInterval(() => {
                  if (currentIdx == imageAmount - 1) {
                    currentIdx = 0;
                  } else {
                    currentIdx = currentIdx + 1;
                  }
                  revealImage(revealImages, currentIdx);
                }, 1800);
              }
            }
          }
        };
        const stopCounter = () => {
          clearInterval(interval ?? undefined);
        };
        if (window.innerWidth <= breakpoints$1.md) {
          const updateClasses = () => {
            previewImages.forEach((item, idx) => {
              const reveal = idx === mobileIndex;
              item.classList.toggle('reveal', reveal);
              item.firstElementChild?.classList.add('reveal');
              articleTeaserItem[idx].classList.toggle('reveal', reveal);
            });
          };
          updateClasses();
          mobileInterval = setInterval(() => {
            mobileIndex = (mobileIndex + 1) % previewImages.length;
            updateClasses();
          }, 3200);
        }
        const revealImage = (images, idx) => {
          images.forEach(img => {
            if (img.dataset.index == idx) {
              img.classList.add(classes.reveal);
            } else {
              img.classList.remove(classes.reveal);
            }
          });
        };
        init();
        return () => {
          teaser.removeEventListener('mouseover', handleMouseOver);
          if (mobileInterval) clearInterval(mobileInterval);
        };
      });
    };

    var sectionArticleTeaser$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionArticleTeaser
    });

    const {
      breakpoints
    } = window.PoleneLibs.Breakpoints;
    const events$1 = window.PoleneLibs.Events.default;
    const scrollLock = window.PoleneLibs.ScrollLock.default;
    const {
      getElementByRef: getElementByRef$7,
      getElementsByRef: getElementsByRef$4,
      getRefs
    } = window.PoleneLibs.Refs;
    const {
      isMobile: isMobile$1,
      getVisibleFocusableElements,
      inertOutside,
      releaseInert
    } = window.PoleneLibs.Utils;
    const HOVER_CLOSE_DELAY = 200;
    const CLASSES = {
      menuOpen: 'menu-open',
      scrolled: 'is-scrolled',
      open: 'is-open',
      announcementBarActive: 'announcement-bar-active',
      expanded: 'is-expanded',
      menuOpeningLevel2: 'menu-opening-level-2'
    };
    const SELECTORS = {
      menuItem: '.header__menu-item',
      menuPanel: '[data-ref="menu-panel"]',
      menuPanelSplit: '.header__menu-panel__split',
      menuPanelSplitHoverPreview: '[data-ref="split-hover-preview"]',
      menuPanelSplitHoverPreviewTitle: '[data-ref="split-hover-preview-title"]',
      menuPanelSplitImageItem: '[data-ref="split-image-item"]',
      menuL2Trigger: '[data-ref="panel-trigger"]',
      menuL2Wrapper: '[data-ref="panel-wrapper"]'
    };
    class ComponentHeaderMenu extends HTMLElement {
      abortController = undefined;
      header = null;
      navPanel = null;
      mobileBar = null;
      burgerToggle = null;
      l1Triggers = [];
      l2Triggers = [];
      panelBacks = [];
      panelGridBacks = [];
      panels = [];
      l1TriggerToPanel = new Map();
      l1ItemToTrigger = new Map();
      l1ItemToPanel = new Map();
      panelToL1Trigger = new Map();
      l2TriggerToWrapper = new Map();
      wrapperToL2Trigger = new Map();
      panelToL2Triggers = new Map();
      hoverTimer = null;
      splitPreviewTimer = null;
      activeL1 = null;
      hasAnnouncementBar = false;
      focusTimout = null;
      activeL1Trigger = null;
      activePanel = null;
      activeL2Trigger = null;
      activeWrapper = null;
      backgroundInert = [];
      levelInert = [];
      isPanelPackshot = panel => panel.dataset.panelLayout === 'packshot';
      panelHasSubmenu = panel => {
        if (!this.isPanelPackshot(panel)) return true;
        return panel.querySelectorAll('a[href]').length > 0;
      };
      connectedCallback() {
        this.abortController = new AbortController();
        this.initializeElements();
        this.syncSubPanelBackLabels();
        this.setupEventListeners();
        this.handleScroll();
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      initializeElements = () => {
        const {
          siteHeader
        } = getElementByRef$7('site-header', this);
        this.header = siteHeader ?? null;
        if (!this.header) return;
        this.hasAnnouncementBar = this.header.classList.contains(CLASSES.announcementBarActive);
        const {
          navPanel
        } = getElementByRef$7('nav-panel', this);
        this.navPanel = navPanel ?? null;
        const {
          burgerToggle
        } = getElementByRef$7('burger-toggle', this);
        this.burgerToggle = burgerToggle ?? null;
        const {
          mobileBar
        } = getElementByRef$7('mobile-bar', this);
        this.mobileBar = mobileBar ?? null;
        const {
          menuTrigger
        } = getElementsByRef$4('menu-trigger', this);
        this.l1Triggers = menuTrigger ? Array.isArray(menuTrigger) ? menuTrigger : [menuTrigger] : [];
        const {
          menuPanel
        } = getElementsByRef$4('menu-panel', this);
        this.panels = menuPanel ? Array.isArray(menuPanel) ? menuPanel : [menuPanel] : [];
        const {
          panelTrigger
        } = getElementsByRef$4('panel-trigger', this);
        this.l2Triggers = panelTrigger ? Array.isArray(panelTrigger) ? panelTrigger : [panelTrigger] : [];
        const {
          panelBack
        } = getElementsByRef$4('panel-back', this);
        this.panelBacks = panelBack ? Array.isArray(panelBack) ? panelBack : [panelBack] : [];
        const {
          panelGridBack
        } = getElementsByRef$4('panel-grid-back', this);
        this.panelGridBacks = panelGridBack ? Array.isArray(panelGridBack) ? panelGridBack : [panelGridBack] : [];
        this.buildRelationshipMaps();
      };
      syncSubPanelBackLabels = () => {
        this.panels.forEach(panel => {
          const groupBack = panel.querySelector('[data-ref="panel-back"]');
          if (!groupBack) return;
          const groupTitle = groupBack.querySelector('.ts-tertiary-item')?.textContent ?? '';
          const groupAria = groupBack.getAttribute('aria-label') ?? '';
          panel.querySelectorAll('[data-ref="panel-grid-back"]').forEach(btn => {
            const label = btn.querySelector('.ts-tertiary-item');
            if (label && groupTitle) label.textContent = groupTitle;
            if (groupAria) btn.setAttribute('aria-label', groupAria);
          });
        });
      };
      buildRelationshipMaps = () => {
        this.l1Triggers.forEach(trigger => {
          const item = trigger.closest(SELECTORS.menuItem);
          if (!item) return;
          const panel = item.querySelector(SELECTORS.menuPanel);
          if (!panel) return;
          this.l1TriggerToPanel.set(trigger, panel);
          this.l1ItemToTrigger.set(item, trigger);
          this.l1ItemToPanel.set(item, panel);
          this.panelToL1Trigger.set(panel, trigger);
        });
        this.panels.forEach(panel => {
          const l2Triggers = Array.from(panel.querySelectorAll(SELECTORS.menuL2Trigger));
          this.panelToL2Triggers.set(panel, l2Triggers);
          l2Triggers.forEach(trigger => {
            const wrapper = trigger.parentElement?.querySelector(SELECTORS.menuL2Wrapper);
            if (wrapper) {
              this.l2TriggerToWrapper.set(trigger, wrapper);
              this.wrapperToL2Trigger.set(wrapper, trigger);
            }
          });
        });
      };
      setupEventListeners = () => {
        const signal = this.abortController?.signal;
        if (!signal) return;
        this.burgerToggle?.addEventListener('click', this.handleBurgerClick, {
          signal
        });
        this.l1Triggers.forEach(trigger => {
          const parentLi = trigger.closest(SELECTORS.menuItem);
          if (parentLi) {
            parentLi.addEventListener('mouseenter', this.handleL1MouseEnter, {
              signal
            });
            parentLi.addEventListener('mouseleave', this.handleL1MouseLeave, {
              signal
            });
          }
          trigger.addEventListener('click', this.handleL1Open, {
            signal
          });
        });
        this.l2Triggers.forEach(trigger => {
          trigger.addEventListener('click', this.handleL2Click, {
            signal
          });
          trigger.addEventListener('mouseenter', this.handleL2Hover, {
            signal
          });
        });
        this.panelBacks.forEach(btn => {
          btn.addEventListener('click', this.handlePanelBack, {
            signal
          });
        });
        this.panelGridBacks.forEach(btn => {
          btn.addEventListener('click', this.handlePanelGridBack, {
            signal
          });
        });
        const {
          splitHoverLink
        } = getElementsByRef$4('split-hover-link', this);
        const hoverLinks = splitHoverLink ? Array.isArray(splitHoverLink) ? splitHoverLink : [splitHoverLink] : [];
        hoverLinks.forEach(link => {
          link.addEventListener('mouseenter', this.handleSplitLinkEnter, {
            signal
          });
          link.addEventListener('mouseleave', this.handleSplitLinkLeave, {
            signal
          });
        });
        [this.navPanel, ...this.panels].forEach(scroller => {
          scroller?.addEventListener('scroll', this.keepPanelsAligned, {
            signal
          });
        });
        window.addEventListener('scroll', this.handleScroll, {
          signal,
          passive: true
        });
        window.addEventListener('resize', this.handleResize, {
          signal,
          passive: true
        });
        window.addEventListener('keydown', this.handleKeyDown, {
          signal
        });
        window.addEventListener(events$1.CART_UPDATED, this.handleCartUpdate, {
          signal
        });
        window.addEventListener(events$1.ANNOUNCEMENT_BAR_RENDERED, this.setCSSVariables, {
          signal
        });
        window.addEventListener(events$1.SEARCH_OVERLAY_TOGGLED, this.handleSearchToggled, {
          signal
        });
      };
      isScrolled = () => window.scrollY > (isMobile$1() ? 0 : 30);
      keepPanelsAligned = e => {
        const scroller = e.target;
        if (scroller instanceof HTMLElement && scroller.scrollLeft !== 0) scroller.scrollLeft = 0;
      };
      autoSelectFirstL2 = panel => {
        this.closeActiveL2();
        if (!isMobile$1() && this.isPanelPackshot(panel)) {
          const wrapper = panel.querySelector(SELECTORS.menuL2Wrapper);
          if (wrapper) {
            this.enableContainer(wrapper);
            this.activeWrapper = wrapper;
            this.focusFirstElement(wrapper);
          }
          return;
        }
        const l2Triggers = this.panelToL2Triggers.get(panel) ?? [];
        if (l2Triggers.length === 0) {
          const wrapper = panel.querySelector(SELECTORS.menuL2Wrapper);
          if (wrapper) {
            this.enableContainer(wrapper);
            this.activeWrapper = wrapper;
            this.focusFirstElement(wrapper);
          }
          return;
        }
        const first = l2Triggers[0];
        if (first) {
          first.ariaExpanded = 'true';
          this.activeL2Trigger = first;
          const wrapper = this.l2TriggerToWrapper.get(first);
          if (wrapper) {
            this.enableContainer(wrapper);
            this.activeWrapper = wrapper;
            this.focusFirstElement(wrapper);
          } else {
            first.focus();
          }
        }
      };
      focusFirstElement = container => {
        if (this.focusTimout) clearTimeout(this.focusTimout);
        this.focusTimout = setTimeout(() => {
          const focusables = getVisibleFocusableElements(container);
          const firstVisible = focusables.find(el => el.dataset.ref !== 'panel-back');
          firstVisible?.focus({
            preventScroll: true
          });
          this.focusTimout = null;
        }, 0);
      };
      disableContainer = container => {
        container.ariaHidden = 'true';
        container.inert = true;
      };
      enableContainer = container => {
        container.ariaHidden = 'false';
        container.inert = false;
      };
      wrapTabWithinLayer = e => {
        if (!this.navPanel) return;
        const layer = this.activePanel && !this.activePanel.inert ? this.activePanel : this.navPanel;
        const focusables = [this.mobileBar, layer].filter(container => container !== null).flatMap(container => getVisibleFocusableElements(container)).filter(el => !el.closest('[inert]') && getComputedStyle(el).visibility !== 'hidden');
        if (focusables.length < 2) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      };
      closeActiveL1 = () => {
        releaseInert(this.levelInert);
        this.levelInert = [];
        if (this.activeL1Trigger) {
          this.activeL1Trigger.ariaExpanded = 'false';
          this.activeL1Trigger = null;
        }
        if (this.activePanel) {
          this.disableContainer(this.activePanel);
          this.activePanel = null;
        }
      };
      closeActiveL2 = () => {
        if (this.activeL2Trigger) {
          this.activeL2Trigger.ariaExpanded = 'false';
          this.activeL2Trigger = null;
        }
        if (this.activeWrapper) {
          this.disableContainer(this.activeWrapper);
          this.activeWrapper = null;
        }
      };
      closeAllDropdowns = () => {
        this.closeActiveL2();
        this.closeActiveL1();
        this.header?.classList.remove(CLASSES.menuOpen);
        document.body.classList.remove(CLASSES.menuOpen);
        document.body.classList.remove(CLASSES.menuOpeningLevel2);
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer);
          this.hoverTimer = null;
        }
        this.activeL1 = null;
      };
      syncBurgerLabel = isOpen => {
        if (!this.burgerToggle) return;
        const {
          labelOpen,
          labelClose
        } = this.burgerToggle.dataset;
        const label = isOpen ? labelClose : labelOpen;
        if (label) this.burgerToggle.setAttribute('aria-label', label);
      };
      handleBurgerClick = () => {
        if (!this.burgerToggle || !this.navPanel) return;
        if (this.burgerToggle.ariaExpanded === 'true') {
          this.closeMobileNav();
          return;
        }
        this.burgerToggle.ariaExpanded = 'true';
        this.syncBurgerLabel(true);
        this.navPanel.ariaHidden = 'false';
        this.navPanel.inert = false;
        this.navPanel.classList.add(CLASSES.open);
        document.body.classList.add(CLASSES.open, CLASSES.menuOpen);
        this.header?.classList.add(CLASSES.menuOpen);
        this.backgroundInert = inertOutside(this.header ?? this.navPanel, document.body);
        scrollLock(true);
        const ref = getRefs();
        setSearchOverlayOpenState(ref, false);
        if ('ontouchstart' in window) {
          if (this.focusTimout) clearTimeout(this.focusTimout);
          this.focusTimout = setTimeout(() => {
            this.burgerToggle?.focus();
            this.focusTimout = null;
          }, TIMEOUTS.COMMON_DELAY_300);
        } else {
          this.focusFirstElement(this.navPanel);
        }
        this.updateThemeColor(true);
      };
      closeMobileNav = () => {
        if (this.burgerToggle) {
          this.burgerToggle.ariaExpanded = 'false';
          this.syncBurgerLabel(false);
        }
        if (this.navPanel) {
          this.navPanel.classList.remove(CLASSES.open);
          const hidePanel = isMobile$1();
          this.navPanel.ariaHidden = String(hidePanel);
          this.navPanel.inert = hidePanel;
        }
        document.body.classList.remove(CLASSES.open, CLASSES.menuOpen, CLASSES.menuOpeningLevel2);
        this.header?.classList.remove(CLASSES.menuOpen);
        this.closeActiveL2();
        this.closeActiveL1();
        this.activeL1 = null;
        releaseInert(this.backgroundInert);
        this.backgroundInert = [];
        releaseInert(this.levelInert);
        this.levelInert = [];
        scrollLock(false);
        this.updateThemeColor(false);
      };
      handleL1MouseEnter = e => {
        if (isMobile$1() || document.body.classList.contains('search-open')) return;
        const targetLi = e.currentTarget;
        const trigger = this.l1ItemToTrigger.get(targetLi);
        if (!trigger) return;
        const panel = this.l1ItemToPanel.get(targetLi);
        if (!panel || !this.panelHasSubmenu(panel)) return;
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer);
          this.hoverTimer = null;
        }
        if (this.activeL1 && this.activeL1 !== targetLi) {
          this.closeAllDropdowns();
        }
        trigger.ariaExpanded = 'true';
        this.activeL1 = targetLi;
        this.activeL1Trigger = trigger;
        this.header?.classList.add(CLASSES.menuOpen);
        document.body.classList.add(CLASSES.menuOpen);
        this.enableContainer(panel);
        this.activePanel = panel;
        this.autoSelectFirstL2(panel);
      };
      handleL1MouseLeave = () => {
        if (isMobile$1()) return;
        if (this.hoverTimer) {
          clearTimeout(this.hoverTimer);
        }
        this.hoverTimer = window.setTimeout(() => {
          this.closeAllDropdowns();
        }, HOVER_CLOSE_DELAY);
      };
      handleL1Open = e => {
        const trigger = e.currentTarget;
        const isExpanded = trigger.ariaExpanded === 'true';
        const isLink = trigger.tagName === 'A';
        if (isMobile$1()) {
          if (isLink) e.preventDefault();
          this.closeActiveL2();
          this.closeActiveL1();
          trigger.ariaExpanded = 'true';
          this.activeL1Trigger = trigger;
          document.body.classList.add(CLASSES.menuOpeningLevel2);
          this.navPanel?.scrollTo({
            top: 0
          });
          const panel = this.l1TriggerToPanel.get(trigger);
          if (panel) {
            this.enableContainer(panel);
            this.activePanel = panel;
            const firstWrapper = panel.querySelector(`${SELECTORS.menuL2Wrapper}:not(.md-lg-only)`);
            if (firstWrapper) this.enableContainer(firstWrapper);
            if (this.navPanel) {
              this.levelInert = inertOutside(panel, this.navPanel);
            }
            this.focusFirstElement(panel);
          }
          this.activeL1 = trigger.closest(SELECTORS.menuItem);
        } else {
          const parentLi = trigger.closest(SELECTORS.menuItem);
          if (isLink && (this.activeL1 === parentLi || parentLi?.matches(':hover'))) return;
          const panel = this.l1TriggerToPanel.get(trigger);
          const hasSubmenu = !!panel && this.panelHasSubmenu(panel);
          if (isLink && !hasSubmenu) {
            window.location.href = trigger.href;
            return;
          }
          if (isLink) e.preventDefault();
          this.closeAllDropdowns();
          if (!isExpanded && panel && hasSubmenu) {
            trigger.ariaExpanded = 'true';
            this.activeL1Trigger = trigger;
            this.header?.classList.add(CLASSES.menuOpen);
            document.body.classList.add(CLASSES.menuOpen);
            this.activeL1 = trigger.closest(SELECTORS.menuItem);
            this.enableContainer(panel);
            this.activePanel = panel;
            this.autoSelectFirstL2(panel);
          }
        }
      };
      selectL2Desktop = trigger => {
        this.closeActiveL2();
        trigger.ariaExpanded = 'true';
        this.activeL2Trigger = trigger;
        const wrapper = this.l2TriggerToWrapper.get(trigger);
        if (wrapper) {
          this.enableContainer(wrapper);
          this.activeWrapper = wrapper;
          this.focusFirstElement(wrapper);
        }
      };
      handleL2Click = e => {
        const trigger = e.currentTarget;
        const isExpanded = trigger.ariaExpanded === 'true';
        if (isMobile$1()) {
          const willExpand = !isExpanded;
          if (willExpand) this.closeActiveL2();
          trigger.ariaExpanded = String(willExpand);
          this.activeL2Trigger = willExpand ? trigger : null;
          const wrapper = this.l2TriggerToWrapper.get(trigger);
          if (!wrapper) return;
          if (willExpand) {
            this.enableContainer(wrapper);
            this.activeWrapper = wrapper;
            this.focusFirstElement(wrapper);
          } else {
            this.disableContainer(wrapper);
            this.activeWrapper = null;
          }
        } else {
          const panel = trigger.closest(SELECTORS.menuPanel);
          if (panel && this.isPanelPackshot(panel)) return;
          this.selectL2Desktop(trigger);
        }
      };
      handleL2Hover = e => {
        if (isMobile$1()) return;
        const trigger = e.currentTarget;
        if (trigger.ariaExpanded === 'true') return;
        const panel = trigger.closest(SELECTORS.menuPanel);
        if (panel && this.isPanelPackshot(panel)) return;
        this.selectL2Desktop(trigger);
      };
      handlePanelBack = e => {
        const backBtn = e.currentTarget;
        const panel = backBtn.closest(SELECTORS.menuPanel);
        if (!panel) return;
        const l1Trigger = this.panelToL1Trigger.get(panel);
        releaseInert(this.levelInert);
        this.levelInert = [];
        if (l1Trigger) {
          l1Trigger.ariaExpanded = 'false';
          l1Trigger.focus();
        }
        this.disableContainer(panel);
        document.body.classList.remove(CLASSES.menuOpeningLevel2);
        this.closeActiveL2();
        this.activeL1Trigger = null;
        this.activePanel = null;
        this.activeL1 = null;
      };
      handlePanelGridBack = e => {
        const backBtn = e.currentTarget;
        const wrapper = backBtn.closest(SELECTORS.menuL2Wrapper);
        if (!wrapper) return;
        wrapper.ariaHidden = 'true';
        const l2Trigger = this.wrapperToL2Trigger.get(wrapper);
        if (l2Trigger) {
          l2Trigger.ariaExpanded = 'false';
          l2Trigger.focus();
        } else {
          const wrapperId = wrapper.id;
          const fallbackTrigger = this.querySelector(`[aria-controls="${wrapperId}"]`);
          if (fallbackTrigger) {
            fallbackTrigger.ariaExpanded = 'false';
            fallbackTrigger.focus();
          }
        }
        this.activeL2Trigger = null;
        this.activeWrapper = null;
      };
      handleKeyDown = e => {
        const target = e.target;
        switch (e.key) {
          case 'Enter':
          case ' ':
            {
              if (target.hasAttribute('data-ref') && target.dataset.ref?.includes('menu-trigger')) {
                e.preventDefault();
                target.click();
              }
              break;
            }
          case 'Escape':
            {
              if (isMobile$1()) {
                if (this.activeL1Trigger) {
                  const trigger = this.activeL1Trigger;
                  document.body.classList.remove(CLASSES.menuOpeningLevel2);
                  this.closeActiveL2();
                  this.closeActiveL1();
                  this.activeL1 = null;
                  trigger.focus();
                } else if (this.navPanel?.classList.contains(CLASSES.open)) {
                  this.handleBurgerClick();
                  this.burgerToggle?.focus();
                }
              } else {
                const trigger = this.activeL1 ? this.l1ItemToTrigger.get(this.activeL1) : undefined;
                this.closeAllDropdowns();
                trigger?.focus();
              }
              break;
            }
          case 'Tab':
            {
              if (isMobile$1() && this.navPanel?.classList.contains(CLASSES.open)) this.wrapTabWithinLayer(e);else this.handleTabLayeredNavigation(e, target);
              break;
            }
        }
      };
      handleTabLayeredNavigation = (e, target) => {
        if (!this.activePanel) return;
        if (isMobile$1()) return;
        const isForward = !e.shiftKey;
        if (this.activeWrapper) {
          const focusables = getVisibleFocusableElements(this.activeWrapper);
          const atBoundary = isForward && target === focusables[focusables.length - 1] || !isForward && target === focusables[0];
          if (atBoundary) {
            e.preventDefault();
            if (isForward) {
              if (this.activeL2Trigger) {
                this.activeL1Trigger?.focus();
                this.closeAllDropdowns();
              } else if (this.activeL1Trigger) {
                if (this.activePanel && this.isPanelPackshot(this.activePanel)) {
                  const currentIndex = this.l1Triggers.indexOf(this.activeL1Trigger);
                  const nextTrigger = this.l1Triggers[currentIndex + 1] ?? null;
                  this.closeAllDropdowns();
                  nextTrigger?.focus();
                } else {
                  this.activeL1Trigger.focus();
                  this.closeAllDropdowns();
                }
              }
            } else {
              if (this.activeL2Trigger) this.activeL2Trigger.focus();else if (this.activeL1Trigger) {
                this.activeL1Trigger.focus();
                this.closeAllDropdowns();
              }
            }
            return;
          }
        }
        const l2Triggers = this.panelToL2Triggers.get(this.activePanel) ?? [];
        const atL2Boundary = isForward && target === l2Triggers[l2Triggers.length - 1] || !isForward && target === l2Triggers[0];
        if (atL2Boundary) {
          e.preventDefault();
          this.activeL1Trigger?.focus();
          this.closeAllDropdowns();
        }
      };
      handleScroll = () => {
        const scrolled = this.isScrolled();
        this.header?.classList.toggle(CLASSES.scrolled, scrolled);
        document.body.classList.toggle(CLASSES.scrolled, scrolled);
        this.setCSSVariables();
      };
      handleResize = () => {
        if (!isMobile$1() && this.navPanel?.classList.contains(CLASSES.open)) {
          this.closeMobileNav();
        }
        this.handleScroll();
      };
      setCSSVariables = () => {
        if (!this.header) return;
        const {
          height
        } = this.header.getBoundingClientRect();
        const isSmall = window.innerWidth < breakpoints.sm;
        const translate = !this.isScrolled() || isSmall ? 0 : 20;
        const headerHeight = `${height - translate}px`;
        const fullHeight = this.hasAnnouncementBar ? `${height - translate + 30}px` : `${height - translate}px`;
        const initHeaderHeight = this.hasAnnouncementBar ? `${height + 30}px` : `${height}px`;
        document.body.style.setProperty('--init-header-height', initHeaderHeight);
        document.body.style.setProperty('--header-height', headerHeight);
        document.body.style.setProperty('--full-header-height', fullHeight);
        document.body.style.setProperty('--full-height', `${window.innerHeight}px`);
      };
      updateThemeColor = menuOpen => {
        const pageColor = document.body.classList.contains('theme-beige') ? '#EDEAE7' : 'transparent';
        const metaThemeColor = document.querySelector("meta[name='theme-color']");
        if (!metaThemeColor) return;
        metaThemeColor.content = menuOpen ? '#fff' : pageColor;
      };
      handleCartUpdate = fetchCart;
      handleSearchToggled = e => {
        const {
          isOpen
        } = e.detail;
        if (isOpen) {
          if (!isMobile$1()) {
            this.closeAllDropdowns();
          }
        }
      };
      handleSplitLinkEnter = e => {
        if (isMobile$1()) return;
        if (this.splitPreviewTimer) {
          clearTimeout(this.splitPreviewTimer);
          this.splitPreviewTimer = null;
        }
        const link = e.currentTarget;
        const imageUrl = link.dataset.featuredImageUrl;
        if (!imageUrl) return;
        const splitContainer = link.closest(SELECTORS.menuPanelSplit);
        if (!splitContainer) return;
        const preview = splitContainer.querySelector(SELECTORS.menuPanelSplitHoverPreview);
        if (!preview) return;
        preview.ariaHidden = 'false';
        const img = preview.querySelector('img');
        if (img) {
          img.src = imageUrl;
          img.alt = link.textContent?.trim() ?? '';
          img.ariaHidden = 'false';
        }
        const title = preview.querySelector(SELECTORS.menuPanelSplitHoverPreviewTitle);
        if (title) {
          title.textContent = link.textContent?.trim() ?? '';
        }
        const imageItems = splitContainer.querySelectorAll(SELECTORS.menuPanelSplitImageItem);
        imageItems.forEach(item => {
          item.style.visibility = 'hidden';
        });
        preview.classList.add('is-active');
      };
      handleSplitLinkLeave = e => {
        if (isMobile$1()) return;
        const link = e.currentTarget;
        const splitContainer = link.closest(SELECTORS.menuPanelSplit);
        if (!splitContainer) return;
        this.splitPreviewTimer = window.setTimeout(() => {
          const preview = splitContainer.querySelector(SELECTORS.menuPanelSplitHoverPreview);
          if (preview) {
            preview.classList.remove('is-active');
            preview.ariaHidden = 'true';
          }
          const imageItems = splitContainer.querySelectorAll(SELECTORS.menuPanelSplitImageItem);
          imageItems.forEach(item => {
            item.style.visibility = '';
          });
          this.splitPreviewTimer = null;
        }, 300);
      };
      static define = () => {
        if (!customElements.get('component-header-menu')) {
          customElements.define('component-header-menu', ComponentHeaderMenu);
        }
      };
    }
    var componentHeaderMenu = () => {
      ComponentHeaderMenu.define();
    };

    var componentHeaderMenu$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ComponentHeaderMenu: ComponentHeaderMenu,
        default: componentHeaderMenu
    });

    const {
      getElementsByRef: getElementsByRef$3,
      getElementByRef: getElementByRef$6
    } = window.PoleneLibs.Refs;
    var sectionCountdownTeaser = () => {
      const {
        countdownTeaser
      } = getElementsByRef$3('countdown-teaser');
      if (!countdownTeaser) return;
      const countdownTeasers = Array.isArray(countdownTeaser) ? countdownTeaser : [countdownTeaser];
      const cleaners = [];
      countdownTeasers.forEach(teaser => {
        const {
          days,
          hours,
          minutes,
          seconds
        } = getElementByRef$6(['days', 'hours', 'minutes', 'seconds'], teaser);
        const {
          targetDate
        } = teaser.dataset;
        if (!days || !hours || !minutes || !seconds || !targetDate) return;
        const target = new Date(targetDate).getTime();
        if (isNaN(target)) return;
        const updateCountdown = () => {
          const now = Date.now();
          let diff = target - now;
          if (diff <= 0) {
            days.textContent = '00';
            hours.textContent = '00';
            minutes.textContent = '00';
            seconds.textContent = '00';
            return;
          }
          const d = Math.floor(diff / (1000 * 60 * 60 * 24));
          diff -= d * (1000 * 60 * 60 * 24);
          const h = Math.floor(diff / (1000 * 60 * 60));
          diff -= h * (1000 * 60 * 60);
          const m = Math.floor(diff / (1000 * 60));
          diff -= m * (1000 * 60);
          const s = Math.floor(diff / 1000);
          days.textContent = String(d).padStart(2, '0');
          hours.textContent = String(h).padStart(2, '0');
          minutes.textContent = String(m).padStart(2, '0');
          seconds.textContent = String(s).padStart(2, '0');
        };
        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);
        const cleanup = () => {
          clearInterval(intervalId);
        };
        cleaners.push(cleanup);
      });
      return () => cleaners.forEach(cleaner => cleaner());
    };

    var sectionCountdownTeaser$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionCountdownTeaser
    });

    const {
      BaseComponent: BaseComponent$6
    } = window.PoleneLibs.BaseComponent;
    const {
      relocateElementIfNeeded: relocateElementIfNeeded$1
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$5
    } = window.PoleneLibs.Refs;
    const {
      morph: morph$1
    } = window.PoleneLibs.DOMMorph;
    class ProductRecommendations extends BaseComponent$6 {
      activeFetch = null;
      sectionId = undefined;
      productId = undefined;
      intent = undefined;
      recommendationsPerformed = false;
      url = undefined;
      cache = {};
      onlyWishlistEmpty = false;
      minQtyWishlist = 3;
      isFailover = false;
      slidesContainer = undefined;
      carousel = null;
      onMount() {
        const parent = this.parentElement;
        relocateElementIfNeeded$1(this);
        if (this.parentElement !== parent) return;
        this.initializeElements();
        this.setupEventListeners();
        if (!this.recommendationsPerformed) this.render();
      }
      onUnmount() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          sectionId,
          productId,
          recommendationsPerformed,
          url,
          intent,
          onlyWishlistEmpty,
          minQtyWishlist,
          isFailover
        } = this.dataset;
        const {
          carouselSlidesContainer
        } = getElementByRef$5('carousel-slides-container', this);
        this.slidesContainer = carouselSlidesContainer;
        this.carousel = this.querySelector('component-carousel');
        this.sectionId = sectionId;
        this.productId = productId;
        this.intent = intent;
        this.recommendationsPerformed = recommendationsPerformed === 'true';
        this.url = url;
        this.onlyWishlistEmpty = onlyWishlistEmpty === 'true';
        this.minQtyWishlist = !!minQtyWishlist ? +minQtyWishlist : this.minQtyWishlist;
        this.isFailover = isFailover === 'true';
      };
      setupEventListeners = () => {
        if (this.onlyWishlistEmpty) Wishlist.setEventListeners(WishlistEvent.UPDATE, this.render);
      };
      removeEventListeners = () => {
        if (this.onlyWishlistEmpty) Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.render);
      };
      render = async () => {
        if (!this.slidesContainer) return;
        if (this.onlyWishlistEmpty && Wishlist.count() >= this.minQtyWishlist) {
          this.classList.remove('visible');
          return;
        }
        if (this.isFailover === true) {
          this.classList.add('visible');
          return;
        }
        const section = await this.requestSection();
        if (!section.success || !section.data) return;
        const parsedDoc = new DOMParser().parseFromString(section.data, 'text/html');
        const newSlidesContainer = parsedDoc.querySelector('[data-ref="carousel-slides-container"]');
        if (newSlidesContainer) {
          morph$1(this.slidesContainer, newSlidesContainer);
          this.carousel?.updatedCallback();
          this.classList.add('visible');
        }
      };
      requestSection = async () => {
        const url = `${this.url}&product_id=${this.productId}&section_id=${this.sectionId}&intent=${this.intent}`;
        const cachedResponse = this.cache[url];
        if (cachedResponse) {
          return {
            success: true,
            data: cachedResponse
          };
        }
        this.activeFetch?.abort();
        this.activeFetch = new AbortController();
        try {
          const response = await fetch(url, {
            signal: this.activeFetch?.signal
          });
          if (!response.ok) return {
            success: false,
            status: response.status
          };
          const text = await response.text();
          this.cache[url] = text;
          return {
            success: true,
            data: text
          };
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            return {
              success: false,
              status: 0
            };
          }
          throw error;
        } finally {
          this.activeFetch = null;
        }
      };
      static define = () => {
        if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
      };
    }
    var sectionProductRecommendations = () => {
      ProductRecommendations.define();
    };

    var sectionProductRecommendations$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        ProductRecommendations: ProductRecommendations,
        default: sectionProductRecommendations
    });

    const {
      BaseComponent: BaseComponent$5
    } = window.PoleneLibs.BaseComponent;
    const {
      relocateElementIfNeeded
    } = window.PoleneLibs.Utils;
    const {
      getElementByRef: getElementByRef$4
    } = window.PoleneLibs.Refs;
    const {
      morph
    } = window.PoleneLibs.DOMMorph;
    class WishlistSlider extends BaseComponent$5 {
      slidesContainer = undefined;
      carousel = null;
      minQtyWishlist = 3;
      onMount() {
        const parent = this.parentElement;
        relocateElementIfNeeded(this);
        if (this.parentElement !== parent) return;
        this.initializeElements();
        this.setupEventListeners();
        if (this.slidesContainer) this.renderSlides();
      }
      onUnmount() {
        this.removeEventListeners();
      }
      initializeElements = () => {
        const {
          carouselSlidesContainer
        } = getElementByRef$4('carousel-slides-container', this);
        const {
          minQtyWishlist
        } = this.dataset;
        this.slidesContainer = carouselSlidesContainer;
        this.carousel = this.querySelector('component-carousel');
        this.minQtyWishlist = !!minQtyWishlist ? +minQtyWishlist : this.minQtyWishlist;
      };
      setupEventListeners = () => {
        Wishlist.setEventListeners(WishlistEvent.UPDATE, this.renderSlides);
      };
      removeEventListeners = () => {
        Wishlist.removeEventListeners(WishlistEvent.UPDATE, this.renderSlides);
      };
      renderSlides = async () => {
        if (!this.slidesContainer) return;
        const hasEnoughItems = Wishlist.count() >= this.minQtyWishlist;
        if (!hasEnoughItems) {
          this.classList.remove('visible');
          return;
        }
        const slides = await Wishlist.getHTML('slides');
        if (slides && slides.length > 1) {
          const parsedDoc = new DOMParser().parseFromString(slides, 'text/html');
          const tempContainer = this.slidesContainer.cloneNode(false);
          tempContainer.innerHTML = parsedDoc.body.innerHTML;
          morph(this.slidesContainer, tempContainer);
          this.carousel?.updatedCallback();
          this.classList.add('visible');
        } else {
          this.classList.remove('visible');
        }
      };
      static define = () => {
        if (!customElements.get('wishlist-slider')) customElements.define('wishlist-slider', WishlistSlider);
      };
    }
    var sectionWishlistSlider = () => {
      WishlistSlider.define();
    };

    var sectionWishlistSlider$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        WishlistSlider: WishlistSlider,
        default: sectionWishlistSlider
    });

    const {
      BaseComponent: BaseComponent$4
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementsByRef: getElementsByRef$2
    } = window.PoleneLibs.Refs;
    class FeaturedMediaFrieze extends BaseComponent$4 {
      featuredItems = [];
      thumbnailItems = [];
      activeIndex = 0;
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
      }
      initializeElements = () => {
        const {
          featuredItem,
          thumbnailItem
        } = getElementsByRef$2(['featured-item', 'thumbnail-item'], this);
        this.featuredItems = [featuredItem ?? []].flat();
        this.thumbnailItems = [thumbnailItem ?? []].flat();
        const activeFromDom = this.featuredItems.findIndex(el => el.classList.contains('active'));
        this.activeIndex = activeFromDom >= 0 ? activeFromDom : 0;
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        this.thumbnailItems.forEach(item => item.addEventListener('click', this.handleThumbnailClick, {
          signal
        }));
        this.addEventListener('shopify:block:select', this.handleBlockSelect, {
          signal
        });
      };
      handleThumbnailClick = event => {
        const target = event.currentTarget;
        const index = Number(target.dataset.index);
        if (isNaN(index) || index === this.activeIndex) return;
        this.setActive(index);
      };
      handleBlockSelect = event => {
        const target = event.target;
        if (!(target instanceof HTMLElement)) return;
        const block = target.closest('[data-ref="featured-item"], [data-ref="thumbnail-item"]');
        if (!block) return;
        const index = Number(block.dataset.index);
        if (isNaN(index) || index === this.activeIndex) return;
        this.setActive(index);
      };
      handleFocusout = () => {
        this.thumbnailItems[this.activeIndex].focus();
      };
      setActive = index => {
        const {
          signal
        } = this.controller;
        const currentFeatured = this.featuredItems[this.activeIndex];
        const currentThumbnail = this.thumbnailItems[this.activeIndex];
        const nextFeatured = this.featuredItems[index];
        const nextThumbnail = this.thumbnailItems[index];
        if (!nextFeatured || !nextThumbnail) return;
        if (currentFeatured && currentThumbnail) {
          currentFeatured.classList.remove('active');
          currentFeatured.ariaHidden = 'true';
          currentThumbnail.classList.remove('active');
          currentThumbnail.ariaSelected = 'false';
        }
        nextFeatured.classList.add('active');
        nextFeatured.ariaHidden = 'false';
        nextFeatured.focus();
        nextFeatured.addEventListener('focusout', this.handleFocusout, {
          signal,
          once: true
        });
        nextThumbnail.classList.add('active');
        nextThumbnail.ariaSelected = 'true';
        this.activeIndex = index;
      };
      static define = () => {
        if (!customElements.get('featured-media-frieze')) {
          customElements.define('featured-media-frieze', FeaturedMediaFrieze);
        }
      };
    }
    var sectionFeaturedMediaFrieze = () => {
      FeaturedMediaFrieze.define();
    };

    var sectionFeaturedMediaFrieze$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionFeaturedMediaFrieze
    });

    const {
      getElementByRef: getElementByRef$3,
      getElementsByRef: getElementsByRef$1
    } = window.PoleneLibs.Refs;
    const {
      BaseComponent: BaseComponent$3
    } = window.PoleneLibs.BaseComponent;
    class StickyTextGallery extends BaseComponent$3 {
      medias = [];
      fallbackColor = '';
      rafId = 0;
      ticking = false;
      isVisible = false;
      onMount() {
        this.initializeElements();
        this.setupVisibilityObserver();
      }
      onUnmount() {
        cancelAnimationFrame(this.rafId);
        this.visibilityObserver?.disconnect();
      }
      initializeElements = () => {
        const {
          stickyTextGalleryText
        } = getElementByRef$3(['sticky-text-gallery-text'], this);
        const {
          stickyTextGalleryMedia
        } = getElementsByRef$1(['sticky-text-gallery-media'], this);
        this.textEl = stickyTextGalleryText;
        this.medias = [stickyTextGalleryMedia ?? []].flat();
        this.fallbackColor = this.dataset.fallbackColor || '';
      };
      setupVisibilityObserver = () => {
        this.visibilityObserver = new IntersectionObserver(this.handleVisibility, {
          threshold: 0
        });
        this.visibilityObserver.observe(this);
      };
      handleVisibility = entries => {
        const isVisible = entries[0].isIntersecting;
        if (isVisible && !this.isVisible) {
          window.addEventListener('scroll', this.onScroll, {
            passive: true,
            signal: this.controller?.signal
          });
          this.updateColor();
        } else if (!isVisible && this.isVisible) {
          window.removeEventListener('scroll', this.onScroll);
          cancelAnimationFrame(this.rafId);
          this.ticking = false;
        }
        this.isVisible = isVisible;
      };
      updateColor = () => {
        if (!this.textEl || !this.medias.length) return;
        const textRect = this.textEl.getBoundingClientRect();
        const textMid = textRect.top + textRect.height / 2;
        for (let i = 0; i < this.medias.length; i++) {
          const media = this.medias[i];
          const rect = media.getBoundingClientRect();
          if (rect.top <= textMid && rect.bottom >= textMid) {
            this.textEl.style.color = media.dataset.textColor || this.fallbackColor;
            return;
          }
        }
      };
      onScroll = () => {
        if (!this.ticking) {
          this.rafId = requestAnimationFrame(() => {
            this.updateColor();
            this.ticking = false;
          });
          this.ticking = true;
        }
      };
      static define = () => {
        if (!customElements.get('sticky-text-gallery')) customElements.define('sticky-text-gallery', StickyTextGallery);
      };
    }
    var sectionStickyTextGallery = () => {
      StickyTextGallery.define();
    };

    var sectionStickyTextGallery$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionStickyTextGallery
    });

    const {
      BaseComponent: BaseComponent$2
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef: getElementByRef$2,
      getElementsByRef
    } = window.PoleneLibs.Refs;
    class SectionVideoGallery extends BaseComponent$2 {
      videoTriggers = [];
      modalVideoWrappers = [];
      currentIndex = 0;
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
      }
      onUnmount() {
        this.resizeObserver?.disconnect();
        this.resizeObserver = undefined;
      }
      initializeElements = () => {
        const {
          videoGalleryModalNext,
          videoGalleryModalHeader,
          videoGalleryModalBody
        } = getElementByRef$2(['video-gallery-modal-next', 'video-gallery-modal-header', 'video-gallery-modal-body'], this);
        const {
          videoGalleryOpen,
          videoGalleryModalVideo
        } = getElementsByRef(['video-gallery-open', 'video-gallery-modal-video'], this);
        this.videoTriggers = [videoGalleryOpen ?? []].flat();
        this.modalVideoWrappers = [videoGalleryModalVideo ?? []].flat();
        this.nextButton = videoGalleryModalNext;
        this.modalHeader = videoGalleryModalHeader;
        this.modalBody = videoGalleryModalBody;
      };
      setupEventListeners = () => {
        const {
          signal
        } = this.controller;
        document.addEventListener('modal', this.handleModalEvent, {
          signal
        });
        this.nextButton?.addEventListener('click', this.handleNext, {
          signal
        });
        this.modalVideoWrappers.forEach(wrapper => {
          const video = wrapper.querySelector('video');
          video?.addEventListener('click', this.handleVideoClick, {
            signal
          });
        });
        if (this.modalBody) {
          this.resizeObserver?.disconnect();
          this.resizeObserver = new ResizeObserver(() => {
            const wrapper = this.modalVideoWrappers[this.currentIndex];
            if (wrapper?.classList.contains('is-active')) this.syncHeaderToVideo(wrapper);
          });
          this.resizeObserver.observe(this.modalBody);
        }
      };
      handleVideoClick = e => {
        const video = e.currentTarget;
        const wrapper = video.closest('.video-gallery__modal-video-wrapper');
        if (!wrapper) return;
        this.handleVideo(wrapper);
      };
      handleVideo(wrapper) {
        const video = wrapper.querySelector('video');
        if (!video) return;
        if (video.paused) this.playVideo(wrapper);else video.pause();
      }
      playVideo = wrapper => {
        const video = wrapper.querySelector('video');
        if (!video) return;
        video.play().catch(() => {
          video.addEventListener('canplay', () => {
            if (wrapper.classList.contains('is-active')) video.play().catch(() => {});
          }, {
            once: true,
            signal: this.controller.signal
          });
        });
      };
      stopVideo = wrapper => {
        const video = wrapper.querySelector('video');
        if (!video) return;
        video.pause();
        video.currentTime = 0;
      };
      handleModalEvent = event => {
        const modalEvent = event;
        if (modalEvent.detail.type !== 'video-gallery') return;
        if (modalEvent.detail.action === 'open' && modalEvent.detail.submitter) {
          const index = this.videoTriggers.indexOf(modalEvent.detail.submitter);
          this.currentIndex = index === -1 ? 0 : index;
          this.showVideo(this.currentIndex);
        }
        if (modalEvent.detail.action === 'close') {
          this.stopAll();
        }
      };
      handleNext = () => {
        if (!this.modalVideoWrappers.length) return;
        this.currentIndex = (this.currentIndex + 1) % this.modalVideoWrappers.length;
        this.showVideo(this.currentIndex);
      };
      showVideo = index => {
        this.modalVideoWrappers.forEach((wrapper, wrapperIndex) => {
          if (wrapperIndex === index) return;
          wrapper.classList.remove('is-active');
          this.stopVideo(wrapper);
        });
        const wrapper = this.modalVideoWrappers[index];
        if (!wrapper) return;
        wrapper.classList.add('is-active');
        this.playVideo(wrapper);
        this.syncHeaderToVideo(wrapper);
      };
      syncHeaderToVideo = wrapper => {
        const video = wrapper.querySelector('video');
        if (!video || !this.modalHeader || !this.modalBody) return;
        const apply = () => {
          if (!this.modalHeader || !this.modalBody) return;
          const videoWidth = video.videoWidth || Number(video.getAttribute('width')) || 0;
          const videoHeight = video.videoHeight || Number(video.getAttribute('height')) || 0;
          if (!videoWidth || !videoHeight) {
            this.modalHeader.style.width = '';
            return;
          }
          const {
            width: bodyWidth,
            height: bodyHeight
          } = this.modalBody.getBoundingClientRect();
          if (!bodyWidth || !bodyHeight) return;
          const videoRatio = videoWidth / videoHeight;
          const bodyRatio = bodyWidth / bodyHeight;
          const displayWidth = bodyRatio > videoRatio ? bodyHeight * videoRatio : bodyWidth;
          this.modalHeader.style.width = `${displayWidth}px`;
        };
        requestAnimationFrame(apply);
        if (video.readyState < 1) {
          video.addEventListener('loadedmetadata', apply, {
            once: true,
            signal: this.controller.signal
          });
        }
      };
      stopAll = () => {
        this.modalVideoWrappers.forEach(wrapper => this.stopVideo(wrapper));
      };
      static define = () => {
        if (!customElements.get('video-gallery')) {
          customElements.define('video-gallery', SectionVideoGallery);
        }
      };
    }
    var sectionVideoGallery = () => {
      SectionVideoGallery.define();
    };

    var sectionVideoGallery$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: sectionVideoGallery
    });

    const SAP_DOWNLOAD_BASE_PATHS = {
      invoice: API_PROXY.ORDER_INVOICE,
      credit_note: API_PROXY.ORDER_CREDIT_NOTE
    };
    class InvoiceRedirection extends HTMLElement {
      urlParameters = {};
      connectedCallback() {
        this.controller = new AbortController();
        this.init();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = undefined;
      }
      updatedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.init();
      }
      init() {
        this.retrieveUrlParameters();
        const redirectUrl = this.buildRedirectUrl();
        if (redirectUrl) {
          const button = this.querySelector('.invoice-redirection__button');
          if (button) {
            button.href = redirectUrl;
          }
          window.location.href = redirectUrl;
        }
      }
      retrieveUrlParameters() {
        try {
          const decodedSearch = decodeURIComponent(window.location.search);
          const searchParams = new URLSearchParams(decodedSearch);
          const specificParams = ['type', 'id', 'invoice_name', 'invoice', 'document_key', 'credit_note_name', 'credit_note'];
          specificParams.forEach(param => {
            const value = searchParams.get(param);
            if (value) {
              this.urlParameters[param] = value;
            }
          });
        } catch (error) {}
      }
      getUrlParameter(key) {
        return this.urlParameters[key];
      }
      getDownloadType() {
        const typeParam = this.getUrlParameter('type');
        if (typeParam === 'credit_note' || typeParam === 'invoice') {
          return typeParam;
        }
        return 'invoice';
      }
      buildRedirectUrl() {
        const id = this.getUrlParameter('id') ?? '';
        const downloadType = this.getDownloadType();
        const basePath = SAP_DOWNLOAD_BASE_PATHS[downloadType];
        if (downloadType === 'invoice') {
          const invoice = this.getUrlParameter('invoice') ?? '';
          const invoiceName = this.getUrlParameter('invoice_name') ?? '';
          if (!invoiceName || !id) return null;
          const queryParams = new URLSearchParams();
          queryParams.set('id', id);
          if (invoice) queryParams.set('invoice', invoice);
          const queryString = queryParams.toString();
          return `${basePath}/${invoiceName}${queryString ? '?' + queryString : ''}`;
        }
        const documentKey = this.getUrlParameter('credit_note_name') ?? this.getUrlParameter('document_key') ?? '';
        const creditNoteSignature = this.getUrlParameter('credit_note') ?? '';
        if (!documentKey || !creditNoteSignature || !id) return null;
        const queryParams = new URLSearchParams();
        queryParams.set('credit_note', creditNoteSignature);
        queryParams.set('id', id);
        return `${basePath}/${documentKey}?${queryParams.toString()}`;
      }
      static define = () => {
        if (!customElements.get('invoice-redirection')) {
          customElements.define('invoice-redirection', InvoiceRedirection);
        }
      };
    }
    var componentSapDownloadRedirection = () => {
      InvoiceRedirection.define();
    };

    var componentSapDownloadRedirection$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        InvoiceRedirection: InvoiceRedirection,
        default: componentSapDownloadRedirection
    });

    const {
      BaseComponent: BaseComponent$1
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef: getElementByRef$1
    } = window.PoleneLibs.Refs;
    const {
      dispatchEvent
    } = window.PoleneLibs.Utils;
    const events = window.PoleneLibs.Events.default;
    const {
      isMobile
    } = window.PoleneLibs.Utils;
    class ComponentVideoControls extends BaseComponent$1 {
      fullscreenBtn = null;
      fullscreenIcon = null;
      exitFullscreenIcon = null;
      videoSection = null;
      video = null;
      videoId = '';
      videoThumb = null;
      videoWrapper = null;
      hasUserIntent = false;
      isFullScreen = false;
      isCursorOver = false;
      isOverControls = false;
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
        if (this.reducedMotion?.matches) this.video?.pause();
      }
      initializeElements = () => {
        const refs = getElementByRef$1(['fullscreen-btn', 'fullscreen-icon', 'exit-fullscreen-icon'], this);
        this.fullscreenBtn = refs.fullscreenBtn ?? null;
        this.fullscreenIcon = refs.fullscreenIcon ?? null;
        this.exitFullscreenIcon = refs.exitFullscreenIcon ?? null;
        this.videoSection = this.closest('.video-section');
        this.video = this.parentElement?.querySelector('video[data-streaming-id]') ?? null;
        if (!this.video) return;
        this.videoId = this.video.dataset.streamingId || '';
        this.videoThumb = this.closest('product-packshot')?.querySelector(`[data-video-id="${this.videoId}"]`) ?? null;
        if (!this.video.paused) this.videoThumb?.classList.add('is-playing');
        this.videoWrapper = this.video.closest('.product-packshot__video-wrapper') ?? this.videoSection ?? null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.hasUserIntent = false;
      };
      setupEventListeners = () => {
        const signal = this.controller.signal;
        this.fullscreenBtn?.addEventListener('click', this.handleFullscreenClick, {
          signal
        });
        document.addEventListener('fullscreenchange', this.handleFullscreenChange, {
          signal
        });
        document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange, {
          signal
        });
        this.reducedMotion?.addEventListener('change', this.handleReducedMotionChange, {
          signal
        });
        if (!this.videoWrapper || !this.video) return;
        if (this.videoThumb) {
          this.video.addEventListener('play', () => this.videoThumb?.classList.add('is-playing'), {
            signal
          });
          this.video.addEventListener('pause', () => this.videoThumb?.classList.remove('is-playing'), {
            signal
          });
        }
        this.videoWrapper.addEventListener('click', this.handleClick, {
          signal
        });
        this.videoWrapper.addEventListener('click', this.handleUserIntent, {
          signal,
          capture: true
        });
        this.videoWrapper.addEventListener('mouseenter', this.handleVideoWrapperMouseEnter, {
          signal
        });
        this.videoWrapper.addEventListener('mouseleave', this.handleVideoWrapperMouseLeave, {
          signal
        });
        this.addEventListener('mouseenter', this.handleControlsMouseEnter, {
          signal
        });
        this.addEventListener('mouseleave', this.handleControlsMouseLeave, {
          signal
        });
        this.video.addEventListener('play', this.handleVideoPlay, {
          signal
        });
        this.video.addEventListener('pause', this.handleVideoPause, {
          signal
        });
      };
      getFullscreenElement = () => {
        const doc = document;
        return doc.fullscreenElement || doc.webkitFullscreenElement || null;
      };
      handleFullscreenChange = () => {
        const fullScreenElement = this.getFullscreenElement();
        this.isFullScreen = fullScreenElement !== null && fullScreenElement === this.videoSection;
        this.toggleFullscreenIcons(this.isFullScreen);
      };
      handleFullscreenClick = () => {
        if (this.getFullscreenElement()) {
          this.exitFullscreen();
        } else {
          this.enterFullscreen();
        }
      };
      enterFullscreen = async () => {
        if (!this.videoSection) return;
        const video = this.videoSection.querySelector('video');
        if (isMobile() && video?.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
          return;
        }
        try {
          const section = this.videoSection;
          if (section.requestFullscreen) {
            await section.requestFullscreen();
          } else if (section.webkitRequestFullscreen) {
            await section.webkitRequestFullscreen();
          }
        } catch (error) {}
      };
      exitFullscreen = async () => {
        const doc = document;
        if (doc.exitFullscreen) {
          await doc.exitFullscreen();
        } else if (doc.webkitExitFullscreen) {
          await doc.webkitExitFullscreen();
        }
      };
      toggleFullscreenIcons = isFullScreen => {
        if (isFullScreen) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default'
        });
        this.fullscreenIcon?.classList.toggle('hidden', isFullScreen);
        this.exitFullscreenIcon?.classList.toggle('hidden', !isFullScreen);
      };
      handleReducedMotionChange = event => {
        if (!event.matches) return;
        this.hasUserIntent = false;
        this.video?.pause();
      };
      handleVideoPlay = () => {
        if (this.reducedMotion?.matches && !this.hasUserIntent) {
          this.video?.pause();
          return;
        }
        if (this.isCursorOver && !this.isOverControls && !this.isFullScreen) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'pause',
          contrast: true
        });
      };
      handleVideoPause = () => {
        if (this.isCursorOver && !this.isOverControls && !this.isFullScreen) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'play',
          contrast: true
        });
      };
      handleUserIntent = () => {
        this.hasUserIntent = true;
      };
      handleClick = e => {
        if (e.target?.closest('[data-shopstream-role="video-controls"]') || this.isFullScreen || !this.video) return;
        if (this.video.paused) this.video.play();else this.video.pause();
      };
      handleVideoWrapperMouseEnter = () => {
        this.isCursorOver = true;
        if (!this.isOverControls && !this.isFullScreen && this.video) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: this.video.paused ? 'play' : 'pause',
          contrast: true
        });
      };
      handleVideoWrapperMouseLeave = () => {
        this.isCursorOver = false;
        if (!this.isFullScreen) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default'
        });
      };
      handleControlsMouseEnter = () => {
        this.isOverControls = true;
        if (!this.isFullScreen) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: 'default'
        });
      };
      handleControlsMouseLeave = () => {
        this.isOverControls = false;
        if (this.isCursorOver && !this.isFullScreen && this.video) dispatchEvent(window, events.CHANGE_CURSOR, {
          type: this.video.paused ? 'play' : 'pause',
          contrast: true
        });
      };
      static define = () => {
        if (!customElements.get('component-video-controls')) {
          customElements.define('component-video-controls', ComponentVideoControls);
        }
      };
    }
    var componentVideoControls = () => {
      ComponentVideoControls.define();
    };

    var componentVideoControls$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentVideoControls
    });

    const {
      BaseComponent
    } = window.PoleneLibs.BaseComponent;
    const {
      getElementByRef
    } = window.PoleneLibs.Refs;
    class ComponentVideoToggle extends BaseComponent {
      videos = [];
      isPaused = false;
      onMount() {
        this.initializeElements();
        this.setupEventListeners();
        if (this.reducedMotion?.matches) this.setPaused(true);
      }
      initializeElements = () => {
        const {
          videoToggleButton
        } = getElementByRef('video-toggle-button', this);
        this.button = videoToggleButton;
        this.videos = Array.from(this.parentElement?.querySelectorAll('video') ?? []).filter(this.ownsVideo);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.isPaused = false;
      };
      ownsVideo = video => {
        for (let node = video.parentElement; node && node !== this.parentElement; node = node.parentElement) {
          if (node.querySelector(':scope > component-video-toggle')) return false;
        }
        return true;
      };
      setupEventListeners = () => {
        const signal = this.controller.signal;
        this.button?.addEventListener('click', this.handleClick, {
          signal
        });
        this.reducedMotion?.addEventListener('change', this.handleReducedMotionChange, {
          signal
        });
        this.videos.forEach(video => video.addEventListener('play', this.handleVideoPlay, {
          signal
        }));
      };
      handleClick = () => this.setPaused(!this.isPaused);
      handleReducedMotionChange = event => this.setPaused(event.matches);
      handleVideoPlay = event => {
        if (this.isPaused) event.currentTarget.pause();
      };
      setPaused = isPaused => {
        this.isPaused = isPaused;
        this.classList.toggle('is-paused', isPaused);
        if (this.button) {
          const {
            ariaLabelPlay,
            ariaLabelPause
          } = this.button.dataset;
          this.button.setAttribute('aria-label', (isPaused ? ariaLabelPlay : ariaLabelPause) ?? '');
        }
        this.videos.forEach(video => {
          if (isPaused) {
            video.pause();
            return;
          }
          if (video.offsetParent === null) return;
          video.play().catch(() => {});
        });
      };
      static define = () => {
        if (!customElements.get('component-video-toggle')) {
          customElements.define('component-video-toggle', ComponentVideoToggle);
        }
      };
    }
    var componentVideoToggle = () => {
      ComponentVideoToggle.define();
    };

    var componentVideoToggle$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        default: componentVideoToggle
    });

})();
